export const baData = {
    "locale": {
        "home_instavc_build": "সংস্থা এবং কর্মচারীদের মধ্যে অর্থবহ সম্পর্ক তৈরি করুন",
        "home_instavc_conference_platform": "একটি তুলনামূলক ব্যবহারকারীর অভিজ্ঞতা সহ সম্মেলন প্ল্যাটফর্মগুলি",
        "home_instavc_start_conference": "কনফারেন্স শুরু করুন | কনফারেন্স যোগ দিন | INSTA কনফারেন্স",
        "home_instavc_Hippa": "HIPAA ELIGIBLE AND PCI DSS, SOC, ISO/EIC 27001, ISO/EIC 27017, ISO/EIC 27018, AND ISO 9001 COMPLIANT.",
        "home_instavc_copyrights": "© 2018 · ইনস্টা ভিসি · পিপললিংক ইউনিফাইড  প্রাইভেট লিমিটেড",
        "home_instavc_terms_agree": "আমি একমত",
        "home_instavc_terms": "শর্তাবলী",
        "instavc_login": "প্রবেশ করুন",
        "instavc_login_ইমেইল": "ইমেইল",
        "instavc_login_password": "পাসওয়ার্ড",
        "instavc_login_button": "প্রবেশ করুন",
        "instavc_login_forgotpassword": "পাসওয়ার্ড ভুলে গেছেন ?",
        "instavc_login_have_account": "কোন অ্যাকাউন্ট নেই?",
        "instavc_login_signup": "নিবন্ধন করুন",
        "instavc_signup": "নিবন্ধন করুন",
        "instavc_signup_firstname": "নামের প্রথম অংশ",
        "instavc_signup_lastname": "নামের শেষাংশ",
        "instavc_signup_ইমেইল": "ইমেইল",
        "instavc_signup_password": "পাসওয়ার্ড",
        "instavc_signup_cpassword": "পাসওয়ার্ড নিশ্চিত করুন",
        "instavc_signup_button": "নিবন্ধন করুন",
        "instavc_signup_already_have_account": "ইতিমধ্যে একটি সদস্যপদ আছে?",
        "instavc_signup_login": "প্রবেশ করুন",
        "instavc_signup_fname_error": "প্রথম নামটি কেবল বর্ণমালা হওয়া উচিত",
        "instavc_signup_lname_error": "শেষ নামটি কেবল বর্ণমালা হওয়া উচিত",
        "instavc_signup_ইমেইল_error": "ইমেলটি সঠিক সেটিংস হওয়া উচিত",
        "instavc_signup_password_error": "পাসওয়ার্ড ছয় অক্ষর দীর্ঘ এবং একটি বড় হাতের অক্ষর, একটি ছোট হাতের অক্ষর, একটি সংখ্যা এবং একটি বিশেষ অক্ষর সমন্বয় করা উচিত ",
        "instavc_signup_cpassword_error": "নিশ্চিত করুন যে পাসওয়ার্ডের সাথে উপরের পাসওয়ার্ডটি মিলবে",
        "instavc_forgotpassword_link": "আমরা আপনাকে আপনার নিবন্ধিত ইমেলের একটি লিঙ্ক প্রেরণ করব। কেবল লিঙ্কটি ক্লিক করুন এবং আপনার নতুন পাসওয়ার্ড সেট করুন",
        "instavc_forgotpassword_ইমেইল": "আপনার নিবন্ধিত ইমেল ঠিকানা লিখুন",
        "instavc_forgotpassword": "পাসওয়ার্ড ভুলে গেছেন",
        "instavc_forgotpassword_button": "পাসওয়ার্ড ভুলে গেছেন",
        "instavc_confirmpass_heading": "ফর্মটি পূরণ করে একটি নতুন পাসওয়ার্ড তৈরি করুন।",
        "instavc_confirmpass_verificationcode": "আপনার যাচাইকরণ সংকেতটি প্রবেশ করান",
        "instavc_confirmpass_newpassword": "নতুন পাসওয়ার্ড লিখুন",
        "instavc_confirmpass_retypepassword": "নতুন পাসওয়ার্ড আবার টাইপ করুন",
        "instavc_confirmpass_button": "নতুন পাসওয়ার্ড তৈরি করুন",
        "instavc_forgotpassword_signin": "সাইন ইন করুন",
        "instavc_forgotpassword_passwordcreated": "অভিনন্দন! আপনার নতুন পাসওয়ার্ড তৈরি করা হয়েছে, আপনি এখন ইন্সটা ভিসিতে সাইন ইন করতে পারেন.",
        "instavc_dashboard": "ড্যাশবোর্ড",
        "instavc_dashboard_schedule": "সাক্ষাতের সময়তালিকা ",
        "instavc_dashboard_meetinglist": "অতীত সাক্ষাৎ",
        "instavc_dashboard_conferenceplatform": "একটি তুলনামূলক ব্যবহারকারীর অভিজ্ঞতা সহ সম্মেলন প্ল্যাটফর্মগুলি",
        "instavc_dashboard_SC_room": "সম্মেলন শুরু করুন",
        "instavc_dashboard_SC_roomlist": "আপনার নির্ধারিত সভাটি নির্বাচন করে",
        "instavc_dashboard_startconference": "সম্মেলন শুরু করুন",
        "instavc_dashboard_JC": "সম্মেলনে যোগ দিন",
        "instavc_dashboard_JC_ID": "সম্মেলন পরিচয় বা সম্মেলনের মাধ্যমে",
        "instavc_dashboard_JC_button": "কনফারেন্স যোগ দিন",
        "instavc_dashboard_SC": "সম্মেলন শুরু করুন",
        "instavc_dashboard_SC_p2p": "আপনার তালিকা থেকে একটি রুম নির্বাচন করে",
        "instavc_dashboard_instaconference": "ইনস্টা কনফারেন্স",
        "instavc_dashboard_buynow": "এখন ক্রয় করুন",
        "instavc_dashboard_myprofile": "আমার পরিলেখ ",
        "instavc_dashboard_settings": "সেটিংস",
        "instavc_dashboard_myadmin": "আমার অ্যাডমিন",
        "instavc_dashboard_affiliate": "আমার অনুমোদিত",
        "instavc_dashboard_logout": "প্রস্থান",
        "conference_myrooms": "আমার রুম",
        "conference_myrooms_host": "নিমন্ত্রণকর্তা",
        "conference_myrooms_roomhost": "আপনি এই ঘরের জন্য একটি নিমন্ত্রণকর্তা।",
        "conference_myrooms_search": "অনুসন্ধান করুন ...",
        "conference_myrooms_hostuser": "নিমন্ত্রণকর্তা ব্যবহারকারী",
        "conference_myrooms_gotopremium": "অধিহার যেতে",
        "conference_myrooms_buynow": "এখন ক্রয় করুন",
        "conference_myrooms_renewal": "নবীকরণ",
        "conference_setup": "সেটিংস",
        "conference_myrooms_renewnow": "এখনই পুনর্নবীকরণ করুন",
        // "conference_myrooms_hosts": "নিমন্ত্রণকর্তা",
        "conference_myrooms_join": "প্রবেশ করুন",
        "conference_myrooms_setup": "রুম সেটিংস",
        "conference_myrooms_sethost_ইমেইল": "নিজেকে নিমন্ত্রণকর্তা হিসাবে সেটিংস করুন, বা কোনও নিমন্ত্রণকর্তা হিসাবে তাকে তৈরি করতে কোনও ব্যবহারকারীর ইমেল ঠিকানা প্রবেশ করুন।",
        "conference_myrooms_selfhost": "নিজেকে নিমন্ত্রণকর্তা হিসাবে সেটিংস করুন",
        "conference_myrooms_otherhost": "বা - আপনি যদি কোনও ব্যবহারকারীকে নিমন্ত্রণকর্তা হিসাবে তৈরি করতে চান তবে তার ইমেল ঠিকানা লিখুন।",
        "conference_myrooms_ইমেইল": "ইমেল ঠিকানা",
        "Cancel": "বাতিল",
        "conference_myrooms_apply": "আবেদন করুন",
        "view_schedule_myrooms": "আমার রুম",
        "view_schedule_search": "অনুসন্ধান করুন ...",
        "view_schedule_schedule": "সময়তালিকা",
        "view_schedule_calender": "এই ঘরের সময়সূচী যাচাই করার জন্য ক্যালেন্ডার নীচে দেওয়া হয়েছে",
        "video_recordings": "ভিডিও রেকর্ডিং",
        "view_recordings_search": "অনুসন্ধান",
        "view_recordings_month": "এই মাস",
        "view_recordings_week": "শেষ 7 দিন",
        "view_recordings_today": "আজ",
        "no_recordings": "এখনও কোনও রেকর্ডিং নেই!",
        "no_recordings_message": "এখনই এখানে কোনও ভিডিও নেই।",
        "no_recordings_startmessage": "একবার আপনি রেকর্ডিং শুরু করলে আপনি এখানে আপনার সমস্ত ভিডিও দেখতে পারবেন।",
        "stop_recording": "আপনি কি এই রেকর্ডিং বন্ধ করতে চান?",
        "stop_recording_agree": "সম্মতি",
        "stop_recording_disagree": "অসম্মতি",
        "conference_in_use": "সম্মেলন ব্যবহৃত হয়",
        "conference_mode" : "সম্মেলন প্রকার",
        "large_conference_mode" : "বৃহত সম্মেলন ধরন",
        "conference_setup_configuration": "বহিরবয়ব",
        "conference_setup_generateid": "কোনও মিটিং আইড পাওয়া যায় নি, একটি উত্পন্ন করুন!",
        "conference_setup_regenerate": "পুনরূত্পাদিত",
        "conference_setup_meetingid": "মিটিং আইডি",
        "conference_setup_camera": "ফেসটাইম এইচ ডি ক্যামেরা",
        "conference_setup_defaultmicrophone": "ডিফল্ট - অভ্যন্তরীণ মাইক্রোফোন (অন্তর্নির্মিত)",
        "conference_setup_microphone": "অভ্যন্তরীণ মাইক্রোফোন (অন্তর্নির্মিত)",
        "conference_setup_volume": "স্বরের প্রাবল্য",
        "conference_setup_videomode": "চলচিত্র রূপ",
        "conference_setup_forward": "সামনের দিকে",
        "conference_setup_mix": "মিশ্রিত",
        "conference_setup_invite": "আমন্ত্রণ করা",
        "conference_setup_invitepeople": "অধিবাসিগণ নিমন্ত্রণ",
        "conference_setup_invitefriends": "আপনার বন্ধুদের এবং সহকর্মীদের সহযোগিতা করার জন্য আমন্ত্রণ জানান.",
        "conference_setup_invite_directlink": "আপনার ঘরে সরাসরি সংযোগ",
        "conference_setup_invite_sharelink": "আপনার অধিবেশনে যোগদানের জন্য আপনার অংশগ্রহণকারীদের সাথে এই সংযোগ ভাগ করুন",
        "conference_setup_invite_link": "https://connect.instavc.com/conference-guest/eddca0fc7adcdc61a24dabe02597412a36bb96dac7302f3cedb6aac50169d58614eb46b940b556a9/f",
        "conference_setup_invitebyইমেইল": "ইমেল করে আমন্ত্রণ করুন",
        "conference_setup_invite_enterইমেইল": "আপনার অংশগ্রহণকারীদের আমন্ত্রণ জানাতে পছন্দসই ইমেল ঠিকানা লিখুন",
        "conference_setup_invite_ইমেইলid": "ইমেল ঠিকানা",
        "conference_setup_invite_close": "সমাপ্ত করা",
        "conference_setup_invite_button": "আমন্ত্রণ করা",
        "conference_setup_advancesettings": "অগ্রিম সেটিংস",
        "conference_setup_changeresolution": "রেজোলিউশন পরিবর্তন",
        "conference_setup_lowbandwidth": "দুর্বল ইন্টারনেট সংযোগ",
        "conference_setup_poornetwork": "মন্দ নেটওয়ার্ক",
        "conference_setup_vga": "VGA- (640x480)",
        "conference_setup_vga_graphics": "ভিডিও গ্রাফিক্স অ্যারে (ভিজিএ) ভিডিও রেজোলিউশনের জন্য",
        "conference_setup_hd1080": "HD1080p - (1920x1080)",
        "conference_setup_fhd": "সম্পূর্ণ হাই ডেফিনিশন (এফ এইচ ডি) ভিডিও রেজোলিউশনের জন্য",
        "conference_setup_4k": "4K - (3840 x 2160)",
        "conference_setup_4k_fhd": "ফুল হাই ডেফিনিশন (এফ এইচ ডি) ভিডিও রেজোলিউশনের জন্য",
        "conference_setup_sif": "SIF - (320x240)",
        "conference_setup_sif_vr": " SIF ভিডিও রেজোলিউশনের জন্য",
        "conference_setup_hd720": "HD720p - (1280x720)",
        "conference_setup_hd720_vr": "উচ্চ সংজ্ঞা (এইচডি) ভিডিও রেজোলিউশনের জন্য",
        "conference_setup_2k": "2K - (2048×1080)",
        "conference_setup_2k_fhd": "ফুল হাই ডেফিনিশন (এফএইচডি) ভিডিও রেজোলিউশনের জন্য",
        "conference_setup_broadcastoptions": "সম্প্রচারের বিকল্পগুলি",
        "conference_setup_enable": "সক্ষম করা",
        "conference_setup_disable": "অক্ষম করা",
        "conference_setup_reportquality": "স্বর এবং ভিডিও কলগুলি উন্নত করতে সহায়তা করার জন্য মানের পরিসংখ্যানের প্রতিবেদন করুন",
        "conference_setup_havetroubleshoot": "আপনি কি কনফারেন্স ট্রাবলশুট করতে চান, তবে এখানে লিঙ্কটি ক্লিক করুন ",
        "conference_setup_conferencetroubleshoot": "কনফারেন্স ট্রাবলশুটর",
        "conference_troubleshoot": "ট্রাবলশুট",
        "conference_troubleshoot_faq": "প্রায়শই জিজ্ঞাসিত প্রশ্নাবলী",
        "conference_troubleshoot_ইমেইলreport": "ইমেল প্রতিবেদন ",
        "conference_troubleshoot_gotoconference": "কনফারেন্সে যান",
        "conference_troubleshoot_os": "অপারেটিং সিস্টেম",
        "conference_troubleshoot_version": "সংস্করণ",
        "conference_troubleshoot_browser": "ব্রাউজার",
        "conference_troubleshoot_chromeversion": "ক্রোম সংস্করণ",
        "conference_troubleshoot_privatebrowsing": "ব্যক্তিগত ব্রাউজিং",
        "conference_troubleshoot_displayresolution": "রেজোলিউশন প্রদর্শন করুন",
        "conference_troubleshoot_aspectratio": "দিক অনুপাত প্রদর্শন করুন",
        "conference_troubleshoot_hasspeakers": "সিস্টেমের বক্তা আছে?",
        "conference_troubleshoot_foundspeaker": "বক্তার ডিভাইস পাওয়া গেছে",
        "conference_troubleshoot_hasmicrophone": "মাইক্রোফোনটিতে সিস্টেম আছে?",
        "conference_troubleshoot_foundmicrophone": "মাইক্রোফোন ডিভাইস পাওয়া গেছে",
        "conference_troubleshoot_haswebcam": "সিস্টেমে ওয়েবক্যাম আছে?",
        "conference_troubleshoot_foundcameras": "ক্যামেরা ডিভাইস পাওয়া গেছে",
        "conference_troubleshoot_webcampermission": "ওয়েবসাইটে ওয়েব ক্যামের অনুমতি আছে?",
        "conference_troubleshoot_microphonepermission": "ওয়েবসাইটটিতে মাইক্রোফোনের অনুমতি রয়েছে?",
        "conference_troubleshoot_getUsermedia": "ব্রাউজার এই পৃষ্ঠায় ব্যবহারকারী মিডিয়া পেতে অনুমতি দেয়?",
        "conference_troubleshoot_changeoutput_audiodevice": "আপনি কি আউটপুট অডিও ডিভাইসগুলি পরিবর্তন করতে পারেন?",
        "conference_troubleshoot_changecamera_resolution": "আপনি নতুন সম্মেলনের অনুরোধ না করে ক্যামেরা রেজোলিউশনগুলি পরিবর্তন করতে পারেন?",
        "conference_troubleshoot_supportwebrtc": "ব্রাউজার ওয়েবআরটিসি সমর্থন করে (1.0 বা 1.1 হয়)?",
        "conference_troubleshoot_supportortc": "ব্রাউজারটি ওআরটিসি সমর্থন করে (ওয়েবআরটিসি 1.1)?",
        "conference_troubleshoot_turnserver": "টার্ন সার্ভারটি কি পুনরুদ্ধারযোগ্য?",
        "conference_troubleshoot_turn": "চালু:139.59.64.172:443",
        "conference_troubleshoo_coturn" : "চালু: coturn.instavc.com: 443",
        "conference_troubleshoot_replacetracks": "সহকর্মীরা সঙ্গে আলোচনা না করে আপনি কি ট্র্যাকগুলি প্রতিস্থাপন করতে পারেন?",
        "conference_troubleshoot_record_remoteaudio": "আপনার ব্রাউজারটি দূরবর্তী অডিও রেকর্ড করতে পারে বা ওয়েব অডিও API তে দূরবর্তী অডিও স্ট্রিম প্রক্রিয়া করতে পারে",
        "conference_troubleshoot_browsersupports_websocketapi": "ব্রাউজারগুলি ওয়েবসকেটকে সমর্থন করে API",
        "conference_troubleshoot_blockwebsocket": "আপনার সিস্টেম অবরুদ্ধ ওয়েবসকেট প্রোটোকল, বা ওয়েবসকেট সার্ভার অ্যাক্সেসযোগ্য নয়? না",
        "conference_troubleshoot_supportwebaudioapi": "ব্রাউজার ওয়েব অডিওকে সমর্থন করে API ?",
        "conference_troubleshoot_supportsctp": "ব্রাউজার এস সি টি পি ডেটা চ্যানেলগুলিকে সমর্থন করে?",
        "conference_troubleshoot_supportsrtp": "ব্রাউজার আর টি পি ডেটা চ্যানেল সমর্থন করে?",
        "conference_troubleshoot_support_screencapturing": "এই পৃষ্ঠাটি স্ক্রিন ক্যাপচারিং এপিআই সমর্থন করে?",
        "conference_troubleshoot_support_multimonitor": "ব্রাউজারটি মাল্টি-মনিটর নির্বাচন সমর্থন করে",
        "conference_troubleshoot_mobiledevice": "এটি একটি মোবাইল ডিভাইস?",
        "conference_troubleshoot_supportscreencap_canvas": "ব্রাউজার কি ক্যানভাস থেকে স্ক্রিন ক্যাপচার সমর্থন করে?",
        "conference_troubleshoot_supportscreencap_video": "ব্রাউজার ভিডিও থেকে স্ক্রিন ক্যাপচার সমর্থন করে?",
        "conference_troubleshoot_supportpromisses": "ব্রাউজার প্রতিশ্রুতি সমর্থন করে?",
        "conference_troubleshoot_ipঠিকানা": "আই পি ঠিকানাগুলি দেখানোর জন্য ক্লিক করুন",
        "conference_troubleshoot_stunserver": "স্টান সার্ভারটি কি পুনঃপঠনযোগ্য?",
        "cancel": "বাতিল",
        "instavc_conference_revoke_fromhost" : "নিমন্ত্রণকর্তা থেকে প্রত্যাহার করুন",
        "instavc_conference_startvideoconf_button": "ভিডিও কনফারেন্স শুরু করুন",
        "instavc_conference_loading": "আপনার স্ক্রীনটি লোড হচ্ছে দয়া করে অপেক্ষা করুন",
        "instavc_conference_authenticating": "ইন্সটা ভিসি সার্ভারে প্রমাণীকরণ করা হচ্ছে ....",
        "instavc_conference_joinconference": "সম্মেলনে যোগদান",
        "instavc_conference_publishyourvideo": "আপনার ভিডিও প্রকাশ করা হচ্ছে",
        "instavc_conference_publishyouraudio": "আপনার অডিও প্রকাশ করা হচ্ছে",
        "instavc_conference_settings": "সেটিংস",
        "instavc_conference_setting": "সম্মেলন সেটিংস",
        "instavc_conference_setting_source": "উৎস",
        "instavc_conference_setting_camera": "ক্যামেরা",
        "instavc_conference_audioinputs": "শ্রুতি ইনপুট",
        "instavc_conference_setting_apply": "প্রয়োগ করা",
        "instavc_conference_setting_resolution": "রেজোলিউশন",
        "instavc_conference_setting_qr": "কিউ আর (বিটা)",
        "instavc_conference_whiteboard": "হোয়াইটবোর্ড",
        "instavc_conference_screenshare": "স্ক্রিন শেয়ার",
        "instavc_conference_presenter": "উপস্থাপক",
        "instavc_conference_stopshare": "শেয়ার বন্ধ করুন",
        "instavc_conf_install_Screenshare" : "স্ক্রিন শেয়ার ইনস্টল করুন",
        "instavc_conference_videosync": "একসাথে দেখুন",
        "instavc_conference_videourl": "ভিডিও ইউ-আর-এল",
        "instavc_conference_enter_videourl": "ভিডিও ইউ-আর-এল প্রবেশ করান",
        "instavc_conference_videourl_note": "দ্রষ্টব্য: কেবল সক্রিয় অংশগ্রহণকারীরা এই ভিডিওটি দেখতে পারবেন, দেরিতে যোগদানকারীরা ভিডিওটি দেখতে পারবেন না",
        "instavc_conf_recordings" : "রেকর্ডিং",
        "instavc_conference_sharecontent": "আপনার স্ক্রিন ভাগ করুন",
        "instavc_conference_sharecontent_screen": "সংযুক্ত.instavc.com আপনার পর্দার সামগ্রী ভাগ করতে চায় share আপনি যা ভাগ করতে চান তা চয়ন করুন",
        "instavc_conference_shareentire_screen": "আপনার পুরো পর্দা",
        "instavc_conference_sharescreen_applicationwindow": "অ্যাপ্লিকেশন উইন্ডো",
        "instavc_conference_sharescreen_chrometab": "ক্রোম ট্যাব",
        "instavc_conference_sharescreen_share": "অংশ",
        "instavc_conf_sharescreen":"আপনি আপনার পর্দা ভাগ করছেন!",
        "instavc_conf_share_otherparticipants": "অন্যান্য অংশগ্রহণকারীরা আপনার স্ক্রিনে অ্যাপ্লিকেশন এবং ডকুমেন্টেশন দেখতে পাবে",
        "instavc_stopsharing" : "ভাগ করা বন্ধ কর",
        "instavc_conference_chat": "চ্যাট",
        "instavc_conference_additional_camera": "অতিরিক্ত ক্যামেরা",
        "instavc_conference_sharescreen_groupchat": "গোষ্ঠী চ্যাট",
        "instavc_conference_sharescreen_GC": "জিসি",
        "instavc_conference_entermessage": "কিছু বল!",
        "instavc_conference_adddevice": "ডিভাইস যুক্ত করুন",
        "instavc_conference_adddevice_addcamera": "ক্যামেরা যুক্ত করুন",
        "instavc_conference_adddevice_source": "উৎস",
        "instavc_conference_adddevice_camera": "ক্যামেরা",
        "instavc_conference_adddevice_cameraname": "ফেসটাইম এইচ ডি ক্যামেরা",
        "instavc_conference_adddevice_close": "সমাপ্ত",
        "instavc_conference_adddevice_publish": "প্রকাশ",
        "instavc_conference_info": "তথ্য",
        "questions": "প্রশ্নাবলি",
        "instavc_conference_askquestions": "প্রশ্ন কর",
        "instavc_conference_info_meetingid": "ব্যক্তিগত সভা আইডি",
        "instavc_conference_fullscreen": "পূর্ণ পর্দা",
        "conference_setup_invitepeoplel": "লোকেদের নিমন্ত্রণ",
        "conference_setup_invite_linktojoin": "https://connect.instavc.com/conference-guest/93ac2135d88727ca29061b4b6bf9477bc8f285a8121ff580649512abad353fbc6751a134d56438f7/f",
        "conference_setup_invite_byইমেইল": "মেল করে আমন্ত্রণ করুন",
        "instavc_conference_participants": "অংশগ্রহণকারীরা",
        "instavc_conference_participants_search": "অনুসন্ধান করুন ...",
        "instavc_conference_participant": "অংশগ্রহণকারী",
        "instavc_conference_participants_muteall": "সবাই নিশ্চুপ",
        "instavc_conference_participants_unmuteall": "সকলকে নিঃশব্দ করুন",
        "instavc_conference": "সম্মেলন",
        "instavc_conf_more": "অধিক",
        "instavc_conference_picturemode": "এই ভিডিও টি পিকচার-ইন-ছবি মোডে প্লে হচ্ছে",
        "instavc_conference_mediastreams_stats": "মিডিয়া স্ট্রিমের পরিসংখ্যান",
        "instavc_conference_mediastreams_audio": "শ্রুতি",
        "instavc_conference_mediastreams_audio_send": "পাঠান",
        "instavc_conference_mediastreams_audio_codec": "কোডেক",
        "instavc_conference_mediastreams_audio_rates": "হার (Kbps)",
        "instavc_conference_mediastreams_audio_lost": "নিখোঁজ",
        "instavc_conference_mediastreams_audio_fraction": "ভগ্নাংশ",
        "instavc_conference_mediastreams_video": "ভিডিও",
        "instavc_conference_mediastreams_video_send": "পাঠান",
        "instavc_conference_mediastreams_video_codec": "কোডেক",
        "instavc_conference_mediastreams_video_rates": "হার (Kbps)",
        "instavc_conference_mediastreams_video_lost": "নিখোঁজ",
        "instavc_conference_mediastreams_video_fraction": "ভগ্নাংশ",
        "instavc_conference_resolution": "সমাধান",
        "instavc_conference_framerate": "ফ্রেম হার",
        "instavc_conference_nack": "বস্তু",
        "instavc_conference_pli": "পি এল আই",
        "instavc_conference_bw": "উপলব্ধ বি.ডব্লু",
        "instavc_conference_audiomuted": "অডিও নিঃশব্দ করা হয়েছে",
        "instavc_conference_microphonemuted": "আপনার মাইক্রোফোন নিঃশব্দ হয়েছে",
        "join_conference_join_meetinginvitation": "সভার আমন্ত্রণগুলিতে যোগদান করুন",
        "join_conference_search": "অনুসন্ধান করুন ...",
        "join_conference_meeting details": "বৈঠকের নাম \ n আমন্ত্রিত: \ n নিমন্ত্রকের নাম",
        "join_conference_join": "যোগদান করা",
        "join_conference_nomeetings": "কোন সভা নেই",
        "join_conference_noupcomingmeetings": "ওহো! আপনার এখনও কোনও আসন্ন সভা নেই!",
        "insta_conference_mycontacts": "আমার যোগাযোগ",
        "insta_conference_search": "অনুসন্ধান করুন ...",
        "insta_conference_typemessage": "একটি বার্তা টাইপ করুন",
        "insta_conference_addcontact": "পরিচিতি যোগ করুন",
        "insta_conference_enterইমেইল": "মেল আইডি প্রবেশ করান",
        "insta_conference_add": "যোগ",
        "insta_conference_nouserfound": "এই ইমেল ঠিকানার সাথে এই জাতীয় কোনও ব্যবহারকারী পাওয়া যায় নি",
        "instavc_conf_callnot_allowed" : "আপনি ইতিমধ্যে কল এলে আপনি অন্য ব্যবহারকারীদের কল করতে পারবেন না",
        "insta_conference_pendingapproval": "অনুমোদন অপেক্ষারত",
        "insta_conference_outgoingvideocall": "বহির্গামী ভিডিও কল",
        "insta_conference_calling": "কলিং ....",
        "insta_conference_incomingvideocall": "ইনকামিং ভিডিও কল",
        "insta_conference_calldecline": "পতন",
        "insta_conference_callaccept": "গ্রহণ করা",
        "insta_conference_instavcalert": "connect.instavc.com অনুমতি দিতে চায়",
        "insta_conference_usemicrophone": "আপনার মাইক্রোফোন ব্যবহার করুন",
        "insta_conference_usecamera": "আপনার ক্যামেরা ব্যবহার করুন",
        "insta_conference_blockdevices": "বাধা",
        "insta_conference_allowdevices": "অনুমতি দিন",
        "instavc_schedulemeeting_createmeeting": "নতুন সভা / সম্পাদনা তৈরি করুন",
        "instavc_schedulewebinar_createmeeting": "নতুন ওয়েবিনার তৈরি / সম্পাদনা করুন",
        "instavc_schedulemeeting_meetingname": "আপনার বৈঠকে একটি নাম দিন",
        "instavc_schedulemeeting_selectnames_tomeeting": "আপনার সভার জন্য একটি ঘর নির্বাচন করুন",
        "instavc_schedulemeeting_setduration": "সময়কাল সেট করুন",
        "instavc_schedulemeeting_15min": "15 মিনিট",
        "instavc_schedulemeeting_30min": "30 মিনিট",
        "instavc_schedulemeeting_60min": "60 মিনিট",
        "instavc_schedulemeeting_setcustom": "রীতি সেট করুন",
        "instavc_schedulemeeting_customduration": "রীতি সময়কাল",
        "instavc_schedulemeeting_minutes": "মিনিট",
        "instavc_schedulemeeting_setconfpassword": "আপনার সম্মেলনের পাসওয়ার্ড সেট করুন",
        "instavc_schedulemeeting_typepassword": "আপনার সভার জন্য পাসওয়ার্ড টাইপ করুন",
        "instavc_schedulemeeting_conferencecolor": "আপনার সম্মেলন আইকন রঙ দিন",
        "instavc_schedulemeeting_invitepeople": "এই সভায় লোকদের আমন্ত্রণ জানান",
        "instavc_schedulemeeting_search": "অনুসন্ধান করুন ...",
        "instavc_schedulemeeting_SM": "SM",
        "instvc_SM_message" : "অনুমোদিত ব্যবহারকারী লাইসেন্স সহ ব্যবহারকারীর সংখ্যা লাইসেন্সের সীমা অতিক্রম করেছে। আপনি চাইলে আরও বেশি লোককে আমন্ত্রণ জানাতে পারেন",
        "instavc_SM_message_href" : "প্রিমিয়াম যেতে",
        "instavc_schedulemeeting_notify": "নির্বাচিত লোকদের এই সভা সম্পর্কে অবহিত করুন",
        "instavc_schedulemeeting_addreminder": "অনুস্মারক যুক্ত করুন",
        "instavc_schedulemeeting_add": "যোগ",
        "instavc_schedulemeeting_addmeetingreminder": "মিটিংয়ের অনুস্মারক যুক্ত করুন",
        "instavc_schedulemeeting_adddatetime": "তারিখ বাছাইকারী, সময় বাছাইকারী",
        "instavc_schedulemeeting_apply": "প্রযোজ্য",
        "instavc_schedulemeeting_name": "সভার নাম লিখুন",
        "instavc_schedulemeeting_selectroom": "দয়া করে ঘরটি নির্বাচন করুন",
        "instavc_schedulemeeting_selectduration": "সময়কাল নির্বাচন করুন",
        "instavc_recuring_schedule" : "পুনরাবৃত্তির সময়সূচী",
        "instavc_schedulemeeting_nothinginreminders": "অনুস্মারকগুলিতে কিছুই নেই",
        "instavc_schedulemeeting_createbutton": "সৃষ্টি",
        "instavc_schedulemeeting_createdsuccessfully": "সময়তালিকা সফলভাবে তৈরি করা হয়েছে",
        "instavc_meetinglist_calender": "ক্যালেন্ডার",
        "instavc_meetinglist_selecteddates": "আপনার নির্বাচিত তারিখগুলি",
        "instavc_meetinglist_schedulecreted": "সূচী তৈরি হয়েছে",
        "instavc_meetinglist_pastschedule": "অতীত সময়সূচী",
        "instavc_meetinglist": "সভাগুলির তালিকা",
        "instavc_meetinglist_meetingdetils": "সভার নাম, সভার সময়, সংগঠিত দ্বারা",
        "instavc_meetinglist_search": "অনুসন্ধান করুন ...",
        "instavc_meetinglist_deleterecuring": "পুনরাবৃত্তির সময়সূচি মুছুন ",
        "instavc_meetinglist_alow_deleterecuring": "আপনি কি কেবল বর্তমান সময়সূচি, বা পুনরাবৃত্তির সমস্ত সময়সূচি মুছতে চান?",
        "instavc_meetinglist_schedule_series": "সিরিজের অন্যান্য সমস্ত সময়সূচি থাকবে:",
        "instavc_meetinglist_schedule_seriesdelete": "সিরিজের সমস্ত সূচি মুছে ফেলা হবে:",
        "instavc_meetinglist_allrecuringsch": "সমস্ত পুনরাবৃত্তির তালিকা",
        "instavc_meetinglist_cancelchanges": "পরিবর্তনগুলি বাতিল করুন",
        "instavc_meetinglist_noschedules": "কোনও তালিকা নেই",
        "instavc_ml_schedulemessage" : "এখনও কোন মিটিংয়ের সময়সূচী তৈরি হয়নি! । n নীচের বোতামটিতে ক্লিক করে আপনার সময়সূচী তৈরি করুন।",
        "instavc_create_schedule" : "সময়সূচি তৈরি করুন",
        "instavc_meetinglist_currentschedule": "বর্তমান সময়সূচী",
        "instavc_meetinglist_join": "সংযুক্ত হওয়া",
        "instavc_meetinglist_buynow": "এখন কেন",
        "instavc_dashboard_chooseplan": "একটি পরিকল্পনা চয়ন করুন",
        "instavc_package_smbplan": "এসএমবি পরিকল্পনা",
        "instavc_package_smbplan_host": "(নিমন্ত্রণকর্তা ভিত্তিক করে লাইসেন্স)",
        "instavc_package_smbplandescription": "একটি ঘরে একবারে মাত্র 1 জন নিমন্ত্রণকর্তা থাকতে পারে। একজন ক্রেতা নিমন্ত্রণকর্তা অ্যাকাউন্ট সেট করতে বা পরিবর্তন করতে পারে, কে ঘরটি নিয়ন্ত্রণ করতে পারে। কলের সময় নিমন্ত্রণকর্তা অ্যাক্সেসগুলি ভাগ করা যায় না। নিমন্ত্রণকর্তা সম্মেলনে যোগদান না করা পর্যন্ত অন্যান্য সমস্ত ব্যবহারকারী ইন্টারঅ্যাক্ট করতে পারবেন না।",
        "instavc_package_basic": "মৌলিক",
        "instavc_package_hostuser_smb": "1 নিমন্ত্রণকর্তা এবং",
        "instavc_package_hostuser_smb_users": "ব্যবহারকারীরা",
        "instavc_package_currency": "INR",
        "instavc_package_permonth": "/ মাস",
        "instavc_package_bill_smb": "বার্ষিক বিল",
        "instavc_package_include_smb": "এই প্যাকেজটি সহ অন্তর্ভুক্ত",
        "instavc_package_specifictions_Whiteboard": "হোয়াইটবোর্ড",
        "instavc_package_specifictions_Screen": "স্ক্রিন শেয়ার",
        "instavc_package_specifictions_nChat": "চ্যাট",
        "instavc_package_specifictions_Recording": "রেকর্ডিং",
        "instavc_package_specifictions_PresenterMode": "উপস্থাপক মোড",
        "instavc_package_buynowbutton": "এখন কেন",
        "instavc_package_fullfeatures_smb": "সম্পূর্ণ বৈশিষ্ট্য",
        "instavc_package_billinginfo": "বিল সংক্রান্ত তথ্য",
        "instavc_package_billinginfo_name": "নাম",
        "instavc_package_billinginfo_orginazation": "সংগঠন",
        "instavc_package_biilinginfo_gstin": "GSTIN",
        "Save": "সংরক্ষণ",
        "instavc_package_billinginfo_edit": "সম্পাদনা",
        "instavc_package_billingdetails": "পূর্ণ রূপ প্রকাশ",
        "instavc_package_billingdetails_firstname": "নামের প্রথম অংশ",
        "instavc_package_billingdetails_lastname": "নামের শেষাংশ",
        "instavc_package_billingdetails_ঠিকানা": "ঠিকানা",
        "instavc_package_billingdetails_zip": "জিপ কোড",
        "instavc_package_shippinginfo": "হস্তান্তর তথ্য",
        "instavc_package_shippinginfo_edit": "সম্পাদনা",
        "instavc_package_shippingdetails": "গ্রেপ্তার বিবরণ",
        "instavc_package_shippingdetails_firstname": "নামের প্রথম অংশ",
        "instavc_package_shippingdetails_lastname": "নামের শেষাংশ",
        "instavc_package_shippingdetails_ঠিকানা": "ঠিকানা",
        "instavc_package_shippingdetails_zip": "জিপ কোড",
        "instavc_package_cartsummary": "কার্টের সংক্ষিপ্তসার",
        "instavc_package_hostbase": "নিমন্ত্রণকর্তা ভিত্তিক লাইসেন্স (লাইসেন্সের নাম)",
        "instavc_package_smbplan_basic": "SMB পরিকল্পনা - বেসিক",
        "instavc_package_plandetails": "$ 144.02\n\nbilled for 1 year\n$ 13 per month",
        "instavc_package_term": "মেয়াদ",
        "instavc_package_1year": "1 বছর",
        "instavc_package_2years": "2 বছর",
        "instavc_package_3years": "3 বছর",
        "instavc_package_4years": "4 বছর",
        "instavc_package_5years": "5 বছর",
        "instavc_package_subtotal": "অঙ্কসমূহের মোট যোগফল",
        "instavc_package_taxes": "কর এবং ফি (জিএসটি + 18%)",
        "instavc_package_launchoffer": "অফার চালু করুন",
        "instavc_package_promo": "প্রচার সফলভাবে প্রয়োগ হয়েছে",
        "instavc_package_remove": "অপসারণ",
        "instavc_package_havepromocode": "একটি প্রচার কোড আছে? এখানে আবেদন করুন",
        "instavc_package_entercouponcode": "বৈধ কুপন কোড প্রবেশ করুন",
        "instavc_package_total": "মোট",
        "instavc_package_offerdisclaimer": "অফার অস্বীকৃতি দেখুন",
        "instavc_package_paynow": "এখন পরিশোধ করুন",
        "instavc_package_payment_instavclicense": "পিপললিংক ইউনিফাইড  প্রাইভেট লিমিটেড ইন্সটাভিসি লাইসেন্সের জন্য অর্থ প্রদান",
        "instavc_package_phone": "টেলিফোন",
        "instavc_package_entervalid_contactnumber": "বৈধ যোগাযোগ নম্বর প্রবেশ করুন",
        "instavc_package_ইমেইল": "ইমেইল",
        "instavc_package_enterইমেইল": "দয়া করে একটি বৈধ ইমেল আইডি লিখুন। উদাহরণ: you@example.com",
        "instavc_package_paybycard": "কার্ডের মাধ্যমে প্রদান করুন",
        "instavc_package_securedbyrazorpay": "রেজার পে দ্বারা সুরক্ষিত",
        "instavc_package_card": "কার্ড",
        "instavc_package_enterotp": "অ্যাক্সেস সেভ কার্ডগুলিতে XXXXXXXXXX এ পাঠানো ও টি পি প্রবেশ করান",
        "instavc_package_resendotp": "ও টি পি পুনরায় পাঠান",
        "instavc_package_skipsavedcards": " সংরক্ষিত কার্ডগুলি এড়িয়ে যান",
        "instavc_package_enter_otp": "দয়া করে ও টি পি প্রবেশ করুন",
        "instavc_package_skipthesavedcards": "সংরক্ষিত কার্ডগুলি এড়িয়ে যান",
        "instavc_package_cardnumber": "কার্ড নম্বর",
        "instavc_package_entervalid_cardnumber": "একটি বৈধ কার্ড নম্বর লিখুন দয়া করে",
        "instavc_package_expiry": "মেয়াদ-শেষ",
        "instavc_package_cardholdername": "কার্ডধারীদের নাম",
        "instavc_package_cvv": "CVV",
        "instavc_package_3digitcode": "এটি আপনার কার্ডের পিছনে একটি 3 ডিজিটের কোড মুদ্রিত",
        "instavc_package_pay": "ভাড়া",
        "instavc_package_remembercard": "কার্ড মনে রাখবেন",
        "instavc_package_medium": "মাঝারি",
        "instavc_package_hostuser_medium": "1 নিমন্ত্রণকর্তা এবং 50 জন ব্যবহারকারী",
        "instavc_package_month_medium": "$ 15 / মাস",
        "instavc_package_bill_medium": "বার্ষিক বিল + জিএসটি 18%",
        "instavc_package_include_medium": "এই প্যাকেজটি সহ অন্তর্ভুক্ত",
        "instavc_package_specifictions_medium": "হোয়াইটবোর্ড \ n স্ক্রিন ভাগ \ n চ্যাট \ n রেকর্ডিং \ n প্রেজেন্টার মোড",
        "instavc_package_buynow_medium": "এখন কেন",
        "instavc_package_fullfeatures_medium": "সম্পূর্ণ বৈশিষ্ট্য",
        "instavc_package_advanced": "অগ্রসর",
        "instavc_package_hostuser_advanced": "1 নিমন্ত্রণকর্তা এবং 100 জন ব্যবহারকারী",
        "instavc_package_month_advanced": "$ 16 / মাস",
        "instavc_package_bill_advanced": "বার্ষিক বিল + জিএসটি 18%",
        "instavc_package_include_advanced": "এই প্যাকেজটি সহ অন্তর্ভুক্ত",
        "instavc_package_specifictions_advanced": "হোয়াইটবোর্ড \ n স্ক্রিন শেয়ার \ n চ্যাট \ n রেকর্ডিং \ n প্রিজেটার মোড",
        "instavc_package_buynow_advanced": "এখন কেন",
        "instavc_package_fullfeatures_advanced": "সম্পূর্ণ বৈশিষ্ট্য",
        "instavc_package_virtualmcu": "ভার্চুয়াল এম সি ইউ লাইসেন্স",
        "instavc_package_virtualmcu_room": "(রুম ভিত্তিক লাইসেন্স)",
        "instavc_package_vmcudetails": "একটি ঘরে একবারে মাত্র 1 জন হোস্ট থাকতে পারে। একজন ক্রেতা হোস্ট অ্যাকাউন্ট সেট করতে বা পরিবর্তন করতে পারে, কে ঘরটি নিয়ন্ত্রণ করতে পারে। কলের সময় হোস্ট অ্যাক্সেসগুলি ভাগ করা যায় না। হোস্ট সম্মেলনে যোগদান না করা পর্যন্ত অন্যান্য সমস্ত ব্যবহারকারী ইন্টারঅ্যাক্ট করতে পারবেন না।",
        "instavc_package_instavc": "ইন্সটা ভিসি",
        "instavc_package_silver": "রৌপ্য ",
        "instavc_package_userrooms_silver_users": "ব্যবহারকারীরা",
        "instavc_package_userrooms_silver_rooms": "রুম",
        "instavc_package_month_silver": "$ 281 / মাস",
        "instavc_package_bill_silver": "বার্ষিক বিল + জিএসটি 18%",
        "instavc_package_include_silver": "এই প্যাকেজটি সহ অন্তর্ভুক্ত",
        "instavc_package_specifictions_silver": "হোয়াইটবোর্ড \ n স্ক্রিন ভাগ \ n চ্যাট \ n রেকর্ডিং \ n প্রেজেন্টার মোড",
        "instavc_package_buynow_silver": "এখন কেন",
        "instavc_package_fullfeatures_silver": "সম্পূর্ণ বৈশিষ্ট্য",
        "instavc_package_gold": "স্বর্ণ",
        "instavc_package_userrooms_gold": "200 ব্যবহারকারী - 30 রুম",
        "instavc_package_month_gold": "$ 467 / মাস",
        "instavc_package_bill_gold": "বার্ষিক বিল + জিএসটি 18%",
        "instavc_package_include_gold": "এই প্যাকেজটি সহ অন্তর্ভুক্ত",
        "instavc_package_specifictions_gold": "হোয়াইটবোর্ড \ n স্ক্রিন ভাগ \ n চ্যাট \ n রেকর্ডিং \ n প্রেজেন্টার মোড",
        "instavc_package_buynow_gold": "এখন কেন",
        "instavc_package_fullfeatures_gold": "সম্পূর্ণ বৈশিষ্ট্য",
        "instavc_package_platinum": "প্ল্যাটিনাম",
        "instavc_package_userrooms_platinum": "500 ব্যবহারকারী - 50 টি রুম",
        "instavc_package_month_platinum": "$ 933/ মাস",
        "instavc_package_bill_platinum": "বার্ষিক বিল + জিএসটি 18%",
        "instavc_package_include_platinum": "এই প্যাকেজ সহ অন্তর্ভুক্ত",
        "instavc_package_specifictions_platinum": "হোয়াইটবোর্ড \ n স্ক্রিন ভাগ \ n চ্যাট \ n রেকর্ডিং \ n প্রেজেন্টার মোড",
        "instavc_package_buynow_platinum": "এখন কেন",
        "instavc_package_fullfeatures_platinum": "সম্পূর্ণ বৈশিষ্ট্য",
        "instavc_package_legacybaselicense": "উত্তরাধিকার ভিত্তিক লাইসেন্স",
        "instavc_package_licensebased_ports": "পোর্ট সংখ্যা ভিত্তিক লাইসেন্স",
        "instavc_package_hardwareendpoint": "হার্ডওয়্যার এন্ডপয়েন্ট সহ ইন্সটাভিসি",
        "instavc_package_webrtcconf_legacysupport": "উত্তরাধিকার সমর্থনগুলির সাথে ওয়েব আর টি সি কনফারেন্সিং",
        "instavc_package_sip": "এস আই পি / বি এফ সি পি সমর্থন",
        "instavc_package_chh323": "ChH323 / H.239 সমর্থন",
        "instavc_package_contactus": "যোগাযোগ করুন",
        "instavc_myprofile_dashboard": "ড্যাশবোর্ড",
        "instavc_myprofile_settings": "সেটিংস",
        "instavc_myprofile": "আমার প্রোফাইল",
        "instavc_myprofile_personaldetail": "ব্যক্তিগত বিবরণ",
        "instavc_myprofile_personaldetails_name": "নাম",
        "instavc_myprofile_personaldetails_email": "ইমেইল",
        "instavc_myprofile_personaldetails_phoneno": "ফোন নম্বর",
        "instavc_myprofile_personaldetails_address": "ঠিকানা",
        "instavc_myprofile_personaldetails_city": "শহর",
        "instavc_myprofile_edit": "সম্পাদনা",
        "instavc_myprofile_personaldetails": "ব্যক্তিগত বিবরণ",
        "instavc_myprofile_firstname": "নামের প্রথম অংশ",
        "instavc_myprofile_lastname": "নামের শেষাংশ",
        "instavc_myprofile_ইমেইল": "ইমেইল",
        "instavc_myprofile_phoneno": "ফোন নম্বর",
        "instavc_myprofile_professionaldetails": "পেশাগত বিবরণ",
        "instavc_myprofile_position": "পদ",
        "instavc_myprofile_professionaldetails_ইমেইল": "ইমেইল",
        "instavc_myprofile_professionaldetails_phoneno": "ফোন নম্বর",
        "instavc_myprofile_professionaldetails_address": "ঠিকানা",
        "instavc_myprofile_professionaldetails_branch": "শাখা",
        "instavc_myprofile_professionaldetails_edit": "সম্পাদনা",
        "instavc_myprofile_officialdetails": "অফিসিয়াল বিবরণ",
        "instavc_myprofile_officialdetails_position": "পদ",
        "instavc_myprofile_officialdetails_email": "ইমেইল",
        "instavc_myprofile_officialdetails_phoneno": "ফোন নম্বর",
        "instavc_myprofile_officialdetails_branch": "শাখা",
        "instavc_myprofile_officialdetails_address": "ঠিকানা",
        "instavc_myprofile_contactinfo": "যোগাযোগের তথ্য",
        "instavc_myprofile_contactinformation": "যোগাযোগের তথ্য",
        "instavc_myprofile_add": "যুক্ত করা",
        "instavc_myprofile_contactinformation_ঠিকানা": "ঠিকানা",
        "instavc_myprofile_contactinformation_city": "শহর / ছোট শহর",
        "instavc_myprofile_contactinformation_zip": "জিপ কোড",
        "instavc_myprofile_contactinformation_landmark": "জমির চিহ্ন",
        "instavc_myprofile_address": "ঠিকানা",
        "instavc_myprofile_landmark": "জমির চিহ্ন",
        "instavc_myprofile_delete": "সতর্ক",
        "instavc_myprofile_deletealert": "আপনি কি এটিকে মুছতে চান?",
        "instavc_myprofile_disagree": "অসম্মতি",
        "instavc_myprofile_agree": "সম্মত হওয়া",
        "instavc_myprofile_websitelinks": "ওয়েবসাইট লিংক",
        "instavc_myprofile_website_add": "যুক্ত করা",
        "instavc_myprofile_website": "ওয়েবসাইট",
        "instavc_myprofile_websiteexample": "https://www.google.com",
        "instavc_myprofile_sociallinks": "সামাজিক বন্ধন",
        "instavc_myprofile_sociallinks_add": "যুক্ত করা",
        "instavc_myprofile_sociallink": "সামাজিক বন্ধন",
        "instavc_myprofile_sociallinks_example": "https://www.facebook.com/xxx",
        "instavc_myprofile_basicinfo": "মৌলিক তথ্য",
        "instavc_myprofile_basicinfo_add": "যুক্ত করা",
        "instavc_myprofile_basicinfo_dob": "জন্ম তারিখ",
        "instavc_myprofile_basicinfo_gender": "লিঙ্গ",
        "instavc_myprofile_basicinformation": "মৌলিক তথ্য",
        "instavc_myprofile_basicinformation_dob": "জন্ম তারিখ",
        "instavc_myprofile_basicinformation_gender": "লিঙ্গ",
        "instavc_myprofile_basicinformation_deletealert": "সতর্কতা \ n আপনি কি এটি মুছতে চান?",
        "instavc_myprofile_basicinformation_disagree": "অসম্মতি",
        "instavc_myprofile_basicinformation_agree": "সম্মত হন",
        "instavc_myprofile_uploadnewavatar": "নতুন অবতার আপলোড করুন",
        "instavc_myprofile_cropimage": "ফসল ইমেজ",
        "instavc_myprofile_locale": "স্থান",
        "instavc_myprofile_localesettings": "স্থানীয় সেটিংস",
        "instavc_myprofile_preferredlanguage": "পছন্দের ভাষা :",
        "instavc_myprofile_language": "ইংরেজি",
        "instavc_settings": "সেটিংস",
        "instavc_settings_changepassword": "পাসওয়ার্ড পরিবর্তন করুন",
        "instavc_settings_changepass": "পাসওয়ার্ড পরিবর্তন করুন",
        "instavc_settings_currentpassword": "বর্তমান পাসওয়ার্ড টাইপ করুন",
        "instavc_settings_newpassword": "নতুন পাসওয়ার্ড টাইপ করুন",
        "instavc_settings_enter_currentpassword": "বর্তমান পাসওয়ার্ড লিখুন দয়া করে",
        "instavc_settings_enter_newpassword": "নতুন পাসওয়ার্ড লিখুন দয়া করে",
        "instavc_settings_help": "সাহায্য",
        "instavc_settings_affiliate": "অধিভুক্ত হন",
        "instavc_settings_support": "সহায়তা কেন্দ্র",
        "instavc_settings_newticket": "একটি নতুন টিকিট খুলুন",
        "instavc_settings_ticketstatus": "টিকিট অবস্থা চেক করুন",
        "instavc_settings_troubleshoot": "ট্রাবলশুট",
        "instavc_legacy_dailout": "ডায়াল আউট",
        "instavc_legacy_stats" : "পরিসংখ্যান",
        "instavc_legacy_dail_in_detail" : "ডায়াল ইন বিশদ",
        "instavc_legacy_h323_endpoint" : "H.323 শেষ পয়েন্ট",
        "instavc_legacy_sip_endpoint" : "এস আই পি শেষ পয়েন্ট",
        "instavc_admin_users" : "ব্যবহারকারীরা",
        "instavc_admin_username" : "ব্যবহারকারীর নাম",
        "instavc_admin_user_accountstatus" : "অ্যাকাউন্টের স্থিতি",
        "instavc_admin_user_confirmed" : "নিশ্চিত",
        "instavc_admin_user_unconfirmed" : "অসমর্থিত",
        "instavc_admin_user_resetall" : "সব পুনরায় সেট করুন",
        "instavc_admin_user_sync" : "সুসংগত",
        "instavc_admin_user_status" : "অবস্থা",
        "instavc_admin_user_phonenumber" : "ফোন নম্বর",
        "instavc_admin_user_created" : "নির্মিত",
        "instavc_admin_user_all" : "সব",
        "instavc_admin_groups" : "দল",
        "instavc_admin_addmore" : "আরো যোগ করো",
        "instavc_admin_group_peoplelink" : "কুইন্স, গোলাইভ, পিপললিঙ্ক",
        "instavc_admin_select_plan" : "পরিকল্পনা নির্বাচন করুন",
        "instavc_admin_lastmodified" : "সর্বশেষ পরিবর্তিত",
        "instavc_admin_ইমেইল_verified" : "ইমেইল যাচাই",
        "instavc_admin_verified" : "যাচাই",
        "instavc_admin_Unverified" : "Unverified",
        "instavc_admin_licenses" : "Licenses",
        "instavc_admin_addlicense" : "লাইসেন্স যুক্ত করুন",
        "instavc_admin_defaultroom" : "ডিফল্ট রুম",
        "instavc_admin_hostlicense" : "নিমন্ত্রণকর্তা ভিত্তিক লাইসেন্স",
        "instavc_admin_roomlicense" : "রুম ভিত্তিক লাইসেন্স",
        "instavc_admin_virtualmcu" : "ভার্চুয়াল এম সি ইউ ভিত্তিক লাইসেন্স",
        "instavc_admin_enterprise" : "এন্টারপ্রাইজ লাইসেন্স",
        "instavc_mcuserver": "এমসিইউ সার্ভার",
        "instavc_mculink" : "https://awsmcu.instavc.com",
        "instavc_admin_expirydate" : "সমাপ্তির তারিখ",
        "instavc_admin_settings" : "প্রশাসন সেটিংস",
        "instavc_default_offer" : "সুপারিশ জন্য ডিফল্ট অফার",
        "instavc_enter_coupon_code" : "কুপন কোড প্রবেশ করান",
        "instavc_current_partshare" : "বর্তমান অংশীদার ভাগ",
        "instavc_share_value" : "শেয়ারের মূল্য",
        "instavc_affliate_share" : "বর্তমান অনুমোদিত শেয়ার",
        "instavc_enter_share" : "শেয়ার মান লিখুন (%)",
        "instavc_roomname" : "রুমের নাম",
        "instavc_room_ten" : "দশ",
        "instavc_room_twenty" : "কুড়ি",
        "instavc_room_thirty" : "ত্রিশ",
        "instavc_room_hostbased" : "নিমন্ত্রণকর্তা ভিত্তিক",
        "instavc_virtualmcu": "ভার্চুয়াল এম সি ইউ",
        "instavc_rooms_enterprises" : "উদ্যোগ",
        "instavc_roomid" : "রুম আই ডি",
        "instavc_roomtype" : "ঘরের বিবরণ",
        "instavc_room_options" : "রুম বিকল্প",
        "instavc_commercialtype": "বাণিজ্যিক প্রকার",
        "instavc_free" : "বিনামূল্যে",
        "instavc_poc" : "পি ও সি",
        "instavc_commercial" : "ব্যবসায়িক",
        "instavc_createdAt" : "এ নির্মিত",
        "instavc_useraccess" : "ব্যবহারকারী প্রবেশ",
        "instavc_peoplelinkroom" : "পিপলিংক রুম",
        "instavc_inputlimit" : "ইনপুট সীমানা",
        "instavc_participant_limit" : "অংশগ্রহণকারীদের সীমানা",
        "instavc_adduser" : "ব্যবহারকারী যুক্ত করুন",
        "instavc_searchbyname" : "নাম দ্বারা অনুসন্ধান",
        "instavc_manage_plans" : "পরিকল্পনা / পণ্য পরিচালনা করুন",
        "instavc_new_plans": "নতুন পরিকল্পনা / পণ্য",
        "instavc_allplan_list" : "সমস্ত পরিকল্পনা তালিকা",
        "instavc_sortby" : "ক্রমানুসার",
        "instavc_active" : "সক্রিয়",
        "instavc_inactive" : "নিষ্ক্রিয়",
        "instavc_create_plan" : "নতুন পরিকল্পনা তৈরি করুন",
        "instavc_plan_name" : "পরিকল্পনার নাম",
        "instavc_enteramount" : "পরিমাণ প্রবেশ করুন (ন্যূনতম: INR 100)",
        "instavc_select_product" : "পণ্য নির্বাচন করুন",
        "instavc_host_room" : "1 নিমন্ত্রণকর্তা / রুম",
        "instavc_multiroom" : "বহুবিধ নিমন্ত্রণকর্তা / রুম",
        "instavc_legacyrooms" : "উত্তরাধিকার রুম",
        "instavc_number_hosts" : "নিমন্ত্রণকর্তার সংখ্যা",
        "instavc_number_participants" : "অংশগ্রহণকারীদের সংখ্যা",
        "instavc_number_room" : "রুমের সংখ্যা",
        "instavc_subscriptiom_period" : "সাবস্ক্রিপশন সময়",
        "instavc_sub_yearly" : "বার্ষিক",
        "instavc_sub_monthly" : "মাসিক",
        "instavc_sub_weekly" : "সাপ্তাহিক",
        "instavc_setinterval" : "ব্যবধান সেট করুন",
        "instavc_type" :"আদর্শ",
        "instavc_subscription" :"সাবস্ক্রিপশন",
        "instavc_onetime" : "একবার",
        "instavc_description" : "বিবরণ",
        "instavc_planid" : "প্ল্যান আই ডি",
        "instavc_orders" : "অর্ডার",
        "instavc_orderid" : "অর্ডার আই ডি",
        "instavc_none" : "না",
        "instavc_customer" : "ক্রেতা",
        "instavc_build_anually" : "নির্মাণ করা বছরে বছরে",
        "instavc_recurring_billing" : "পুনরাবৃত্ত বিলিং",
        "instavc_next_due" : "পরবর্তী বাকি",
        "instavc_invoice_details" :"চালান বিশদ",
        "instavc_recurring_payment" : "পুনরাবৃত্তি প্রদান",
        "instavc_todays_sale" : "আজকের বিক্রয়",
        "instavc_total_order" : "মোট অর্ডার",
        "instavc_total_rooms" : "মোট রুম",
        "instavc_current_conference" : "বর্তমান সম্মেলন",
        "instavc_current_user" : "বর্তমান ব্যবহারকারী",
        "instavc_live_broadcast" : "সরাসরি সম্প্রচার",
        "instavc_loading_chart" : "চার্ট লোড হচ্ছে",
        "instavc_view" : "দৃশ্য",
        "instavc_coupon_info" : "কুপন তথ্য",
        "instavc_new_coupon" : "নতুন কুপন",
        "instavc_create_coupon" : "নতুন কুপন তৈরি করুন",
        "instavc_coupon_code" : "Coupon Code",
        "instavc_company_code" : "কোম্পানির কোড",
        "instavc_select_plan" : "পরিকল্পনা নির্বাচন করুন",
        "instavc_discount" : "ডিসকাউন্ট",
        "instavc_activestatus" : "সক্রিয় স্থিতি",
        "instavc_usage" : "ব্যবহার",
        "instavc_activeusage" : "সক্রিয় ব্যবহার",
        "instavc_singleuse" : "একক ব্যবহার",
        "instavc_multiuse" : "বহুবিধ ব্যাবহার",
        "instavc_first_page" : "প্রথম পৃষ্ঠা",
        "instavc_previosu_page" : "আগের পৃষ্ঠা",
        "instavc_next_page" : "পরবর্তী পৃষ্ঠা",
        "instavc_last_page" : "শেষ পৃষ্ঠা",
        "instavc_plan" : "পরিকল্পনা",
        "instavc_request_withdrawal" : "প্রত্যাহারের অনুরোধ",
        "instavc_withdraw" : "প্রত্যাহার",
        "instavc_account" : "বিবরণ",
        "instavc_verification" : "প্রতিপাদন",
        "instavc_withdraw_history" : "প্রত্যাহার ইতিহাস",
        "instavc_add_bank" : "প্রত্যাহারের জন্য একটি ব্যাংক অ্যাকাউন্ট যুক্ত করুন",
        "instavc_bank_description" : "আমরা আপনার আর্থিক তথ্য গোপন রেখে আপনার ব্যাংক অ্যাকাউন্ট রক্ষা করি। আমরা যখনই এই অ্যাকাউন্ট থেকে প্রত্যাহারের জন্য অনুরোধটি পাই তখনই আমরা আপনাকে স্থিতিটি ইমেল করব আপনার ব্যাংকের নীতি প্রত্যাহার এবং ছুটির সময়সূচীর উপর নির্ভর করে স্থানান্তরটি সম্পূর্ণ হতে কিছু সময় নিতে পারে।",
        "instavc_bank_accountnumber" : "ব্যাংক একাউন্ট নম্বর",
        "instavc_enter_accountnumber" : "আপনার অ্যাকাউন্ট নম্বর লিখুন",
        "instavc_account_name" : "হিসাব ধারকের নাম",
        "instavc_per_bank_account" : "ব্যাংক অ্যাকাউন্ট অনুসারে",
        "instavc_ifsc" : "আই এফ এস সি কোড",
        "instavc_bankname" : "ব্যাংকের নাম",
        "instavc_শাখাname" : "ব্যাংকের শাখা নাম",
        "instavc_confirmdetails" : "বিশদটি নিশ্চিত করুন",
        "instavc_pandetails" : "আপনার প্যান অনুযায়ী নীচে বিশদ সরবরাহ করুন",
        "instavc_enter_pan" : "প্যান অনুযায়ী আপনার নাম লিখুন",
        "instavc_fathername" : "বাবার নাম",
        "instavc_enter_fathername" : "বাবার নাম প্রবেশ করান",
        "instavc_pannumber" : "প্যান নম্বর",
        "instavc_panexampe" : "উদাহরণ: BNZPM2501G",
        "instavc_upload_pan_copy" : "প্যান কপি আপলোড করুন",
        "instavc_save_details" : "বিবরণ সংরক্ষণ করুন",
        "instavc_sales" : "বিক্রি",
        "instavc_transactionid" : "লেনদেন নাম্বার",
        "instavc_date" : "তারিখ",
        "instavc_amount" : "অর্থমাত্রা",
        "instavc_setaccount_withdraw" : "প্রত্যাহারের আগে অ্যাকাউন্টের বিশদ সেটআপ করুন",
        "instavc_first_withdraw" : "যদি আপনি প্রথমবারের মতো প্রত্যাহারের জন্য অনুরোধ করেন তবে আপনার অ্যাকাউন্টের বিশদটি পূরণ করতে হবে এবং পরবর্তী ট্যাবগুলিতে প্যান কার্ডের বিশদটি ব্যবহার করে আপনার অ্যাকাউন্টটি যাচাই করতে হবে। একবার আপনি যাচাইকরণটি শেষ করার পরে, আপনার উপলব্ধ ব্যালেন্স থেকে প্রত্যাহারের অনুরোধ জানাতে এগিয়ে যেতে পারেন।",
        "instavc_accountdetails" : "অ্যাকাউন্টের বিশদটি পূরণ করুন",
        "instavc_available_balance" : "পর্যাপ্ত টাকা",
        "instavc_amount_withdraw" : "উত্তলনের পরিমান",
        "instavc_enteramount_withdraw" : "আপনি যে পরিমাণ টাকা তুলতে চান তা প্রবেশ করুন",
        "instavc_select_payment_mode" : "পেমেন্ট মোড নির্বাচন করুন",
        "instavc_paypal_payment" : "পেপ্যাল ​​পেমেন্ট",
        "instavc_bank_transaction" : "ব্যাংক লেনদেন",
        "instavc_paypalfee" : "পেপাল ফি",
        "instavc_totalamount_withdraw" : "প্রত্যাহারের মোট পরিমাণ",
        "instavc_sendrequest" : "অনুরোধ প্রেরণ করুন",
        "instavc_no_request_withdraw" : "প্রত্যাহারের জন্য এখনও কোনও অনুরোধ উত্থাপিত হয়নি!",
        "instavc_start_process_withdraw" : "আপনি নীচে থেকে প্রত্যাহারের জন্য প্রক্রিয়া শুরু করতে পারেন।",
        "instavc_request_withdraw_now" : "এখনই প্রত্যাহারের অনুরোধ",
        "instavc_current_commission" : "কারেন্ট কমিশন",
        "instavc_from" : "থেকে",
        "instavc_to" : "প্রতি",
        "instavc_today" : "আজ",
        "instavc_last7days" : "শেষ 7 দিন",
        "instavc_lastmonth" : "এই মাস",
        "instavc_paid_customers" : "পরিশোধিত গ্রাহকরা",
        "instavc_share_referral_link" : "আপনার রেফারেল লিঙ্কটি বন্ধুদের সাথে ভাগ করুন",
        "instavc_copylink" : "লিংক কপি করুন",
        "instavc_minimum_payout" : "সর্বনিম্ন পরিশোধ",
        "instavc_referral_signup" : "সুপারিশ নিবন্ধন করুন",
        "instavc_referral_clicks" : "সুপারিশ ক্লিকস",
        "instavc_paid" : "পেইড",
        "instavc_unpaid" : "আনপেইড",
        "instavc_totalearned" : "মোট অর্জিত",
        "instavc_myreferral" : "আমার প্রচার",
        "instavc_viewall" : "সব দেখ",
        "instavc_mysales" : "আমার বিক্রয়",
        "instavc_sms_mfa" : "এস-এম-এস  এম-এফ-এ স্থিতি",
        "instavc_facebook" : "ফেসবুক",
        "instavc_twitter" : "টুইটার",
        "instavc_linkedin" : "লিঙ্কডইন",
        "instavc_referred_users" : "সুপারিশ ব্যবহারকারী",
        "instavc_created_date" : "তৈরীর তারিখ",
        "instavc_myearnings" : "আমার উপার্জন",
        "instavc_earnings" : "উপার্জন",
        "instavc_commission_share" : "কমিশন শেয়ার",
        "instavc_commission_percentage" : "কমিশন শতাংশ",
        "instavc_coupon_offers": "কুপন / অফার",
        "instavc_my_referral_account" : "আমার সুপারিশ অ্যাকাউন্ট",
        "instavc_req_withdraw" : "অনুরোধ প্রত্যাহার",
        "instavc_authenticating" :"ইনস্টা ভিসি সার্ভারে প্রমাণীকরণ করা হচ্ছে ...",
        "instavc_join_access_media" : "যোগদান করেছেন .. মিডিয়া ডিভাইসগুলি অ্যাক্সেস করা হচ্ছে ...",
        "instavc_publish_success" : "সফলভাবে প্রকাশ করুন",
        "instavc_recieves" : 'গ্রহণ করা',
        "instavc_host_screenshare" : "আপনাকে পর্দা / নথি ভাগ করে নেওয়ার জন্য বা হোস্ট হতে হবে",
        "instavc_request_sharescreen" : "স্ক্রিন / ডকুমেন্ট ভাগ করে নেওয়ার জন্য অ্যাক্সেসের অনুরোধ করুন",
        "instavc_note" : "বিঃদ্রঃ",
        "instavc_filesize" : "ফাইলের আকার 10MB এর বেশি হওয়া উচিত নয়",
        "instavc_become_host" : "নিমন্ত্রণকর্তা হতে ভিডিওটিতে ডটেড ওভার ফ্লো মেনু আইকনগুলিতে ক্লিক করুন",
        "instavc_clicklink" : "পপআপে নিমন্ত্রণকর্তা লিঙ্কটি ক্লিক করুন এবং নিমন্ত্রণকর্তার পাসওয়ার্ড দিন এবং নিমন্ত্রণকর্তা বোতামে ক্লিক করুন",
        "instavc_doc_share" : "পত্র ভাগ",
        "instavc_search_host" : "নিমন্ত্রণকর্তার জন্য অপেক্ষা করছি",
        "instavc_wait_for_host" : "নিমন্ত্রণকর্তার এই সভাটি শুরু করার জন্য দয়া করে অপেক্ষা করুন",
        "instavc_open_black_dialog" : "কালো কথোপকথন খুলুন",
        "instavc_open_white_dialog" : "সাদা ডায়ালগ খুলুন",
        "instavc_dail_detail" : "ডায়াল করুন - ইন - বিশদ",
        "instavc_request_access" : "অনুরোধ প্রবেশ",
        "instavc_inordder_enable" : "সক্রিয় করার জন্য",
        "instavc_host_permission" : "আপনার নিমন্ত্রণকর্তার প্রবেশ এর অনুমতি প্রয়োজন",
        "instavc_please_wait" : "দয়া করে অপেক্ষা করুন ",
        "instavc_host_to_permit" : "(নিমন্ত্রণকর্তা) এর অনুমতি",
        "instavc_alternate_content" : "বিকল্প সামগ্রী",
        "instavc_meeting_room" : "' সভা ঘরগুলি",
        "instavc_host_left_conference" : "নিমন্ত্রণকর্তা সম্মেলন ছেড়ে গেছে!",
        "instavc_conf_end" : "সম্মেলনটি স্বয়ংক্রিয়ভাবে শেষ হবে",
        "instavc_seconds" : "সেকেন্ড",
        "instavc_waiting_msg" : "অপেক্ষা করার জন্য ধন্যবাদ. নিমন্ত্রণকর্তা  যোগদানের পরে আমরা সভাটি শুরু করব",
        "instavc_let_hostname" : "আপনি কি  নিমন্ত্রণকর্তাকে জানাতে চান যে আপনি অপেক্ষা করছেন?",
        "instavc_exitconf" : "প্রস্থান সম্মেলন",
        "instavc_host_left" : "নিমন্ত্রণকর্তা ছেড়ে গেছে...",
        "instavc_end_host_msg" : "নিমন্ত্রণকর্তা এই সভাটি শেষ করেছেন। অংশ নেওয়ার জন্য আপনাকে ধন্যবাদ।",
        "instavc_close_conf" : "আপনি ঘরে ফিরে যেতে পারেন (বা) অ্যাপ্লিকেশনটি বন্ধ করুন।",
        "instavc_gohome" : "হোমপেজে যান",
        "instavc_hand_raised" : "হাত উত্থাপিত",
        "instavc_ask" : "জিজ্ঞাসা করা",
        "instavc_protocal" : "প্রোটোকল",
        "instavc_bitrate" : "বিটরেট",
        "instavc_confirm_details" : "আপনার বিশদটি নিশ্চিত করুন",
        "instavc_enter_info_conf" : "সম্মেলন শুরু করার আগে দয়া করে আপনার তথ্য প্রবেশ করুন।",
        "instavc_have_acc" : "আপনার যদি ইতিমধ্যে একটি অ্যাকাউন্ট থাকে?",
        "instavc_host_access" : "নিমন্ত্রণকর্তা প্রবেশ",
        "instavc_host_pass" : "নিমন্ত্রণকর্তা পাসওয়ার্ড লিখুন",
        "instavc_becomehost" : "নিমন্ত্রণকর্তা হন",
        "instavc_permit_screenshare" : "নিমন্ত্রণকর্তা হন",
        "instavc_allow_access" : "হোয়াইটবোর্ড অ্যাক্সেসের অনুমতি দিন",
        "instavc_request_permission" : "অতিরিক্ত অনুমতির জন্য অনুরোধ করেছে",
        "instavc_deny" : "প্রত্যাখ্যান", 
        // "instavc_planid" : "প্ল্যান আই ডি",
        "instavc_customeremail" : "গ্রাহক ইমেইল",
        "instavc_orderlink" : 'অর্ডার লিঙ্ক',
        "instavc_customerid" : "গ্রাহক আইডি",

        "instavc_selectpackage" : "প্যাকেজ নির্বাচন করুন",
        "instavc_host_package" : "নিমন্ত্রণকর্তা বেসড প্যাকেজ",
        "instavc_virtualbase_mcu" : "ভার্চুয়াল এম সিই উ ভিত্তিক",
        "instavc_plans_product" : "পরিকল্পনা / পণ্য",
        "instavc_nodata" : "কোন তথ্য নেই",
        "instavc_nodata_msg" : "ওহো! আপনাকে এখনই দেখানোর জন্য কোনও ডেটা উপলব্ধ নেই।",
        "instavc_basicplan" : "বেসিক পরিকল্পনা",
        "instavc_host_participants" : "30 জন অংশগ্রহণকারী সহ 1 নিমন্ত্রণকর্তা",
        "instavc_link" : "লিংক",
        "instavc_cancel_order" : "আদেশ বাতিল",
        "instavc_per" : "প্রতি",
        "instavc_user_email" : "ব্যবহারকারী ইমেইল",
        "instavc_owner" : "মালিক",
        "instavc_user" : "ব্যবহারকারী",
        "instavc_default_users" : "ডিফল্ট প্রদান",
        "instavc_system_settings" : "পদ্ধতি নির্ধারণ",
        "instavc_expires" : "মেয়াদ শেষ হয়ে যাবে",
        "instavc_start_VC" : "ভিডিও কনফারেন্স শুরু করুন",
        "instavc_start_AC" : "অডিও সম্মেলন শুরু করুন",
        "instavc_date_error" : "আরম্ভের তারিখ এবং সময় বর্তমান সময়ের চেয়ে বড় হওয়া উচিত",
        "instavc_browser_update" : "ব্রাউজার আপডেট প্রয়োজন",
        "instavc_browser_note" : "আমরা লক্ষ্য করেছি আপনি BROWSER NAME এর পুরানো সংস্করণ ব্যবহার করছেন যা এখন অসমর্থিত।",
        "instavc_browser_msg" : "Instavc.com BROWSER NAME বা অন্য যে কোনও আধুনিক ব্রাউজারের একটি আপডেট সংস্করণ প্রয়োজন।",
        "instavc_browser_upgrade" :"আরও ভাল অভিজ্ঞতার জন্য দয়া করে এই ব্রাউজারগুলির সর্বশেষতম সংস্করণগুলির কোনওটিতে আপগ্রেড করুন।",
        "instavc_googlechrome" : "গুগল ক্রম",
        "instavc_gc_version74" : "সংস্করণ 74",
        "instavc_mfirefox" : "মোজিলা ফায়ারফক্স",
        "instavc_mff_version" : "সংস্করণ 66",
        "instavc_opera" : "অপেরা",
        "instavc_opera_version" : "সংস্করণ 60.0+",
        "instavc_microsoftedge" : "মাইক্রোসফ্ট এজ",
        "instavc_ms_version" :"সংস্করণ 44+",
        "instavc_safari" : "অ্যাপল সাফারি",
        "instavc_safari_version" : "সংস্করণ 12.1",
        "instavc_contact_msg" : "ইতিমধ্যে আপগ্রেড হয়েছে, কিন্তু এখনও সমস্যা আছে? যোগাযোগ করুণ",
        "instavc_camera_busy" : "ব্যস্ত বলে মনে হচ্ছে ক্যামেরা!",
        "instavc_close_camera" : "সমস্ত অ্যাপ্লিকেশন বন্ধ করুন এবং আবার চেষ্টা করুন।",
        "instavc_resolution" :"রেজোলিউশন সমর্থিত নয়!",
        "instavc_camera_notsupport" : "আপনার ক্যামেরা এই রেজোলিউশনটিকে সমর্থন করে না।",
        "instavc_camera_reconfig" : "নিম্ন রেজোলিউশনের সাহায্যে আপনার সেটিংসটিকে পুনরায় কনফিগার করুন এবং আবার চেষ্টা করুন।",
        "instavc_change_resolution" :"রেজোলিউশন পরিবর্তন করুন",
        "instavc_confirmation" : "অনুমোদন",
        "instavc_yes" : "হ্যাঁ",
        "instavc_delete_room" : "আপনি কি রুমটি মুছতে চান?",
        "instavc_delete_license" : "আপনি কি নিশ্চিত যে লাইসেন্সটি মুছতে চান?",
        "instavc_help" :"আপনাকে সাহায্য করার জন্য আমরা এইখানে",
        "instavc_browse_questions" : "প্রায়শই জিজ্ঞাসিত প্রশ্নগুলির মাধ্যমে ব্রাউজ করুন।",
        "instavc_os" :"অপারেটিং সিস্টেম",
        "instavc_macos" :"ম্যাক ওএস এক্স সংস্করণ:",
        "instavc_chrome_version" : "ক্রোম সংস্করণ:",
        "instavc_private_browsing" : "ব্যক্তিগত ব্রাউজিং?",
        "instavc_faq_no" : "না",
        "instavc_display_resolution" : "ইনস্টা ভিসি_ প্রদর্শন_ সমাধান",
        "instavc_aspect_ratio" : "দিক অনুপাত প্রদর্শন করুন",
        "instavc_sys_hasspeakers" : "সিস্টেমের স্পিকার আছে?",
        "instavc_found_speakers" : "স্পিকার ডিভাইস পাওয়া গেছে: 2",
        "instavc_speakers1" : "স্পিকার 1",
        "instavc_speakers2" : "স্পিকার 2",
        "instavc_sys_have_microphone" : "মাইক্রোফোনটিতে সিস্টেম আছে?",
        "instavc_found_microphone" : "মাইক্রোফোন ডিভাইস পাওয়া গেছে: 2",
        "instavc_microphone1" : "মাইক্রোফোন 1",
        "instavc_microphone2" : "মাইক্রোফোন 2",
        "instavc_has_webcam" : "সিস্টেমে ওয়েবক্যাম আছে?",
        "instavc_found_speakers1" : "স্পিকার ডিভাইস পাওয়া গেছে: 1",
        "instavc_camera1" : "ক্যামেরা 1",
        "instavc_webcam_permission" : "ওয়েবসাইটে ওয়েব ক্যামের অনুমতি আছে?",
        "instavc_microphone_permission" : "ওয়েবসাইটটিতে মাইক্রোফোনের অনুমতি রয়েছে?",
        "instavc_browser_allows" : "ব্রাউজার এই পৃষ্ঠায় ব্যবহারকারী মিডিয়া পেতে অনুমতি দেয়?",
        "instavc_change_output_device" : "আপনি কি আউটপুট অডিও ডিভাইসগুলি পরিবর্তন করতে পারেন?",
        "instavc_change_camera_resolutions" : "নতুন ব্যবহারকারীর মিডিয়া অনুরোধ না করে আপনি কী ক্যামেরার রেজোলিউশনগুলি পরিবর্তন করতে পারবেন?",
        "instavc_browser_support_webrtc" : "ব্রাউজার ওয়েবআরটিসি সমর্থন করে (1.0 বা 1.1 হয়)?",
        "instavc_browser_support_ortc" : "ব্রাউজারটি ওয়েব আর টিসি সমর্থন করে (ওয়েব আর টিসি 1.1)?",
        "instavc_initial_setup" : "আপনার প্রাথমিক সেটআপ প্রক্রিয়া চলাকালীন অপেক্ষা করুন!",
        "instavc_close_browser" : "এই মুহুর্তে আপনার ব্রাউজারটি বন্ধ করবেন না বা পিছনের বোতামটি ব্যবহার করবেন না।",
        "instavc_whoops" : "উপস!",
        "instavc_nonet_msg" : "কোনও ইন্টারনেট সংযোগ পাওয়া যায় নি। দয়া করে আপনার সংযোগটি পরীক্ষা করুন বা আবার চেষ্টা করুন।",
        "instavc_nosearch" : "কোন অনুসন্ধান ফলাফল পাওয়া যায় নি",
        "instavc_noserchmsg" : "আমরা আপনার অনুসন্ধানের সাথে মেলে এমন কোনও সামগ্রী খুঁজে পাই না।",
        "instavc_nosearch_filter" : "আপনি যা সন্ধান করছেন তা অনুসন্ধান করতে নিজের অনুসন্ধান বা ফিল্টারকে সামঞ্জস্য করার চেষ্টা করুন।",
        "instavc_gotohoem_page" : "হোমপেজে যান",
        "instavc_pageloading" : "পৃষ্ঠা লোড হচ্ছে ... দয়া করে অপেক্ষা করুন!",
        "instavc_process" : "প্রক্রিয়াকরণ করা হচ্ছে ...",
        "instavc_session_timeout" : "অধিবেশন সময় শেষ",
        "instavc_session_inactivity" : "নিষ্ক্রিয়তার কারণে আপনার সেশনটির সময়সীমা শেষ হচ্ছে।",
        "instavc_session_msg" : "সাইন ইন থাকা চয়ন করুন।",
        "instavc_session_reconnect" : "পুনরায় সংযোগ",
        "instavc_site_notreached" : 'এই সাইটে পৌঁছানো যাবে না!',
        "instavc_site_webঠিকানা" : "আপনি সঠিক ওয়েব ঠিকানা পেয়েছেন তা নিশ্চিত করুন ",
        "instavc_check_internet" : "Check your network",
        "instavc_search_url" : "অন্যান্য ব্রাউজারে URL অনুসন্ধান করুন",
        "instavc_goto" : "যাও",
        "instavc_request_for_access" : "অ্যাক্সেসের জন্য অনুরোধ",
        "instavc_start_collabrate" : "হোয়াইটবোর্ডে সহযোগিতা শুরু করতে",
        "instavc_large_conference_mode" : 'এটির "বৃহত্তর সম্মেলন" মোড, হোস্ট আপনাকে অনুমতি না দেওয়া পর্যন্ত আপনি অন্যকে কথা বলতে বা দেখতে পারবেন না ',
        "instavc_allow_participants" : 'এটির "বৃহত্তর সম্মেলন" মোডে আপনাকে অংশগ্রহণকারীদের ম্যানুয়ালি বলতে হবে',
        "instavc_buy_premium" : "এই বৈশিষ্ট্যগুলি আনলক করতে প্রিমিয়াম কিনুন ",
        "instavc_alert_tryagain" : "কিছু ভুল হয়েছে আবার চেষ্টা করুন",
        "instavc_enter_name" : "আপনার নাম প্রবেশ করুন",
        "instavc_confirm" : "নিশ্চিত করুন ",
        "instavc_ok" : "ঠিক আছে",
        "instavc_askquestion" : "প্রশ্ন জিজ্ঞাসা কর...",
        "instavc_recieve" : "গ্রহণ করা",
        "instavc_delay" : "বিলম্ব (MS)",
        "instavc_audio_opus" : "অডিও / রচনা",
        "instavc_video_vp8" : "ভিডিও / ভিপি 8",
        "instavc_browser_not_support_incall" : 'আপনার ব্রাউজার কল চলাকালীন রেজোলিউশন পরিবর্তন সমর্থন করে না!',
        "instavc_failed_toPublish" : "ভিডিও প্রকাশ করতে ব্যর্থ",
        "instavc_publish_fail" : "প্রকাশ ব্যর্থ",
        "instavc_video_cant_publish" : "ব্যবহারকারীর সীমাবদ্ধতার নাগালের কারণে ভিডিও প্রকাশ করা যায় না",
        "instavc_failed_joinConference" : 'সম্মেলনে যোগ দিতে ব্যর্থ',
        "instavc_mute_audio" : "রিমোট অডিও নিঃশব্দ করা থাকলে আপনি নিঃশব্দ / সশব্দ করতে পারবেন না",
        "instavc_remote_audio_muted" : "রিমোট অডিও নিঃশব্দ!",
        "instavc_enter_conferenceid" : "আপনার কনফারেন্স আইডি প্রবেশ করান",
        "instavc_share_screen" : "ভাগ পর্দা",
        "instavc_sharing_your_screen" : "আপনার পর্দা ভাগ করা হচ্ছে ...",
        "instavc_stop" : "স্টপ",
        "instavc_back" : "পেছনে",
        "instavc_choose_plan" : "নীচের তালিকা থেকে আপনার পরিকল্পনা চয়ন করুন",
        "instavc_have_promotionalcode" : "একটি প্রচারমূলক কোড / অংশীদার কোড আছে?",
        "instavc_contact_pricing" : "মূল্য নির্ধারণের জন্য আমাদের সাথে যোগাযোগ করুন",
        "instavc_payment_failed" : 'পেমেন্ট ব্যর্থ হয়েছে',
        "instavc_payment_error" : 'দুর্ভাগ্যক্রমে আপনার অর্থ প্রদানের সময় একটি ত্রুটি ঘটেছে।',
        "instavc_contact_support" : "কোন সহায়তা প্রয়োজন হলে আমাদের সমর্থন দলের সাথে যোগাযোগ করুন।",
        "instavc_tryagain" : "আবার চেষ্টা কর",
        "instavc_payment_success" : "অর্থ প্রদান সফল",
        "instavc_thanks_for_payment" : "পরিশোধের জন্য আপনাকে ধন্যবাদ!",
        "instavc_payment_processed" : 'আপনার অর্থ প্রদান সফলভাবে প্রক্রিয়া করা হয়েছে। একটি স্বয়ংক্রিয় পেমেন্ট প্রাপ্তি',
        "instavc_mail_sent" : 'শীঘ্রই আপনার নিবন্ধিত ইমেল ঠিকানায় প্রেরণ করা হবে',
        "instavc_goto_homepage" : "হোম পৃষ্ঠায় ফিরে যান",
        "instavc_want_toend_call" : "কলটি শেষ করতে চান?",
        "instavc_exit_window" : 'এই উইন্ডোটি বন্ধ করা আপনার কল থেকে প্রস্থান করবে। আপনি কি নিশ্চিত যে আপনি এই কলটি শেষ করতে চান?',
        "instavc_create_room" : "ঘর তৈরি করুন",
        "instavc_userlimit" : "ব্যবহারকারী সীমা",
        "instavc_edit_room" : "ঘর সম্পাদনা করুন",
        "instavc_update" : 'আপডেট',
        "instavc_manage_license" : 'লাইসেন্স পরিচালনা করুন',
        "instavc_package" : "প্যাকেজ",
        "instavc_no_of_rooms" : "রুম সংখ্যা",
        "instavc_no_of_users" : "ব্যবহারকারীর সংখ্যা",
        "instavc_purchasedOn" : "ক্রয় করা হয়েছে",
        "instavc_expiredon" : "মেয়াদোত্তীর্ণ",
        "instavc_or" : "অথবা",
        "instavc_otherhost_ইমেইল" : "Iআপনি যেকোন ব্যবহারকারীর হোস্ট হিসাবে তৈরি করতে চান, তার ইমেইল ঠিকানা প্রবেশ করান .",
        "instavc_set_host_password" : 'নিমন্ত্রণকর্তা পাসওয়ার্ড সেট করুন',
        "instavc_host_password" : 'নিমন্ত্রণকর্তা পাসওয়ার্ড',
        "instavc_access_room" : 'এই রুমে আর কে অ্যাক্সেস করতে পারে?',
        "instavc_select_user_host" : "তাকে হোস্ট করার জন্য তালিকা থেকে যে কোনও ব্যবহারকারী নির্বাচন করুন।",
        "instavc_prologin" : "ইন্সটা-ভিসি প্রো প্রবেশ করুন",
        "instavc_start" : "শুরু",
        "instavc_enter_website" : "ওয়েবসাইটের নাম লিখুন",
        "instavc_enter_valid_ইমেইল" : 'বৈধ ইমেইল প্রবেশ করুন ',
        "instavc_enter_valid_phone" : 'দয়া করে বৈধ ফোন নম্বর লিখুন',
        "instavc_field_required" : 'ঘরটি অবশ্যই পূরণ করতে হবে',
        "instavc_invitedby" : "আমন্ত্রিত দ্বারা",
        "instavc_storage" : "সংগ্রহস্থল",
        
        "affiliate_approve" : "অনুমোদিত",
        "affiliate_pending" : "বিচারাধীন",
        "affiliate_rejected" : "প্রত্যাখ্যাত",
        "affiliate_user_status" : "ব্যবহারকারী অবস্থা",
        "commission_other" : "অন্যান্য কমিশন",
        "add_commission" : "কমিশন যুক্ত করুন",
        "delete_commission" : "কমিশন যুক্ত করুন",
        "update_commission" : "কমিশন আপডেট করুন",
        "name" : "নাম",
        "offer_value" : "অফার মূল্য",
        "add" : "যোগ",
        "update" : "আপডেট",
        "affiliates" : "সংযুক্ত করণ",
        "status" : "অবস্থা",
        "status_change_message" : "আপনি কি স্থিতি পরিবর্তন করতে চান?",
        "approve" : 'অনুমোদন করা',
        "reject" :"প্রত্যাখ্যান",
        "commissions" : "কমিশন",
        "withdraw_data" : "ডেটা প্রত্যাহার করুন",
        "withdraw_amount" : 'পরিমাণ প্রত্যাহার',
        "payment_method" : "মূল্যপরিশোধ পদ্ধতি",
        "payment_fee" : "বেতন প্রদানের ভাতা",
        "total_amount_withdraw" : "প্রত্যাহারের জন্য মোট পরিমাণ",
        "total_earnings" : "মোট উপার্জন",
        "pending_amount" : "মুলতুবি পরিমাণ",
        "paid_amount" : "দেওয়া পরিমাণ",
        "unpaid_amount" : "আনপেইড পরিমাণ",
        "requested_withdraw" : "অনুরোধ করা পরিমাণ প্রত্যাহার",
        "english": "ইংরেজি",
        "french" : "ফরাসি",
        "portuguese": "পর্তুগীজ",
        "hindi": "হিন্দি",
        "gujarati": "গুজরাটি",
        "kannada": "কন্নড",
        "marathi": "মারাঠি",
        "tamil": "তামিল",
        "telugu": "তেলুগু",
        "urdu": "উর্দু",
        "spanish": "স্পেনীয়",
        "malyalam": "মায়ালাম",
        "italian": "ইতালিয়ান",
        "bangla" : "বাংলা",
        "room" : "রুম",
        "create" : 'সৃষ্টি',
        "repeat" : "পুনরাবৃত্তি",
        "daily" : "দৈনন্দিন",
        "repeat_every" : "প্রতিটি পুনরাবৃত্তি",
        "repeat_on" : "পুনরাবৃত্তি",
        "repeat_by" : "পুনরাবৃত্তি দ্বারা",
        "ends" : "শেষ",
        "after" : "পরে",
        "occurences" : "ঘটনার",
        "on" : "চালু",
        "summary" : "সারসংক্ষেপ",
        "repeats" : "পুনরাবৃত্তি",
        "withdraws" : "প্রত্যাহার",
        "every" : "প্রতি",
        "days" : "দিন",
        "weeks" : "সপ্তাহ",
        "months": "মাস",
        "onday" : "দিনে",
        "years" : "বছর",
        "times" : "বার",
        "until" : "পর্যন্ত",
        "past_meeting_list" : "অতীত বৈঠকের তালিকা",
        "organised_by" : "সংগঠিত দ্বারা",
        "delete" : "মুছে ফেলা",
        "join" : "যোগদান",
        "to" : "প্রতি",
        "enter_password" : "পাসওয়ার্ড লিখুন",
        "submit" : "জমা দিন",
        "enter_passwordmessage" : "পাসওয়ার্ড লিখুন দয়া করে",
        "delete_message" : "আপনি মুছে ফেলতে চান",
        "meeting_permanent" : "স্থায়ীভাবে দেখা?",
        "day" : "দিন",
        "password_message": "পাসওয়ার্ড ভুল",
        "timezone" : "সময় অঞ্চল",
        "by" : "দ্বারা",
        "weekdays" : ['রবি', 'সোম', 'মঙ্গল', 'বুধ', 'বৃহস্পতি', 'শুক্র', 'শনি'],
        "allweek" : ['রবিবার', 'সোমবার', 'মঙ্গলবার', 'বুধবার', 'বৃহস্পতিবার', 'শুক্রবার', 'শনিবার'],
        "day_month" : "মাসের দিন",
        "day_week" : "সপ্তাহের দিন",
        "week": "সপ্তাহ",
        "month": "মাস",
        "year": "বছর",
        "enterpassword": "আপনার নতুন পাসওয়ার্ড লিখুন এবং পাসওয়ার্ড নিশ্চিত করুন",
        "passwordmessage" : "পাসওয়ার্ড এবং নিশ্চিত পাসওয়ার্ড উভয়ই এক হওয়া উচিত",
        "passwordupdate" : "পাসওয়ার্ড সফলভাবে আপডেট হয়েছে",
        "numeric" : ['প্রথম', 'দ্বিতীয়', 'তৃতীয়', 'চতুর্থ', 'পঞ্চম'],
        "verify_ইমেইল" : "আপনার ইমেইল যাচাই করুন ",
        "confirm_code" : "নিশ্চিতকরণ কোড",
        "verify_msg" : "কোডটির জন্য আপনার মোবাইলটি পরীক্ষা করুন।",
        "verify" : "যাচাই করুন",
        "not_recieved" : "প্রাপ্ত না?",
        "resend_otp" : "ও টি পি পুনরায় পাঠান",
        "start_browsing" : "ব্রাউজিং শুরু করুন",
        "become_affiliate" : "অধিভুক্ত হন",
        "affiliate" : "শাখা",
        "verify_mobile" : "আপনার মোবাইল যাচাই করুন",
        "instavc_allow_DocumentAccess" : "পারমিট ডকুমেন্ট-শেয়ার",
        "instavc_allow_Notes" : "পারমিট নোটস",

        //common - CameraResolution	
        "camera_not_access" : "নিম্নলিখিত কোনও কারণে ক্যামেরা অ্যাক্সেসযোগ্য নয়:",
        "camera_not_access_reason1" : "রেজোলিউশন সেটিংস এই ডিসপ্লেটির সাথে সামঞ্জস্যপূর্ণ হতে পারে না",
        "camera_not_access_reason2" : "আপনার ক্যামেরাটি বিভিন্ন অ্যাপ্লিকেশন দ্বারা ব্যবহৃত হচ্ছে, দয়া করে সমস্ত অ্যাপ্লিকেশন বন্ধ করুন এবং লিঙ্কটিতে ক্লিক করে আবার চেষ্টা করুন।",
            
        //Containers	
        //content - components - assignQuestionnaire	
        "asgnQue_Assign_Question" : "প্রশ্নাবলী অর্পণ করুন",
        "asgnQue_assigned_question" : "নির্ধারিত প্রশ্নাবলী",
        //assignQuestList	
        "quslsit_assig_que_list" : "বরাদ্দকৃত প্রশ্নাবলী তালিকা",
        "quslsit_question_lists" : "প্রশ্নাবলী তালিকা",
        "quslsit_add_new_question" : "নতুন প্রশ্নাবলী যুক্ত করুন",
        "quslsit_no_question_assign":"কোনও প্রশ্নপত্র এখনও বরাদ্দ করা হয়নি!",
        "quslsit_assign_new_ques" : "উপরোক্ত প্রশ্নোত্তর বোতামটি ক্লিক করতে একটি নতুন প্রশ্নাবলী নিয়োগ করুন",

        //model-assign-Questionnaire	
        "select_questionnaire" : "প্রশ্নাবলী নির্বাচন করুন",
        "duration" : "স্থিতিকাল",
        "time_limit" : "সময় সীমা",
        "show_results" : "ফলাফল প্রদর্শন করো",
        "save" : "সংরক্ষণ",
        //viewAssigned	
        "content_group" : "সামগ্রী গোষ্ঠী",
        "list_assigned_ques" : "নির্ধারিত প্রশ্নের তালিকা:",
        "mins" : "মিনিট",
        "marks" : "চিহ্ন",
        //AssignedQuestions	
        "asgQues_5_Marks" : "( 5 চিহ্ন )",
        "asgQues_answers" : "উত্তর",
        "asgQues_no_questions" : "প্রশ্ন নেই!",

        //content - components - contentGrade	
        //GradeSetting	
        "grdSet_GPA_calculation" : "শতাংশ থেকে জি পি এ গণনা",
        "grdSet_GPA_cal_msg" : "শতাংশটি 100% এর জন্য যা 100 পয়েন্ট ছাড়া কিছুই নয়। সুতরাং 25 শতাংশ পয়েন্ট জিপিএ সিস্টেমে 1 পয়েন্ট সমতুল্য। জিপিএ সূত্রে শতকরা হার মাত্র আপনার শতাংশকে ১০০ দিয়ে ভাগ করে 4 দিয়ে গুণা করে you যদি আপনার শতাংশটি 75% হয় তবে আপনার গ্রেড (75/100) * 4 = 3 হবে।",
        "grdSet_grade_point" : "গ্রেড পয়েন্ট যদি হয়",
        //managegrade	
        "mngGrd_grades" : "শ্রেণীসমূহ",
        "mngGrd_modify" : "পরিবর্তন",
        "mngGrd_save_grades" : "গ্রেড সংরক্ষণ করুন",
        "mngGrd_modify_grades" : "গ্রেডগুলি সংশোধন করুন",
        "mngGrd_grade_info" : "গ্রেড তথ্য",
        //content - components - ContentParticipants	
        //components-admnAnsView
        "admnAns_answer_list_for_question" : "নীচে এই বিষয়বস্তু গোষ্ঠীর সমস্ত প্রশ্নাবলীর জন্য উত্তরগুলির তালিকা দেওয়া হল।",
        //components-participants	
        "prtcpt_certification" : "প্রশংসাপত্রদান:",
        "prtcpt_other_content_group" : "অন্যান্য সামগ্রী গোষ্ঠীতে",
        "prtcpt_sales" : "বিক্রয়",
        "prtcpt_marketing" : "মার্কেটিং",
        "prtcpt_human_resource" : "মানব সম্পদ",
        //manageparticipants	
        "mngPrtcpt_add_participants" : "অংশগ্রহণকারীদের যোগ করুন",
        "mngPrtcpt_participants_list" : "অংশগ্রহণকারীদের তালিকা",
        "mngPrtcpt_import_participants" : "অংশগ্রহণকারীদের আমদানি করুন",
        "mngPrtcpt_download_sample" : "নমুনা ডাউনলোড করুন",
        "mngPrtcpt_no_participants_added" : "কোনও অংশগ্রহণকারী এখনও যোগ করা হয়নি!",
        "mngPrtcpt_add_new_participant" : "উপরের অংশগ্রহীতা বোতাম যুক্ত করতে যোগ করতে একটি নতুন অংশীদার যুক্ত করুন",
        //modal-add-participants	
        "addPrtcpt_select_participants" : "অংশগ্রহণকারীদের নির্বাচন করুন",
        "addPrtcpt_model_add_participants" : "অংশগ্রহণকারীদের যোগ করুন",
        //partipantGradeView	
        "prtcptGrde_participant_grade" : "অংশগ্রহণকারী শ্রেণী বিশদ",
        "prtcptGrde_grade_participants_list" : "অংশগ্রহণকারীদের তালিকা",
        //content - components - ContentQuestionnaire	
        //managequestionnaire	
        "mngQuesnr_create_questionnaire" : "প্রশ্নাবলী তৈরি করুন",
        "questionnaire_list" : "প্রশ্নাবলী তালিকা",
        //managequestions	
        "mngQues_question_details" : "প্রশ্নাবলী বিবরণ",
        "mngQues_no_question_created" : "এখনও কোন প্রশ্ন তৈরি করা হয়নি!",
        "mngQues_create_new_question" : "একটি নতুন প্রশ্ন তৈরি করুন, তৈরি করতে উপরের প্রশ্নোত্তর তৈরি করুন বোতামটি ক্লিক করুন",
        //modal-create-quest-group	
        "mdlGrp_questionnaire_name" : "প্রশ্নাবলী নাম",
        "mdlGrp_update" : "আপডেট",
        "mdlGrp_create" : "সৃষ্টি",
        //modal-create-questions
        "mdlCrtQues_question_type" : "প্রশ্নের ধরন",
        "mdlCrtQues_sel_question_type" : "প্রশ্ন প্রকার নির্বাচন করুন",
        "mdlCrtQues_single_sel_multiple_choice" : "একক নির্বাচন একাধিক পছন্দ",
        "mdlCrtQues_multiselect_multiple_choice" : "বহুবিধ পছন্দ",
        "mdlCrtQues_ture_false" : "সত্য / মিথ্যা",
        "mdlCrtQues_enter_answer_choice" : "উত্তরের পছন্দগুলি প্রবেশ করান এবং কোন উত্তরটি সঠিক তা চিহ্নিত করুন",
        "mdlCrtQues_add_another_choice" : "+ অন্য পছন্দ যুক্ত করুন",
        //viewQuestionnaire	
        "viewQues_add_questions" : "প্রশ্ন যুক্ত করুন",
        "viewQues_no_question_created" : "এখনও কোন প্রশ্ন তৈরি করা হয়নি!",
        "viewQues_create_new_question" : "একটি নতুন প্রশ্ন তৈরি করুন, তৈরি করতে উপরের প্রশ্নোত্তর তৈরি করুন বোতামটি ক্লিক করুন",

        //content - components - createContent	
        //createcontent	
        "crteContent_create_new_content" : "নতুন সামগ্রী তৈরি করুন",
        "crteContent_update_content" : "সামগ্রী আপডেট করুন",
        "crteContent_save_content" : "সামগ্রী সংরক্ষণ করুন",
        "crteContent_content_list" : "সামগ্রীর তালিকাগুলি",
        "edit_content" : "সামগ্রী সম্পাদনা করুন",
        "crteContent_create_content" : "সামগ্রী তৈরি করুন",
        "crteContent_create_your_content_like" : "চিত্র, ভিডিও ফাইল, অডিও ফাইল এবং দস্তাবেজের মতো মিডিয়া যুক্ত করে আপনার সামগ্রী তৈরি করুন.",
        "crteContent_upload_document" : "দস্তাবেজগুলি আপলোড করুন",
        "crteContent_upload_media" : "মিডিয়া আপলোড করুন",
        "crteContent_document" : "দস্তাবেজগুলি",
        "crteContent_media_files" : "মিডিয়া ফাইল",
        //view-content	
        "viewCon_content_view" : "সামগ্রী দেখুন",
        "viewCon_content_list" : "সামগ্রীর তালিকাগুলি",
        "viewCon_View_content" : "সামগ্রী দেখুন",
        "viewCon_enable" : "সক্ষম করুন: ",
        "viewCon_document" : "দস্তাবেজগুলি",
        "viewCon_media_files" : "মিডিয়া ফাইল গুলো",

        //content - components - contentRow	
        "conRow_by" : "দ্বারা: ",

        //content - components - managecontent	
        "create_new_content" : "সামগ্রী তৈরি করুন",
        "mngCon_all" : "সব",
        "mngCon_content_list" : "সামগ্রীর তালিকাগুলি",
        "mngCon_no_content_created" : "এখনও কোনও সামগ্রী তৈরি করা হয়নি!",
        "mngCon_create_new_content" : "একটি নতুন সামগ্রী তৈরি করুন, তৈরি করতে উপরের সামগ্রী তৈরি করুন বোতামটি ক্লিক করুন",
        //content - components - model-access-right	
        "mdlAccRight_share_access" : "অন্যান্য প্রশিক্ষকের সাথে প্রবেশ ভাগ করুন",
        "mdlAccRight_type_id_add" : "ইমেল আইডি টাইপ করুন এবং অ্যাড করুন",
        "mdlAccRight_no_instructor_added" : "কোনও প্রশিক্ষক এখনও যোগ করা হয়নি!.",
        "mdlAccRight_add_people_from_ঠিকানাbok" : "আপনার ঠিকানা বই থেকে বা ইমেল ঠিকানা টাইপ করে লোকেদের যুক্ত করুন.",
        "mdlAccRight_contacts" : "যোগাযোগ",
        "mdlAccRight_add_contacts" : "আপনার ঠিকানা বইয়ের পরিচিতিগুলি থেকে সামগ্রী গোষ্ঠী পরিচিতি যুক্ত করুন",
        "mdlAccRight_no_contacts_added" : "কোনও যোগাযোগ এখনো যোগ করা হয়নি !.",
        //content - components - model-confirm-delete	
        "mdlConfDel_confirmation" : "অনুমোদন",
        "mdlConfDel_are_you_sure_delete" : "আপনি কি নিশ্চিত যে আপনি এটি মুছতে চান",
        "mdlConfDel_delete" : "মুছে ফেলা",
        //content - components - model-create-content-group	
        "mdlCrtConGrp_alert_enter_group_title" : "গোষ্ঠী শিরোনাম প্রবেশ করুন",
        "mdlCrtConGrp_alert_enter_group_description" : "গোষ্ঠী বিবরণ লিখুন",
        "mdlCrtConGrp_group_name" : "গোষ্ঠী নাম",
        //content - components - model-upload-doc	
        "mdlUpldoc_alert_enter_title_doc" : "দস্তাবেজের শিরোনাম লিখুন দয়া করে",
        "mdlUpldoc_upload_document" : "দস্তাবেজগুলি আপলোড করুন",
        "mdlUpldoc_document_title" : "নথির শিরোনাম",
        "mdlUpldoc_upload_doc_from_system" : "আপনার সিস্টেম থেকে দস্তাবেজ আপলোড করুন, এটি .পিডিএফ, এক্সেল, ওয়ার্ড ডকুমেন্ট সমর্থন করে।",
        "mdlUpldoc_upload_doc" : "দস্তাবেজ আপলোড করুন",
        "mdlUpldoc_added_doc" : "যুক্ত নথি",
        //content - components - model-upload-media	
        "mdlUplMedia_alert_enter_title_media" : "মিডিয়া শিরোনাম লিখুন দয়া করে",
        "mdlUplMedia_alert_enter_title_url" : "দয়া করে শিরোনাম এবং ইউ-আর-এল লিখুন",
        "mdlUplMedia_alert_enter_youtube_vimeo_url": "দয়া করে বৈধ এবং ইউআরএল প্রবেশ করুন (ইউটিউব / ভিমেও)",
        "mdlUplMedia_upload_media" : "মিডিয়া আপলোড করুন",
        "mdlUplMedia_upload_url" : "আপলোড ইউ-আর-এল",
        "mdlUplMedia_Upload_media_system" : "মিডিয়া আপলোড করে আপনার সিস্টেম, এটি .jpg, .png, .jpeg, .mp3, .mp4 সমর্থন করে",
        "mdlUplMedia_add_media_url" : "মিডিয়া সংযুক্ত করতে মিডিয়া  ইউ-আর-এল ঠিকানা যুক্ত করুন",
        "mdlUplMedia_upload_media_url" : "মিডিয়া ইউ-আর-এল আপলোড করুন",
        "mdlUplMedia_upload_youtube_url" : "দ্রষ্টব্য: ইউটিউব ইউ-আর-এল আপলোড করুন",
        "mdlUplMedia_Add_media_file" : "মিডিয়া ফাইল যুক্ত করা হয়েছে",
        
        //content - managecontent - index	
        // "mngContent_content" : "বিষয়বস্তু ",
        "mngContent_participants" : "অংশগ্রহণকারীরা",
        "mngContent_grade_settings" : "শ্রেণী সেটিংস",
        
        //content - index	
        "content_all_content_group" : "সমস্ত বিষয়বস্তু  শ্রেণী",
        "create_new_group" : "গোষ্ঠী গঠন",
        "content_no_group_created" : "এখনও কোনও গোষ্ঠী তৈরি করা হয়নি!",
        "content_create_new_group" : "একটি নতুন গোষ্ঠী তৈরি করুন, তৈরি করতে উপরের গোষ্ঠী বোতামটি ক্লিক করুন",

        //ContentShare - contentList
        "conList_all_group" : "সমস্ত গোষ্ঠী",
        "conList_content_list" : "সামগ্রীর তালিকাগুলি",
        "conList_no_content_created" : "এখনও কোনও সামগ্রী তৈরি করা হয়নি!",
        //contentShare - grouplist	
        "grpList_all_content_group" : "সমস্ত বিষয়বস্তু  গোষ্ঠী",
        "grpList_no_group_created" : "এখনও কোনও গোষ্ঠী তৈরি করা হয়নি!",

        //ContentShare - questionStepper	
        "queStepper_cant_skip" : "ঐচ্ছিক নয় এমন কোনও পদক্ষেপ আপনি এড়িয়ে যেতে পারবেন না।",
        "queStepper_back" : "পেছনে",
        "queStepper_next" : "পরবর্তী",
        "queStepper_skip" : "এড়িয়ে",
        "queStepper_finish" : "শেষ",
        "queStepper_submit_next" : "জমা দিন এবং পরবর্তী",
        //contentshare - showContent	
        "conList_content_list" : "সামগ্রী তালিকা",
        "showCont_document" : "কাগজপত্র",
        "showCont_previous" : "আগে",
        "showCont_next" : "পরবর্তী",
        "showCont_have_completed_topic" : "আমি এই বিষয়বস্তুতে বিষয়গুলি সম্পূর্ণ করেছি",
        //contentShare - showMedia
        "showMedia_page" : "পৃষ্ঠা",
        "showMedia_of" : "এর",
        "showMedia_previous" : "পূর্ববর্তী",

        //contentShare - showquestions	
        "showQues_min_left" : "মিনিট বাকি",
        "showQues_completed_test" : "আপনি এই প্রশ্নাবলীতে পরীক্ষা শেষ করেছেন।",
        "showQues_go_back_content_group" : "বিষয়বস্তু  গোষ্ঠীতে ফিরে যান",
        //contentShare - viewUserScore	
        "viewUserScore_view_score" : "স্কোর দেখুন",
        "viewUserScore_total_marks" : "মোট চিহ্ন:",
        "viewUserScore_scored_marks" : "স্কোরড মার্কস:",
        "viewUserScore_GPA_score" : "আপনার জিপিএ স্কোর:",
        "viewUserScore_below_list_of_answer" : "নীচে এই বিষয়বস্তু গোষ্ঠীর সমস্ত প্রশ্নাবলীর জন্য উত্তরগুলির তালিকা দেওয়া হল।",
        "viewUserScore_answered" : "উত্তর",
        "viewUserScore_correct_answer" : "সঠিক উত্তর",

        //schedule - components	
        //ConfirmCancelInvite	
        "confCancle_confirmation" : "অনুমোদন",
        "confCancle_are_you_sure" : "তুমি কি নিশ্চিত?",
        "confCancle_delete_user" : "ব্যবহারকারী মুছুন",
        //confirmscheduledelete	
        "confSche_are_you_sure_delete" : "আপনি কি এই সময়সূচিটি মুছে ফেলার বিষয়ে নিশ্চিত?",
        "confSche_no" : "না",
        //PastMeetingitem	
            // "pastMtnItem_rn" : "আর এন",
            // "pastMtnItem_room_name" : "রুমর নাম: ",
            // "pastMtnItem_webinar_list" : "ওয়েবিনার তালিকা",
            // "pastMtnItem_list_webinar" : "নীচে ওয়েবিনার গুলির তালিকা রয়েছে.",
            // "pastMtnItem_today" : "আজ",
            // "pastMtnItem_webinar_title_falls" : "ওয়েবিনার শিরোনাম এখানে পড়ে",
            // "pastMtnItem_view" : "দৃশ্য",
            // "pastMtnItem_upcoming" : "আসন্ন",

        //SchedulesView	
        //"scheView_edit_content" : "সামগ্রী সম্পাদনা করুন",
        "scheView_scheduled_by" : "তফসিল অনুসারে: ",
        "scheView_delete" : "মুছে ফেলা",
        "scheView_download_calander" : "ক্যালেন্ডার ডাউনলোড করুন",
        "scheView_invite_participants" : "অংশগ্রহণকারীদের আমন্ত্রণ জানান",
        "scheView_start_conference" : "সম্মেলন শুরু করুন",
        "scheView_event_details" : "অনুষ্ঠানের বিবরণ",
        "scheView_room_name" : "রুমর নাম",
        "scheView_minutes" : "সভার মিনিট",
        "scheView_conference_password" : "সম্মেলনের পাসওয়ার্ড",
        "scheView_settings" : "সেটিংস",
        "scheView_webinar_event" : "ওয়েবিনার ঘটনা",
        "scheView_list_webinar" : "ইনস্টাভ্যাক.কম / ওয়েবিনারে এই ওয়েবিনারের ইভেন্টটিকে তালিকাবদ্ধ করুন এবং নিবন্ধগুলি স্বীকার করুন।",
        "scheView_guest_login_anonymous" : "অতিথি অনামী হিসাবে লগ ইন করতে পারেন",
        "scheView_allow_invities" : "সম্মেলনে যোগদানের জন্য কেবলমাত্র আমন্ত্রণগুলিকে অনুমতি দিন",
        "scheView_enable_webinar_chat" : "ওয়েবিনার চ্যাট সক্ষম করুন",
        "scheView_enable_hand_rise" : "ওয়েবিনারে হ্যান্ড রাইজ সক্ষম করুন",
        "scheView_list_of_people_invited" : "নীচে আমন্ত্রিত ব্যক্তির তালিকা রয়েছে",
        "scheView_alert_err_to_join" : "যোগ দিতে ভুল করা",
        //WebinarDetails	
        "webnrDtls_upcoming_webinar_room" : "নীচে এই ঘরের জন্য আসন্ন ওয়েবিনার রয়েছে।",
            // Webinar 1
            // Webinar 2
            // Webinar 3
        "webnrDtls_webinar_details" : "ওয়েবিনার বিবরণ",
        "webnrDtls_webinar_list" : "ওয়েবিনার তালিকা",
        "webnrDtls_webinar_title" : "ওয়েবিনার শিরোনাম",
        "webnrDtls_webinar_title_falls" : "ওয়েবিনার শিরোনাম এখানে পড়ে",
        "webnrDtls_get_more_joining" : "এই ওয়েবিনারে যোগদান করে আরও পান।",
        "webnrDtls_join_webinar" : "ওয়েবিনারে যোগদান করুন",
        //webinarList	
        "webnrList_webinar_list" : "ওয়েবিনার তালিকা",
        "webnrList_below_list_of_webinar" : "নীচে ওয়েবিনারগুলির তালিকা রয়েছে।",
        "webnrList_today" : "আজ",
        "webnrList_webinar_title_falls" : "ওয়েবিনার শিরোনাম এখানে পড়ে",
        "webnrList_view" : "দৃশ্য",
        "webnrList_upcoming" : "Upcoming",
            
        //schedule - 	
        //ঠিকানাBook	
        "addBook_address_book" : "বইয়ের ঠিকানা",
        "addBook_contact" : "বিষয়বস্তু",
        "addBook_add_contact_to_meeting" : "আপনার ঠিকানা বইয়ের পরিচিতিগুলি থেকে বৈঠকে পরিচিতি যুক্ত করুন",
        //MeetingList	
        "meetingList_past_meetings" : "অতীত সভা",
        "meetingList_past_meetings_list" : "বিগত সভাগুলির তালিকা",
        "meetingList_room_name" : "রুমর নাম: ",
        "meetingList_view_content" : "সামগ্রী দেখুন",
        "meetingList_recording" : "রেকর্ডিং",
        "meetingList_view" : "দৃশ্য",
        //scheduleInvite	
        "scheInvt_err_invalid_id" : "অবৈধ ইমেল আইডি",
        "scheInvt_invite_participants" : "অংশগ্রহণকারীদের আমন্ত্রণ জানান",
        "scheInvt_address_book" : "বইয়ের ঠিকানা",
        "scheInvt_invite_people_to_meeting" : "এই সভায় লোকদের আমন্ত্রণ জানান। আপনার ঠিকানা থেকে বা ইমেল ঠিকানা টাইপ করে লোকদের যুক্ত করুন।",
        "scheInvt_start" : "শুরু @ ",
        "scheInvt_below_list_of_answer" : "নীচে এই বিষয়বস্তু গোষ্ঠীর সমস্ত প্রশ্নাবলীর জন্য উত্তরগুলির তালিকা দেওয়া হল।",
        "scheInvt_host" : "নিমন্ত্রণকর্তা:",
        "scheInvt_minutes" : "মিনিট",
            //Webinar 1
        "scheInvt_add" : "একত্রিত করা",
        "scheInvt_no_participants_added" : "কোনও অংশগ্রহণকারী যুক্ত হয়নি",
        "scheInvt_add_ppl_to_meetings" : "আপনার ঠিকানা পুস্তক থেকে অংশগ্রহীতা হিসাবে এই সভায় লোককে যুক্ত করুন, বা অনুসন্ধান দ্বারা যুক্ত করুন।",
        "scheInvt_send_invitation" : "আগমনবার্তা পাঠান",
        "scheInvt_send_passcodes" : "পৃথক মেইলে পাসকোডগুলি প্রেরণ করুন।",

        //Invitation - component - invitationbody	
        "invitBody_invite_only_upto" : "আপনি কেবল 10 জনকে আমন্ত্রণ জানাতে পারেন",
        "invitBody_invite_ppl_meeting_email_add" : "এই সভায় লোকদের আমন্ত্রণ জানান, আপনার ঠিকানা পুস্তক থেকে লোক যুক্ত করুন বা ইমেল ঠিকানার মাধ্যমে যুক্ত করুন",
        "invitBody_copy" : "প্রতিলিপি",
        "invitBody_enter_emailid" : "ইমেল আইডি প্রবেশ করান",
        "invitBody_close" : "সমাপ্ত করা",
        "invitBody_send_invitation" : "আগমনবার্তা পাঠান",

        //documentShare 	
        //index,js	
        "docShare_doc_sharing" : "নথি শেয়ারিং কর",
        "docShare_upload_doc_system_pdf" : "আপনার সিস্টেম থেকে দস্তাবেজ আপলোড করুন, এটি পি ডি এফ, এক্সেল, ওয়ার্ড ডকুমেন্ট সমর্থন করে।",
        "docShare_upload_doc" : "দস্তাবেজ আপলোড করুন",
        "docShare_no_doc" : "কোনও দস্তাবেজ নেই",
        "docShare_no_doc_in_list" : "তালিকায় এখনও কোনও নথি যুক্ত হয়নি।",
        "docShare_add_doc" : "দস্তাবেজ যোগ করা হয়েছে",
        "docShare_alert_title_doc" : "দস্তাবেজের শিরোনাম লিখুন দয়া করে",
        "docShare_alert_something_went_wrong" : "কিছু ভুল হয়েছে আবার চেষ্টা করুন",
        //components - PermitDocShare	
        "permitDocShr_permit_doc_share_access" : "অনুমতি দস্তাবেজ ভাগ প্রবেশ",
        "permitDocShr_req_permission_doc_share" : "দস্তাবেজ ভাগ প্রবেশ করার অনুমতি অনুরোধ করেছে।",
        "permitDocShr_deny" : "অস্বীকার করা",
        "permitDocShr_allow" : "অনুমতি দিন",
        //components - RequestDocShare	
        "reqDocShr_req_doc_share_access" : "দস্তাবেজ ভাগ প্রবেশ অনুরোধ",
        "reqDocShr_access_permission_host" : "দস্তাবেজ ভাগ করে নেওয়া সক্ষম করার জন্য, আপনাকে নিমন্ত্রণকর্তার কাছ থেকে প্রবেশ এর অনুমতি প্রয়োজন।",
        "reqDocShr_plz_wait" : "দয়া করে অপেক্ষা করুন",
        "reqDocShr_permission_start_doc_share" : "(নিমন্ত্রণকর্তা) দস্তাবেজ ভাগ করে নেওয়া শুরু করার অনুমতি।",
        "reqDocShr_doc_share" : " দস্তাবেজ ভাগ!",
        //components - ShowDocument View	
        "showDocViewback" : "পিছনে",
        "showDocViewdoc_title_name" : "নথির শিরোনামের নাম",
        "showDocViewnext" : "পরবর্তী",
        "showDocViewprevious" : "পূর্ববর্তী",

        //Broadcast - 	
        //boradcastScreenShare	
        "borcstScreen_alert_unsupported" : "অসমর্থিত প্লে অর্ডারটির অনুরোধ করা হয়েছে। সমর্থিত ফর্ম্যাটগুলি হ'ল ওয়েবার্টিসি এবং এইচএলএস। প্লে অর্ডার = ওয়েবার্টিসি, এইচএলএস এর মতো কিছু ব্যবহার করুন",
        "borcstScreen_alert_no_stream_spec" : "কোনও স্ট্রিম নির্দিষ্ট করা হয়নি ইউ-আর-এল টিতে আইডি={স্ট্রিম _ আইডি} যুক্ত করুন",
        "borcstScreen_Plz_enable_js" : "এই ভিডিওটি দেখতে দয়া করে জাভাস্ক্রিপ্ট সক্ষম করুন এবং একটি ওয়েব ব্রাউজারে আপগ্রেড করার কথা বিবেচনা করুন",
        "borcstScreen_support_HTML5" : "HTML5 ভিডিও সমর্থন করে",
        "borcstScreen_steam_play_when_live" : "ভিডিও স্ট্রিমটি লাইভ হলে প্লে হবে",
        //broadcast	
        "broadcast_alert_unsupported" : "অসমর্থিত প্লে অর্ডারটির অনুরোধ করা হয়েছে। সমর্থিত ফর্ম্যাটগুলি হ'ল ওয়েবার্টিসি এবং এইচ এল এস। প্লেঅর্ডার = ওয়েবার্টিসি, এইচ এল এস এর মতো কিছু ব্যবহার করুন",
        "broadcast_alert_no_stream_spec" : "কোনও স্ট্রিম নির্দিষ্ট করা হয়নি। যোগ করুন ?আইডি={স্ট্রিম _ আইডি}ইউ-আর-এল তে",
        "broadcast_enter_your_name" : "তোমার নাম প্রবেশ করাও",
        "broadcast_enter_your_email" : "আপনার ইমেল প্রবেশ করুন",
        "broadcast_user_details" : "ব্যবহারকারীর বৃত্যান্ত",
        "broadcast_submit_next" : "জমা দিন",
        "broadcast_Plz_enable_js" : "এই ভিডিওটি দেখতে দয়া করে জাভাস্ক্রিপ্ট সক্ষম করুন এবং একটি ওয়েব ব্রাউজারে আপগ্রেড করার কথা বিবেচনা করুন",
        "broadcast_support_HTML5" : "HTML5 ভিডিও সমর্থন করে",
        "broadcast_steam_play_when_live" : "ভিডিও প্রবাহটি যখন লাইভ হবে তখন প্লে হবে",
        //broadcastConference	
        "brdcstConf_whiteboard" : "হোয়াইটবোর্ড",
        "brdcstConf_screen_share" : "স্ক্রিন শেয়ার",
        // "brdcstConf_participants" : "অংশগ্রহণকারীদের",
        "brdcstConf_broadcast" : "সম্প্রচার করা",
        "brdcstConf_right" : "সরাসরি",
        //broadcast - component	
        //broadcasterParicipants	
        "brdcstPart_broadcast_list" : "সম্প্রচারক তালিকা",

        //Containers - calender	
        //index	
        "calender_scheduled_calendar" : "সময়সূচী ক্যালেন্ডার",
        "calender_select_all" : "সমস্ত নির্বাচন করুন",
        "calender_calender" : "ক্যালেন্ডার",
        "calender_daily" : "দৈনন্দিন",
        "calender_weekly" : "সাপ্তাহিক",
        "calender_month" : "মাস",
        "calender_today" : "আজ",

        //Dashboard - componenet	

        //MeetingReminder	
        "meetReminder_scheduled_confirm" : "সময়তালিকা নিশ্চিতকরণ",
        "meetReminder_meeting_has_been_scheduled" : "নিম্নলিখিত বৈঠক এই মুহূর্তে নির্ধারিত হয়েছে",
        "meetReminder_start_meeting" : "এই সভাটি শুরু করুন",
        "meetReminder_join_meeting" : "এই সভায় যোগদান করুন",
        "meetReminder_quick_start_another_meeting" : "দ্রুত আর একটি সভা শুরু করুন",
        //MyMeetingItem	
        "myMeetItem_start" : "শুরু",
        "myMeetItem_for" : "জন্য",
        "myMeetItem_minutes" : "মিনিট",
        "myMeetItem_host" : "নিমন্ত্রণকর্তা: ",
        //MyMeeting	
        "myMeet_my_meetings" : "আমার সভা",
        "myMeet_search_my_meetings" : "আমার সভা সন্ধান করুন",
        //NoScheduledMeeting	
        "noScheMeet_no_meeting_scheduled" : "কোনও সভা নির্ধারিত হয়নি",
        "noScheMeet_no_upcoming_meetings" : "আপনার কোনও আসন্ন বৈঠক এখনও নির্ধারিত নেই। আপনি একটি নতুন সময়সূচি তৈরি করতে বা এখনই আপনার সম্মেলনটি দ্রুত শুরু করতে পারেন।",
        "noScheMeet_create_schedule" : "সময়তালিকা তৈরি করুন",
        "noScheMeet_quick_start" : "দ্রুত শুরু",
        "noScheMeet_or" : "অথবা",
        //RoomSettings	
        "roomSet_alert_select_license" : "অনুগ্রহ করে লাইসেন্সটি নির্বাচন করুন",
        "roomSet_manage_licenses" : "লাইসেন্স পরিচালনা করুন",
        "roomSet_package" : "প্যাকেজ",
        "roomSet_no_of_rooms" : "রুমের সংখ্যা",
        "roomSet_no_of_user" : "ব্যবহারকারীর সংখ্যা",
        "roomSet_purchased_on" : "ক্রয় করা হয়েছে",
        "roomSet_expired_on" : "মেয়াদোত্তীর্ণ",
        "roomSet_create_room" : "রুম তৈরি করুন",


        //conference - component	
        //AddSipDevice	
        "addSipDev_add_sip_details" : "SIP বিশদ যুক্ত করুন",
        "addSipDev_sip_address" : "SIP ঠিকানা:",
        "addSipDev_connect" : "যুক্ত করা",
        "addSipDev_enter_sip_address" : "SIP ঠিকানা প্রবেশ করান",
        //ConfNotification	
        "confNotf_notification" : "বিজ্ঞপ্তিগুলি",
        "confNotf_user_name" : "ব্যবহারকারীর নাম",
        "confNotf_want_to_join" : "এই সভা রুমে যোগদান করতে চায়",
        "confNotf_allow" : "অনুমতি দিন",
        "confNotf_deny" : "অস্বীকার করা",
        "confNotf_ask_question" : "একটি প্রশ্ন জিজ্ঞাসা।",
        "confNotf_send_msg_lobby" : "প্রবেশরুম থেকে একটি বার্তা প্রেরণ।",
        //Loddy	
        "lobby_participants_loddy" : "লবিতে অংশগ্রহণকারীরা",
        "lobby_pramote_all" : "সব প্রচার করুন",
        "lobby_user_name" : "ব্যবহারকারীর নাম",
        //RemoveUserDialog	
        "removeUserDlg_manage_user_selecting" : "এই বিকল্পগুলির যে কোনও একটি নির্বাচন করে এই ব্যবহারকারীকে পরিচালনা করুন:",
        "removeUserDlg_user_name" : "ব্যবহারকারীর নাম",
        "removeUserDlg_block_participant" : "অংশগ্রহণকারীকে বাধা দেত্তয়া",
        "removeUserDlg_send_to_lobby" : "লবিতে প্রেরণ করুন",
        "removeUserDlg_remote_participant" : "অংশগ্রহণকারীকে সরান",
        "removeUserDlg_close" : "সমাপ্ত করা",
        //participantsList	
        "PartList_participants_in_lobby" : "প্রবেশরুম এ অংশগ্রহণকারীরা",
        "PartList_alert_something_went_wrong" : "কিছু ভুল হয়েছে আবার চেষ্টা করুন",
        "PartList_in_webinar" : "ওয়েবিনারে",
        "PartList_promote_all" : "সমস্ত প্রচার করুন",
        //participants2020	Retry
        //WaitingRoom	
        "waitingRoom_waiting_room" : "বিশ্রামাগার",
        "waitingRoom_plz_wait_host_allow" : "হোস্ট আপনাকে সম্মেলনে যোগদানের অনুমতি না দেওয়া পর্যন্ত অপেক্ষা করুন।",
        "waitingRoom_chat" : "চ্যাট",
        "waitingRoom_mins" : "মিনিট",
        "waitingRoom_no_msg_yet" : "কোনও বার্তা নেই, এখনও!",
        "waitingRoom_no_msg_from_host" : "হোস্টের কোনও বার্তা নেই।",
        //userRemoved	
        "userRemoved_you_removed_by_host" : "আপনাকে হোস্ট দ্বারা অংশগ্রহণকারীদের তালিকা থেকে সরানো হয়েছে", 
        //invitationSlide	
        "invitSlide_invite" : "আমন্ত্রণ করা",
        "invitSlide_add_email" : "ইমেলগুলি যোগ করুন",
        "invitSlide_add" : "যোগ",
        "invitSlide_broadcast_list" : "সম্প্রচার লিঙ্ক",
        "invitSlide_invite_people_to_meeting" : "এই সভায় লোকদের আমন্ত্রণ জানান। লোকদের ইমেল ঠিকানা টাইপ করে যোগ করুন এবং একটি আমন্ত্রণ প্রেরণ করতে তালিকায় যুক্ত করুন।",
        "invitSlide_err_invalid_id" : "অবৈধ ইমেল আইডি",
        //participantsChat	
        "particiChat_no_chat_msg" : "এখনও কোনও চ্যাট বার্তা নেই!",
        "particiChat_start_conversation" : "এখানে বার্তা দেখতে কথোপকথন শুরু করুন.",

        
        //components - lobbyparticipants	
        "lobbyPartici_no_participants" : "অংশগ্রহণকারীরা নেই",
        "lobbyPartici_no_participants_lobby" : "লবিতে কোনও অংশীদার নেই।",


        //conference	
        //simulcast	
        "simulcast_alert_decline_access" : "নিমন্ত্রণকর্তা প্রবেশ প্রত্যাখ্যান করেছে",
        "simulcast_invalid_url" : "অবৈধ ইউ-আর-এল",
        "simulcast_no_host_available" : "এই মুহুর্তে কোনও নিমন্ত্রণকর্তা উপলব্ধ নেই বলে মনে হচ্ছে, দয়া করে স্ক্রিনটি ভাগ করে নেওয়ার জন্য নিমন্ত্রণকর্তা হন",
        //simulcastVAD & // Conference.js	
        "conference_access_to_participants" : "অংশগ্রহণকারীদের প্রবেশ",
        "conference_screen_share" : "স্ক্রিন শেয়ার",
        "conference_chat" : "চ্যাট",
        "conference_lock_all" : "সব বন্ধ",
        "conference_lock_conf" : "সম্মেলন তালাবদ্ধ",
        "conference_become_host" : "নিমন্ত্রণকর্তা হয়ে উঠুন",
        "conference_you_are_host" : "আপনিও একজন নিমন্ত্রণকর্তা হয়ে উঠুন",
        "conference_share" : "ভাগ",
        "conference_document_share" : "কাগজপত্রের অংশ",
        "conference_content_share" : "বিষয়বস্তু ভাগ",
        "conference_more" : "আরও ...",
        "conference_become_host" : "নিমন্ত্রণকর্তা হন",
        "conference_alert_no_host_aval_screen" : "এই মুহুর্তে কোনও নিমন্ত্রণকর্তা উপলব্ধ নেই বলে মনে হচ্ছে, দয়া করে স্ক্রিনটি ভাগ করে নেওয়ার জন্য নিমন্ত্রণকর্তা হন",
        "conference_alert_no_host_aval_doc" : "এই মুহুর্তে কোনও হোস্ট উপলভ্য দেখাচ্ছে না, দয়া করে দস্তাবেজটি ভাগ করে নেওয়ার জন্য হোস্ট হন",
        "conference_alert_err_sip_device" : "সিপ ডিভাইস সংযোগ করার সময় ভুল",
        "conference_alert_host_decline_access" : "নিমন্ত্রণকর্তা প্রবেশ প্রত্যাখ্যান করেছে",
        "conference_alert_invalid_url" : "অবৈধ ইউ-আর-এল",	
        "conference_unmute_mic_start_talk" : "কথা শুরু করার জন্য আপনার মাইক্রোফোনটি সশব্দ করুন",

        // tools	
        "confTools_new_whiteboard" : "আপনার নতুন হোয়াইটবোর্ড এখানে আসে ",
        "confTools_video_sync" : "আপনার ভিডিও সিঙ্ক",
        "confTools_microphone" : "মাইক্রোফোন",
        "confTools_type_text_here" : "আপনার পাঠ্য টাইপ করুন ...",
        "whiteboard" : "হোয়াইটবোর্ড",

        //meetingRecording	
        "meetRec_video_rec_meeting_name" : "সভার নামের ভিডিও রেকর্ডিং",
        "meetRec_page_view" : "পাতা দেখুন:",
        //meetingRecording- recordinglistview	
        "recListView_title_name_rec" : "রেকর্ডিংয়ের শিরোনামের নাম",
        "recListView_name_user" : "ব্যবহারকারীর নাম",




        // /////////////////////////////////////////////////////////////////////
        //Src	
        //component - common - BrowserUpgrade	
        "brwUpg_req_fun_not_avail" : "প্রয়োজনীয় কার্যকারিতা আপনার ব্রাউজারে উপলব্ধ নয়",
        "brwUpg_meeting_req_fun_sup" : "এই সভা পরিষেবাটির ফ্যানকেশনালটির প্রয়োজন আপনার ব্রাউজার দ্বারা সমর্থিত নয়।",
        "brwUpg_plz_upgrade" : "দয়া করে আপগ্রেড করুন, অন্য কোনও ব্রাউজারে স্যুইচ করুন বা আপনার সেটিংস পরীক্ষা করুন। সমর্থিত ব্রাউজারগুলি:",
        //"    Samsung Internet
        //component - common - header - header.js	
        "header_content" : "সূচীপত্র (বিটা)",
        "header_loading" : "লোড হচ্ছে ...",
        
        //containers/admin/plans/components/createPlan.js	
        "crtePln_plz_enter_name" : "প্ল্যানের নাম লিখুন",
        "crtePln_plz_amount_Plan" : "প্ল্যানের পরিমাণ প্রবেশ করুন",
        "crtePln_plz_enter_des" : "বর্ণনা লিখুন",
        "crtePln_Plz_sel_product" : "পণ্য নির্বাচন করুন",
        "crtePln_plz_sel_no_host" : "দয়া করে নিমন্ত্রণকর্তার নম্বরটি নির্বাচন করুন।",
        "crtePln_plz_enter_no_participants" : "অংশগ্রহণকারীদের সংখ্যা লিখুন",
        "crtePln_plz_enter_roomno" : "রুম সংখ্যা লিখুন",
        "crtePln_select_period" : "সময়কাল নির্বাচন করুন",
        "crtePln_sel_interval" : "বিরতি নির্বাচন করুন",
        "crtePln_update_succ" : "সফলভাবে আপডেট হয়েছে ",
        "crtePln_err_creating_plan" : "পরিকল্পনা তৈরির ক্ষেত্রে ভুল",

        //containers/broadcast/components/BroadcastHandRaise.js	
        "brdcRaise_alert_question_50_char" : "আপনার প্রশ্নের ন্যূনতম 50 টি অক্ষরের চ্যাট হওয়া উচিত",
        //containers/conference/components/components	
        "cofCom_no_part_lobby" : "লবিতে কোনও অংশীদার নেই।",
        //containers/conference/components/ConfirmUserDetails.js	
        "confmUser_plz_provide_name_email" : "আপনার নাম এবং ইমেল প্রদান করুন",
        "confmUser_notes" : "মন্তব্য",
        //containers/conference/ConferenceSetup.js 	
        "confSetup_telepresence" : "টেলি উপস্থিতি",
        "confSetup_alert_not_generate_meetingID" : "মিটিং আইডি তৈরি করতে সক্ষম নয়, কিছুক্ষণ পরে চেষ্টা করুন ",
        "confSetup_auth_part_can_join" : "শুধুমাত্র অনুমোদিত অংশগ্রহণকারীরা যোগ দিতে পারবেন !.",
        "confSetup_invalid_link" : "অবৈধ লিঙ্ক",
        "confSetup_meeting_notyet_started" : "এই সভাটি এখনও শুরু হয়নি। দয়া করে পরে যোগদান করুন! আপনি যদি নিমন্ত্রণকর্তা হন তবে অনুগ্রহ করে ইন্সটা ভিসিতে লগইন করুন এবং সভাটি শুরু করুন",
        "confSetup_meeting_locked_byhost" : "এই সভাটি নিমন্ত্রণকর্তা দ্বারা লক করা আছে",
        "confSetup_meeting_notyet_started_wait_host" : "এই সভাটি এখনও শুরু হয়নি। মিটিং শুরু করার জন্য  নিমন্ত্রণকর্তার জন্য অপেক্ষা করুন!",
        //containers/conference/components/NewChat.js",
        "newChat_panel_chat" : "প্যানেল চার্ট",
        //containers/conference/libs/InstaVC.js 	
        "instaVc_server_busy" : "দেখে মনে হচ্ছে সার্ভার ব্যস্ত! অন্য সার্ভারকে সংযুক্ত করার চেষ্টা করা হচ্ছে ...",
        //"    load-message",
        "instaVc_server_busy_reload_tojoin" : "দেখে মনে হচ্ছে সার্ভার ব্যস্ত! সম্মেলন যোগ দিতে পুনরায় লোড করুন",
        "instaVc_broadcast_scr_failed" : "ব্রডকাস্ট স্ক্রিন ব্যর্থ",
        "instaVc_broadcast_failed" : "সম্প্রচার ব্যর্থ",
        "instaVc_waiting_for_host" : "নিমন্ত্রণকর্তার ভিডিওটির জন্য অপেক্ষা করা হচ্ছে",
        //containers/content/components/contentQuestionnaire/modal-create-quest-group.js 	
        "modlCreate_plz_enter_title" : "শিরোনাম লিখুন দয়া করে",
        "modlCreate_poll" : "ভোটগ্রহণ",
        //containers/content/components/contentQuestionnaire/modal-create-poll-question.js	
        "mdlCretPoll_plz_enter_quest" : "প্রশ্ন লিখুন",
        "mdlCretPoll_option_should_not_same" : "বিকল্পগুলি একই হওয়া উচিত নয়",
        "mdlCretPoll_plz_enter_option" : "বিকল্পগুলি লিখুন",
        "mdlCretPoll_plz_select_type_option" : "বিকল্পগুলির ধরণটি নির্বাচন করুন",
        "alert_server_error" : "অভ্যন্তরীণ সার্ভার ভুল, দয়া করে আবার চেষ্টা করুন",
        "mdlCretPoll_update_ques" : "আপডেট প্রশ্ন",
        "mdlCretPoll_create_ques" : "Create Question",
        "mdlCretPoll_enter_que_here" : "আপনার প্রশ্ন এখানে লিখুন",
        "mdlCretPoll_end" : "সমাপ্ত",
        //containers/content/components/contentQuestionnaire/viewQuestionnaire.js	
        "delete_successfully" : "সফলভাবে মোছা হয়েছে",

        //containers/content/components/hozContentNavBlock.js / managecontent-index.js	
       // "mngContent_mngContent_content" : "বিষয়বস্তু",
        // "mngContent_mngContent_participants" : "অংশগ্রহণকারীরা",
        "mngContent_mngContent_fav_prog_lang" : "আপনার প্রিয় প্রোগ্রামিং ভাষা কোনটি?",
        "mngContent_mngContent_pollings" : "ভোটদান",
        

        //containers/contentShare/showQuestions.js 	
        "showQue_obtained_marks" : "প্রাপ্ত চিহ্ন:",
        //containers/contentShare/viewUserScore.js	
        "viewUser_your_grade" : "আপনার শ্রেণী:",
        //containers/packages/Package.js	
        "package_one_host" : "1 হোস্ট এবং",
        //"package_participants" : "অংশগ্রহণকারীরা",
           // SOHO
        //"    SMB 300
        "package_concurrentUser_room2" : "20 সমকালীন ব্যবহারকারী - 2 রুম",
        "package_concurrentUser_room5" : "30 সমকালীন ব্যবহারকারী -5 রুম",
        "package_concurrentUser_room20" : "100 সমকালীন ব্যবহারকারী - 20 টি রুম",
        "package_concurrentUser_room30" : "200 সমকালীন ব্যবহারকারী - 30 টি রুম",
        "package_concurrentUser_room50" : "500 Concurrent Users – 50 Rooms",

        //containers/schedule/components/PastMeetingItem.js	
        "pastMeeting_rn" : "আর এন",
        "pastMeeting_chat_history_deleted" : "চ্যাট ইতিহাস সফলভাবে মোছা হয়েছে",
        "pastMeeting_past_meeting_dtls" : "অতীত সভার বিবরণ",
        "pastMeeting_duration" : "স্থিতিকাল:",
        "pastMeeting_download_parti_atten" : "অংশগ্রহণকারী এবং অংশগ্রহণকারীদের ডাউনলোড করুন",
        "pastMeeting_download_webinar" : "ওয়েবিনার ডাউনলোড করুন",
        // "pastMeeting_participants" : "অংশগ্রহণকারীরা",
        "pastMeeting_attendees" : "অংশগ্রহণকারীগণ",
        "pastMeeting_chat_history" : "কথোপকথনের ইতিহাস",
        "pastMeeting_recordings" : "রেকর্ডিং",
        "pastMeeting_webinar_user" : "ওয়েবিনার ব্যবহারকারীরা",
        "pastMeeting_webinar_chat" : "ওয়েবিনার চ্যাট",
        "pastMeeting_no_participants_in_meeting" : "এই সভায় কোনও অংশগ্রহণকারী নেই!",
        "pastMeeting_no_parti_attended_meeting" : "এই সভায় অংশ নেওয়া কোনও অংশগ্রহণকারী ছিল না।",
        "pastMeeting_guest_list" : "অতিথি তালিকা",
        "pastMeeting_no_guest_in_meeting" : "এই সভায় কোনও অতিথি নেই!",
        "pastMeeting_no_guests_were_invited " : "এই সভায় আমন্ত্রিত বা উপস্থিত ছিলেন এমন কোনও অতিথি ছিলেন না।",
        "pastMeeting_meeting_chat_history" : "চ্যাট ইতিহাসের সভা",
        "pastMeeting_delete_all" : "সব মুছে ফেলুন",
        "pastMeeting_no_chat_msg_inmeeting" : "এই সভায় কোনও চ্যাট বার্তা নেই!",
        "pastMeeting_no_conver_during_meeting" : "বৈঠকের সময় কোনও কথোপকথন হয়নি।",
        "pastMeeting_no_user_inwebinar" : "এই ওয়েবিনারে কোনও ব্যবহারকারী নেই!",
        "pastMeeting_no_user_attand_webinar" : "এই ওয়েবিনারে কোনও ব্যবহারকারী নেই!",
        "pastMeeting_webinar_chat_history" : "ওয়েবিনার চ্যাট ইতিহাস",
        "pastMeeting_no_chat_msg_inwebinar" : "এই ওয়েবিনারে কোনও চ্যাট বার্তা নেই!",
        "pastMeeting_no_conver_during_webinar" : "ওয়েবিনারের সময় চ্যাটে কোনও কথোপকথন হয়নি।",
        "pastMeeting_del_chat_history" : "চ্যাট ইতিহাস মুছুন",
        "pastMeeting_delete_all_chat_history" : "আপনি কি নিশ্চিত আপনি স্থায়ীভাবে সমস্ত চ্যাট ইতিহাস মুছতে চান?",
        "pastMeeting_delete" : "মুছে ফেলা",
        //containers/schedule/components/Schedules.js	
        "schedul_webinar_description" : "ওয়েবিনার বর্ণনা",
        "schedul_upload_custom_banner" : "আপনার ওয়েবিনার ইভেন্টের জন্য একটি কাস্টম ব্যানার আপলোড করুন।",
        "schedul_setting" : "সেটিংস",
        //containers/schedule/components/SchedulesView.js	
        "schedulView_time" : "সময়",
        "schedulView_edit" : "সম্পাদন করা",
        "schedulView_enable_training_mode" : "প্রশিক্ষণ প্রণালী সক্ষম করুন",
        "schedulView_audio_conference" : "অডিও সম্মেলন",
        "schedulView_enable_mix_video" : "ডিফল্ট দ্বারা মিক্স ভিডিও সক্ষম করুন",
        
        //class components
        //content - components - hozContentNavBlock	
        // "hozConNav_content" : "বিষয়বস্তু",
        //scheduleMeeting	
        "scheMeet_room_reserved_from" : "রুম থেকে সংরক্ষিত ",
        "scheMeet_meeting_name" : "সভার নাম সহ",
        //dashboard - component -Contact	
        "contact_alert_already_in_call" : "আপনি অন্য ব্যবহারকারীকে কল করতে পারবেন না, আপনি যখন ইতিমধ্যে কল করছেন তখন",
        "contact_alert_user_offline" : "ব্যবহারকারী অফলাইন",
        //dashboard - dashboard.js	
        "dashboard_alert_cannot_start" : "আপনি অন্য কল এলে আপনি সম্মেলন শুরু করতে পারবেন না",
        "dashboard_alert_cannot_join" : "আপনি যখন অন্য কলে থাকবেন তখন আপনি সম্মেলনে যোগ দিতে পারবেন না",
        "dashboard_quick_start_conf" : "দ্রুত শুরু সম্মেলন",
        "dashboard_maintenance_msg" : "দয়া করে মনে রাখবেন যে আমরা রুটিন রক্ষণাবেক্ষণের কারণে ২০২০ সালের ২২ শে এপ্রিল 8..৩০ পিএম থেকে রাত ৯.০০ টা পর্যন্ত সার্ভার ডাউনটাইমের অভিজ্ঞতা অর্জন করব। ",
        //coBrowsing	
        "coBrows_host_share-video" : "অনুগ্রহপূর্বক অপেক্ষা করুন! নিমন্ত্রণকর্তা একটি ভিডিও ভাগ করে নিতে চলেছে",
        //Additionalcamera	
        "addCam_add_device" : "যন্ত্র সংযুক্ত করুন",

        // genral same lang
        "answer_list" : "উত্তর তালিকা",
        "answer" : "উত্তর",
        "answered" : "প্রতু্যত্তর দেত্তয়া",
        "correct_answer" : "সঠিক উত্তর",
        "please_try_again" : "অনুগ্রহপূর্বক আবার চেষ্টা করুন",
        "question" : "প্রশ্ন",
        "cancel" : "বাতিল",
        "questionnaire" : "প্রশ্নাবলী",
        "content" : "বিষয়বস্তু",
        "ঠিকানা_book" : "ঠিকানা বই",
        "view" : "দৃশ্য",
        "rn" : "আর এন",

        // new langs
        "plz_enter_marks" :"প্রশ্নের চিহ্ন লিখুন দয়া করে",
        "plz_sel_crtans" : "অনুগ্রহ করে উত্তরটি নির্বাচন করুন",
        "truefalse_choice" : "সত্য / মিথ্যা পছন্দ",
        "questionnarie" : "জরিপ",
        "content_title" : "সামগ্রীর শিরোনাম",
        "media_title" : "মিডিয়া_ শিরোনাম",
        "add_url_add" : "ইউ-আর-এল ঠিকানা যোগ করা...",
        "val_shuld_grtr_from_val" : "মান থেকে মান হতে হবে",
        "val_shuld_grtr_grade" : " মান থেকে শ্রেণী বড় হওয়া উচিত ",
        "to_val" : "মূল্যনির্ণয় করা",
        "enable_hand_raise" : "কোনও ওয়েবিনারে হ্যান্ড রাইজ / প্রশ্ন জিজ্ঞাসা সক্ষম করুন",
        "enable_waiting_room" : "অপেক্ষার রুম সক্ষম করুন",
        "allow_only_invite" : "শুধুমাত্র আমন্ত্রিতদের সম্মেলনে যোগদানের অনুমতি দিন",
        "guest_login_anonymous" : "অতিথি অনামী হিসাবে লগইন করতে পারেন",
        "give_name_webinar" : "আপনার ওয়েবিনারে একটি নাম দিন",
        "Webinar" : "ওয়েবিনার",
        "video_syn" : "ভিডিও সিঙ্ক",
        "notepad" : "নোটপ্যাড",
        "enable_handraise" : "কোনও ওয়েবিনারে হ্যান্ড রাইজ সক্ষম করুন",
        //new one venkatesh
        "polls_list" : "পোলের তালিকা",
        "no_poll_assign" : "এখনও কোন পোল বরাদ্দ করা হয়নি!",
        "poll_view" : "ভোটগ্রহণ দেখুন",

        // new Prudhvi
        "filter_block": "ফিল্টার ব্লক",
        "file_size": "ফাইলের আকার",
        "select_room": "দয়া করে একটি ঘর নির্বাচন করুন",
        "provide_event_name": "একটি ইভেন্ট নাম প্রদান করুন",
        "end_time_greater_start_time": "শেষ সময় অবশ্যই শুরু সময়ের চেয়ে বেশি হওয়া উচিত!",
        "invite_people_meeting": "এই সভায় লোকদের আমন্ত্রণ জানান",
        "download_ical": "আই সিএল ডাউনলোড করুন",
        "download": "ডাউনলোড",
        "delete_meeting": "এই সভাটি মুছুন",
        "room": "রুম ",
        "new_event": "New Event",
        "end_repeat": "শেষ পুনরাবৃত্তি",
        "invite_users_timezone": "নিম্নলিখিত সময় অঞ্চল সঙ্গে ব্যবহারকারীদের আমন্ত্রণ",
        "update_event": "আপডেট ইভেন্ট",
        "create_event": "ইভেন্ট তৈরি করা",
        "wrong_password": "ভুল গোপন নম্বর",
        "college": "কলেজ",
        "university": "বিশ্ববিদ্যালয়",
        "country": "দেশ",
        "time_period": "সময় কাল:",
        "currently_working_here": "বর্তমানে এখানে কাজ",
        "from": "হইতে:",
        "to": "প্রতি:",
        "graduated": "Graduated",
        "enter_description": "আপনার বিবরণ এখানে প্রবেশ করুন ...",
        "concentration": "একাগ্রতা",
        "school": "বিদ্যালয়",
        "poll_question": "ভোটের প্রশ্ন",
        "create_poll_ques": "পোল প্রশ্ন তৈরি করুন",
        "options": "পছন্দমতো",
        "no_ques_assigned_yet": "এখনও কোন প্রশ্ন বরাদ্দ করা হয়নি!",
        "create_new_ques_click_create_ques": "উপরের প্রশ্নোত্তর তৈরি করুন বোতামটি ক্লিক করতে একটি নতুন প্রশ্ন তৈরি করুন",
        "enter_room_name": "রুম নাম লিখুন",
        "billed_annually": "* বার্ষিক বিল",
        "subscribe_now": "এখন সাবস্ক্রাইব করুন",
        "group": "গোষ্ঠী",
        "sample_webinar": "নমুনা ওয়েবিনার",
        "webinar_affiliate": "অনুমোদিত সম্পর্কিত সম্পর্কে ওয়েবিনার",
        "webinar_one": "ওয়েবিনার ওয়ান ",
        "workspace": "কর্মস্থান",
        "company": "প্রতিষ্ঠান",
        "add_another": "অন্য একটি যোগ করুন",

        "instavc_login_email":"ই-মেইল",
        "instavc_signup_email":"ই-মেইল",
        "instavc_signup_email_error":"ই-মেইলটি সঠিক বিন্যাস হওয়া উচিত",
        "instavc_forgotpassword_email":"আপনার নিবন্ধিত ই-মেইল ঠিকানা লিখুন",
        "conference_myrooms_sethost_email":"নিজেকে নিমন্ত্রণকর্তা হিসাবে সেট করুন, বা কোনও নিমন্ত্রণকর্তা হিসাবে তাকে তৈরি করতে কোনও ব্যবহারকারীর ই-মেইল ঠিকানা প্রবেশ করুন।",
        "conference_myrooms_email":"ই-মেইল ঠিকানা",
        "conference_setup_invitebyemail":"মেল করে আমন্ত্রণ করুন",
        "conference_setup_invite_enteremail":"আপনার অংশগ্রহণকারীদের আমন্ত্রণ জানাতে পছন্দসই ই-মেইল ঠিকানা লিখুন",
        "conference_setup_invite_emailid":"ই-মেইল ঠিকানা",
        "conference_troubleshoot_emailreport":"ই-মেইল প্রতিবেদন ",
        "conference_troubleshoot_ipaddress":"আইপি ঠিকানাগুলি দেখানোর জন্য ক্লিক করুন",
        "conference_setup_invite_byemail":"মেল করে আমন্ত্রণ করুন",
        "insta_conference_enteremail":"মেল আইডি প্রবেশ করান ",
        "instavc_package_billingdetails_address":"ঠিকানা",
        "instavc_package_shippingdetails_address":"ঠিকানা",
        "instavc_package_email":"ই-মেইল",
        "instavc_package_enteremail":"দয়া করে একটি বৈধ ই-মেইল আইডি লিখুন। উদাহরণ: you@example.com",
        "instavc_myprofile_email":"ই-মেইল",
        "instavc_myprofile_professionaldetails_email":"ই-মেইল",
        "instavc_myprofile_contactinformation_address":" ঠিকানা",
        "instavc_admin_email_verified":"ইমেইল যাচাই",
        "instavc_branchname":"ব্যাংক শাখার নাম",
        "instavc_site_webaddress":"আপনি সঠিক ওয়েব ঠিকানা পেয়েছেন তা নিশ্চিত করুন",
        "instavc_otherhost_email":"আপনি যদি কোনও ব্যবহারকারীকে নিমন্ত্রণকর্তা হিসাবে তৈরি করতে চান তবে তার ইমেল ঠিকানা প্রবেশ করুন।",
        "instavc_enter_valid_email":"বৈধ ইমেল প্রবেশ করুন",
        "verify_email":"আপনার ইমেইল যাচাই করুন",
        "mdlAccRight_add_people_from_addressbok":"আপনার ঠিকানা বই থেকে বা ই-মেইল ঠিকানা টাইপ করে লোকদের যুক্ত করুন।",
        "address_book":"ঠিকানা বই",
        "pastMeeting_notes":"মন্তব্য",
        "assignment":"নির্ধারিত",
        "assignments":"নির্ধারিত কার্য",
        "create_new_poll":"বরাদ্দকরণ শুরু করতে একটি নতুন ভোটগ্রহণ প্রশ্ন তৈরি করুন।",
        "plz_title_url":"শিরোনাম এবং url লিখুন দয়া করে",
        "votes":"ভোট",
        "enter_content_title":"দয়া করে সামগ্রীর শিরোনাম প্রবেশ করান",
        "failed_result":"ব্যর্থ ফলাফল",
        "removed_successfully":"সফলভাবে সরানো হয়েছে",
        "enter_duration":"সময়কাল লিখুন দয়া করে",
        "select_questionnarie":"প্রশ্নাবলী নির্বাচন করুন",
        "no_assignments":"কোনও নির্ধারিত কার্য নেই",
        "create_new_assignment":"উপরোক্ত  নির্ধারিত কার্য বোতামটি ক্লিক করতে তৈরি করতে একটি নতুন  নির্ধারিত কার্য তৈরি করুন",
        "create_assignment":"নির্ধারিত কার্য তৈরি করুন",
        "assignments_list":"নির্ধারিত কার্য তালিকা",
        "assignment_description":"নির্ধারিত কার্য বিবরণ",
        "assignment_name":"নির্ধারিত কার্য নাম",
        "update_assignment":"নির্ধারিত কার্য আপডেট করুন",
        "add_new_assignment":"নতুন নির্ধারিত কার্য যুক্ত করুন",
        "assignment_list":"নির্ধারিত কার্য তালিকা",
        "assign_assignments":"বরাদ্দকরণ",
        "assigned_assignments_list":"বরাদ্দ করা কার্য তালিকা",
        "assignment_answer":"বরাদ্দ করা কার্য উত্তর",
        "no_assig_submitted":" এখনও কোনও বরাদ্দ করা কার্য জমা দেওয়া হয়নি।",
        "no_assig_submitted_participants":"কোনও অংশগ্রহণকারীদের কাছ থেকে এখনও কোনও বরাদ্দ করা কার্য জমা দেওয়া হয়নি।",
        "view_assignment":"নির্ধারিত কার্য দেখুন",
        "assigned_participants":"অংশগ্রহণকারীদের বরাদ্দ",                                
        "select_assignment":"নির্ধারিত কার্য নির্বাচন করুন",
        "fill_your_assignment":"আপনার নির্ধারিত কার্য পূরণ করুন",
        "submit_assignment":"নির্ধারিত কার্য জমা দিন",
        "assignment_details":"নিয়োগের বিশদ",
        "assignment_submit_success":"নির্ধারিত কার্য সফলভাবে জমা দেওয়া হয়েছে",
        "assignment_saved_success" : "কার্যভার সাফল্যের সাথে সংরক্ষণ করা হয়েছে saved",
        "how_to_get_started":"কিভাবে শুরু করেছিল.",
        "create_new_room":"নতুন ঘর তৈরি করুন",
        "create_room_add_participants":"একটি নতুন রুম তৈরি করুন এবং রুমে অংশগ্রহণকারীদের যুক্ত করুন।",
        "repeats_every":"প্রতিটি পুনরাবৃত্তি",
        "now":"এখন",
        "Plz_enter_title_meeting":"সভার শিরোনাম লিখুন দয়া করে",
        "no_start_time":"কোনও শুরুর সময় পাওয়া যায় নি",
        "no_end_time":"কোন শেষ সময় পাওয়া যায় নি",
        "item_id_not_found":"পদ পরিচয় পাওয়া যায় নি",
        "msg_title_not_found":"বার্তা শিরোনাম পাওয়া যায় নি",
        "plz_join_conf_clicking_link":"নিম্নলিখিত লিঙ্কে ক্লিক করে সম্মেলনে যোগদান করুন",
        "hi_there":"হাই-সেখানে",
        "room_permanently":"স্থায়ীভাবে রুম?",
        "sure_want_to_delete_participants":"আপনি কি নিশ্চিত যে আপনি এই অংশগ্রহণকারীকে মুছতে চান?",
        "delete_participant":"অংশগ্রহণকারীকে মুছুন",
        "add_email":"ইমেল যুক্ত করুন",
        "add_participants_to_the_room":"নীচের ইনপুট বাক্সে অংশগ্রহণকারীদের ইমেল ঠিকানা টাইপ করে এই ঘরে যোগ করুন।",
        "no_of_users":"ব্যবহারকারীর সংখ্যা নেই",
        "edit_the_name":"আপনি নামটি এবং এই ঘরের ব্যবহারকারীর সংখ্যা সম্পাদনা করতে পারেন।",
        "delete_room":"ঘর মুছুন",
        "are_you_sure_delete":"আপনি মুছে ফেলতে চান",
        "delete_this_room":"এই ঘরটি মুছুন",
        "delete_room_will_parmanently":"মুছুন ক্লিক করে, এই ঘরটি নির্লজ্জভাবে মুছে ফেলা হবে।",
        "enable_storage":"সঞ্চয়স্থান সক্ষম করুন",
        "enable_recordings":"রেকর্ডিং সক্ষম করুন",
        "enable_SIP":"SIP সক্ষম করুন",
        "addons":"যোগ করুন",
        "expires_on":"মেয়াদ শেষ",
        "purchased_on":"ক্রয় করা হয়েছে",
        "more_storage":"আরও সঞ্চয়স্থান",
        "total_storage":"মোট সঞ্চয়স্থান",
        "storage_occupied":"সংগ্রহস্থল দখল",
        "added":"যোগ করা হয়েছে",
        "open_graphs":"গ্রাফগুলি খুলুন",
        "participant_controls":"অংশগ্রহণকারী নিয়ন্ত্রণ",
        "dashboard_controls ":"ড্যাশবোর্ড নিয়ন্ত্রণ",
        "start_meeting":"একটি সভা শুরু করুন",
        "join_a_meeting":"একটি সভায় যোগদান করুন",
        "meeting_settings":"সভা সেটিংস",
        "videos_to_get_started":"ভিডিওগুলি শুরু করার জন্য",
        "if_you_are_host":"আপনি যদি নিমন্ত্রণকর্তা হন তবে সভাটি শুরু করতে নীচের বোতামটি ক্লিক করুন",
        "guest_link":"অতিথি লিঙ্ক",
        "pay_now":"এখন পরিশোধ করুন",
        "promo_code_apply_here":"একটি প্রচার কোড আছে? এখানে আবেদন করুন",
        "per_month":"প্রতি মাসে",
        "billed_for":"বিল এর জন্য",
        "gst_applicable":"সরকারী নীতিমালার সাথে সম্মতি অনুসারে ভারতে গ্রাহকদের জন্য অতিরিক্ত 18% জিএসটি প্রযোজ্য হবে।",
        "select_country_code":"দেশ কোড নির্বাচন করুন",
        "country_code":"দেশের কোড",
        "enter_email_id":"ইমেল আইডি প্রবেশ করান ...",
        "downLoad_chat":"ডাউনলড চ্যাট",
        "allow_guest_control_their":"অতিথিকে তাদের ভিডিও / অডিও নিয়ন্ত্রণ করতে অনুমতি দিন",
        "below_list_people_invited":"নীচে আমন্ত্রিত ব্যক্তির তালিকা রয়েছে",
        "verification_code":"যাচাইকরণের কোড",
        "open_link_enter_verify_code":"নীচের URL লিঙ্কটি খুলুন এবং একীকরণের জন্য আপনার যাচাইকরণ কোডটি প্রবেশ করুন",
        "social_media_integration":"সোশ্যাল মিডিয়া মিশ্রণ",
        "integrate_social_media_platform":"আপনি সোশ্যাল মিডিয়া প্ল্যাটফর্মগুলিকে সংহত করতে পারেন, একটি বোতামে ক্লিক করে আপনি যাচাইকরণ কোড পাবেন, এটি সংহতকরণের জন্য ব্যবহার করবেন।",
        "plz_enter_val_email":"অনুগ্রহ করে আপনার সঠিক মেইল ​​আইডি প্রবেশ করান",
        "record":"নথি",
        "in_conference":"সম্মেলনে",
        "password_if_any":"পাসওয়ার্ড (যদি থাকে)",
        "stop_send":"বন্ধ করুন এবং প্রেরণ করুন",
        "broadcast_not_enabled_meeting":"এই সভার জন্য সম্প্রচার সক্ষম নয়",
        "facebook_url":"ফেসবুক URL",
        "enter_facebook_url":"ফেসবুক RTMB URL প্রবেশ করুন",
        "add_facebook_url":"ফেসবুক যুক্ত করুন RTMP URL",
        "youtube_url":"ইউটিউব URL",
        "enter_youtube_url":"ইউটিউব RTMB URL প্রবেশ করান",
        "add_youtube_url":"ইউটিউব RTMB URL যোগ করুন",
        "register":"নিবন্ধন",
        "time_of_program":"কার্যক্রম সময়",
        "date_of_program":"কার্যক্রমের তারিখ",
        "name_program_interested":"আগ্রহী প্রোগ্রামের নাম",
        "email_id":"ই-মেইল আইডি",
        "dob":"জন্ম তারিখ",
        "applicant_address":"আবেদনকারীর ঠিকানা",
        "qualification":"যোগ্যতা",
        "designation":"উপাধি",
        "org_name_address":"প্রতিষ্ঠানের নাম ও ঠিকানা",
        "fullname_participant":"অংশগ্রহণকারীদের পুরো নাম",
        "registration_form":"নিবন্ধন ফর্ম",
        "thanks_submitting_data":"আপনার তথ্য জমা দেওয়ার জন্য ধন্যবাদ",
        "manage_content":"সামগ্রী পরিচালনা করুন",
        "API_settings":"API সেটিংস",
        "schedule_API":"সময়তালিকা API",
        "image_upload_success":"চিত্র সফলভাবে আপলোড হয়েছে",
        "less_than_10MB":"দয়া করে 10মেগাবাইট এর চেয়ে কম ফাইল আপলোড করুন",
        "at_time_of_event":"ইভেন্টের সময়",
        "min_5":"5 মিনিট আগে",
        "min_10":"10 মিনিট আগে",
        "min_15":"15 মিনিট আগে",
        "min_30":"30 মিনিট আগে",
        "hrs_1":"1 ঘন্টা আগে",
        "hrs_2":"2 ঘন্টা আগে",
        "day_1":"1 দিন আগে",
        "day_2":"2 দিন আগে",
        "jan":"জানুয়ারী",
        "feb":"ফেব্রুয়ারি",
        "mar":"মার্চ",
        "apr":"এপ্রিল",
        "may":"মে",
        "jun":"জুন",
        "jul":"জুলাই",
        "aug":"আগস্ট",
        "sep":"সেপ্টেম্বর",
        "oct":"অক্টোবর",
        "nov":"নভেম্বর",
        "dec":"ডিসেম্বর",
        "mon":"সোম",
        "tue":"মঙ্গল",
        "wed":"বুধ",
        "thu":"বৃহঃ",
        "fri":"শুক্র",
        "sat":"শনি",
        "sun":"রবি",
        "all_day":"সারাদিন",
        "starts_ddmmyyyy":"শুরু (dd/mm/yyyy)",
        "ends_ddmmyyyy":"শেষ (dd/mm/yyyy)",
        "ddmmyyyy":"(dd/mm/yyyy)",
        "by_dayweek":"দিন / সপ্তাহে",
        "never":"না",
        "on_date":"তারিখ",
        "alert":"সতর্ক",
        "multi_factor_auth" : "মাল্টি ফ্যাক্টর প্রমাণীকরণ (MFA) সক্ষম করুন",
        "advanced_settings" : "উন্নত সেটিংস",
        "verify_Otp" : "ওটিপি যাচাই করুন",
        "resend_Otp" : "ওটিপি পুনরায় পাঠান",
        "otp_sent_mobile" : "আপনার মোবাইল নাম্বারে প্রেরিত ওটিপি প্রবেশ করান",
        "update_mobile" : "মোবাইল আপডেট করুন",
        "verify_mobile" : "মোবাইল যাচাই করুন",
        "mob_verfi_pending" : "আপনার মোবাইল যাচাইকরণ মুলতুবি রয়েছে।",
        "mobile_number" : "মোবাইল নম্বর",
        "enter_Otp" : "ওটিপি প্রবেশ করান",
        "enter_mob_no" : "মোবাইল নম্বর লিখুন দয়া করে",
        "sure_want_to_delete_rec" : "আপনি কি নিশ্চিত রেকর্ডিং মুছতে চান",
        "delete_recording" : "রেকর্ডিং মুছুন",
        "invalid_credentials" : "Invalid Credentials",
        "join_conf_by_clicking_link" : "নিম্নলিখিত লিঙ্কে ক্লিক করে সম্মেলনে যোগদান করুন",
        "hi_there" : "হাই!,",
        "valid_room_name" : "বৈধ কক্ষের নাম লিখুন",
        "internal_server_error" : "অভ্যন্তরীণ সার্ভার ভুল, আবার চেষ্টা করুন",
        "room_limit_exceed" : "ঘরের সীমা অতিক্রম করেছে",
        "cant_start_meeting_already_goingon" : "ইতিমধ্যে একটি সভা চলছে বলে আপনি কোনও সভা শুরু করতে পারবেন না।",

        //new
        "social_integration" : "সামাজিক একীকরণ",
        "advanced" : "অগ্রসর",
        "add_youtube" : "ইউটিউব যুক্ত করুন",
        "plugins" : "প্লাগইন",
        "subtitles" : "সাবটাইটেল",
        "view_local" : "স্থানীয় দেখুন",
        "hide_local" : "স্থানীয় লুকান",
        "switch_conf_mode" : "কনফারেন্স মোডে স্যুইচ করুন",
        "switch_pres_mode" : "উপস্থাপক মোডে স্যুইচ করুন",
        "conference_locked" : "সম্মেলন লকড",
        "conference_unlocked" : "সম্মেলন আনলক করা হয়েছে",
        "sharing_tools" : "ভাগ করে নেওয়ার সরঞ্জাম",
        "record" : "নথি",
        "recording" : "রেকর্ডিং",
        "plz_wait_host_shr_video" : "অনুগ্রহপূর্বক অপেক্ষা করুন! হোস্টটি একটি ভিডিও শেয়ার করতে চলেছে",
        "supported_sources_include" : "সমর্থিত উত্স অন্তর্ভুক্ত",

        "team_plugins" : "টিম প্লাগইনস",
        "open" : "খোলা",
        "click" : "ক্লিক",
        "more_app" : "আরো অ্যাপ্লিকেশান",
        "upload_custom_app" : "কাস্টম অ্যাপ আপলোড করুন",
        "download_team_plugin" : "টিম প্লাগইন ডাউনলোড করুন",
        "install_mng_app_microsoft_team" : "মাইক্রোসফ্ট টিমে অ্যাপ্লিকেশন ইনস্টল এবং পরিচালনা করবেন",
        "microsoft_step1" : "পদক্ষেপ 1: মাইক্রোসফ্ট টিম খুলুন",
        "microsoft_step1_para1" : "শুরু করার জন্য, প্রথমে আপনাকে এই পৃষ্ঠার শীর্ষে উপলব্ধ আপনার সিস্টেমে টিম প্লাগইন ডাউনলোড করতে হবে। তারপরে আপনার মাইক্রোসফ্ট টিমগুলি খুলুন এবং চয়ন করুন",
        "microsoft_step1_para2" : " টিম অ্যাপ্লিকেশনগুলি দেখতে পাশের নেভিগেশন থেকে বিকল্পগুলি।",
        "microsoft_step2" : "পদক্ষেপ 2: আরও অ্যাপ্লিকেশনগুলিতে যান",
        "microsoft_step2_para1" : "এখানে আপনি আরও অ্যাপস নামের একটি বোতাম সহ কয়েকটি অ্যাপ্লিকেশন খুঁজে পেতে পারেন। ক্লিক করুন",
        "microsoft_step2_para2" : "কাস্টম আপলোড বিকল্প এবং অন্যান্য স্টোর বিকল্পগুলির জন্য আরও পরীক্ষা করতে।",
        "microsoft_step3" : "পদক্ষেপ 3: অ্যাপ্লিকেশন আপলোড করুন",
        "microsoft_step3_para1" : "আপনি একবার স্টোরটি খোলার পরে আপনি একটি খুঁজে পেতে পারেন",
        "microsoft_step3_para2" : " বাম নেভিগেশন বিকল্প। এটিতে ক্লিক করুন এবং আপনার ডাউনলোড প্লাগইন অ্যাপটি এখানে আপলোড করুন।",
        "microsoft_step4" : "পদক্ষেপ 4: স্টোরেজ থেকে ইন্সটাভিসি অ্যাপ নির্বাচন করুন",
        "microsoft_step4_para1" : "উইন্ডোটি যখন অনুরোধ জানাবে, তখন আপনার সিস্টেম থেকে ইনস্টাটিভিসি প্লাগইন অ্যাপ্লিকেশনটি সিলেক্ট করুন (পদক্ষেপ 1) এবং ক্লিক করুন",
        "microsoft_step5" : "পদক্ষেপ 5: মাইক্রোসফ্ট টিমে আপলোড করা অ্যাপ",
        "microsoft_step5_para1" : "ফাইলটি আপলোড করার পরে এটি মাইক্রোসফ্ট টিমের অ্যাপ্লিকেশন তালিকায় আপলোড হয়ে যায়। তারপরে আপনি এটি দেখতে এবং টিমে এটি যুক্ত করতে অ্যাপ্লিকেশনটিতে ক্লিক করতে পারেন। ",
        "microsoft_step6" : "পদক্ষেপ:: ইন্সটাভিসি অ্যাপ খুলুন",
        "microsoft_step6_para1" : "একবার আপনি ইন্সটাভিসি অ্যাপ্লিকেশনটিতে ক্লিক করুন, আপনি এখন একটি বোতামের সাথে প্লাগইন অ্যাপ্লিকেশনটির সম্পূর্ণ বিবরণ দেখতে পারবেন ",
        "microsoft_step6_para2" : "মাইক্রোসফ্ট টিমে এই অ্যাপ্লিকেশনটি যুক্ত করতে বোতামটি।",
        "microsoft_step7" : "পদক্ষেপ:: মাইক্রোসফ্ট টিমে ইন্সটাভিসি যুক্ত হয়েছে",
        "microsoft_step7_para1" : "এখন আপনার অ্যাপটি সহজ এবং স্বনির্ধারিত ব্যবহারের জন্য বাম পাশের নেভিগেশনে মাইক্রোসফ্ট দলগুলিতে যুক্ত করা হবে।",


        "ddyymm" : "DD/MM/YYYY",
        "fill_details_for_webinar" : "ওয়েবিনারের জন্য আপনার নিবন্ধকরণের বিশদটি এখানে পূরণ করুন",
        "microsoft_teams" : "মাইক্রোসফ্ট টীমস",
        "microsoft_outlook" : "মাইক্রোসফ্ট আউটলুক",
        "select_the_plan" : "দয়া করে পরিকল্পনাটি নির্বাচন করুন",
        "enter_company_code" : "দয়া করে কোম্পানির কোড দিন",
        "enter_code" : "কোডটি প্রবেশ করান",
        "enter_valid_coupon_code" : "বৈধ কুপন কোড প্রবেশ করুন",
        "coupon_alreadt_taken" : "এই কুপন কোডটি ইতিমধ্যে নেওয়া হয়েছে",
        "error_updating_plan" : "পরিকল্পনা আপডেট করার সময় ত্রুটি",
        "unit" : "একক",
        "referrals" : "প্রচার",
        "sel_coupon" : "দয়া করে কুপন নির্বাচন করুন",
        "share_val_0_99" : "শেয়ার মান 0 থেকে 99 এর মধ্যে হওয়া উচিত",
        "enter_share_val" : "দয়া করে শেয়ারের মানটি প্রবেশ করান",
        "valid_commission_per" : "বৈধ কমিশন শতাংশ লিখুন দয়া করে",
        "enter_commission_per" : "দয়া করে কমিশন শতকরা প্রবেশ করুন",
        "enter_commission_name" : "দয়া করে কমিশনের নাম লিখুন",
        "sync_successfully" : "ব্যবহারকারীদের সফলভাবে সুসংগত",
        "room_deleted_suc" : "ঘর সফলভাবে মোছা হয়েছে",
        "lic_deleted_suc" : "লাইসেন্স সফলভাবে মোছা হয়েছে",
        "female" : "মহিলা",
        "male" : "পুরুষ",
        "insta_conference" : "ইন্সটা কনফারেন্স",
        "quick_meeting_by" : "দ্রুত সভা দ্বারা",
        "in_lobby" : "লবিতে",
        "switch_to_broadcast" : "সম্প্রচারে স্যুইচ করুন",
        "Broadcasters_5" : "সম্প্রচারক (5)",
        "Participants_5" : "অংশগ্রহণকারীরা (5)",
        "search_participants" : "অংশগ্রহণকারীদের অনুসন্ধান করুন",
        "host_controls" : "নিমন্ত্রণকর্তা নিয়ন্ত্রণ",
        "deleteroom" : "ঘর মুছে ফেলা",
        "pm" : "অপরাহ্ন",
        "am" : "পূর্বাহ্ণ",
        "email_exist_inroom" : "এই ঘরে ইমেল ইতিমধ্যে বিদ্যমান",
        "type_a_message" : "একটি বার্তা টাইপ করুন ...",
        "please_enter_user_limit" : "দয়া করে ব্যবহারকারীর সীমা প্রবেশ করুন",
        "user_limit_exceeded" : "ব্যবহারকারীর সীমা অতিক্রম করেছে",
        "sel_country_code" : "দয়া করে দেশের কোড নির্বাচন করুন",
        "available_storage" : "উপলব্ধ সঞ্চয়স্থান",
        "enter_phone_number" : "ফোন নম্বর প্রবেশ করান",
        "startdate_less_enddate" : "দয়া করে প্রারম্ভের তারিখটি শেষের তারিখের চেয়ে কম নির্বাচন করুন",
        "havent_add_data" : "আপনি এখনও কোনও ডেটা যুক্ত করেন নি, দয়া করে ডেটা যুক্ত করুন।",
        "professional_skills" : "পেশাগত দক্ষতা",
        "enter_prof_skills" : "পেশাদার দক্ষতা লিখুন",
        "Present_Invitations" : "আমন্ত্রণগুলি উপস্থাপন করুন",
        "sending" : "পাঠানো হচ্ছে ...",
        "sent" : "প্রেরিত",
        "invite_10ppl_only" : "আপনি কেবল 10 জনকে আমন্ত্রণ জানাতে পারেন",
        "join_meeting" : "সভাতে যোগদান করুন",
        "enter_doc_title" : "নথির শিরোনাম প্রবেশ করান",
        "meeting_name" : "সভার নাম",
        "select_the_weeks" : "দয়া করে সপ্তাহগুলি নির্বাচন করুন",
        "grade" : "শ্রেণী",
        "coference_ID" : "সম্মেলন আইডি ...",
        "dont_find_room_meetingid" : "আমরা কোনও সভা খুঁজে পাই না, যা এই মিটিং আইডির সাথে সম্পর্কিত",
        "wireless_share" : "ওয়্যারলেস শেয়ার",
        "video_layout" : "ভিডিও লেআউট",
        "speaker_screen" : "স্পিকার স্ক্রিন",
        "presentation_screen" : "উপস্থাপনা স্ক্রিন",
        "multiple_display" : "একাধিক প্রদর্শন",
        "hellow" : "হ্যালো",
        "enter_passcode" : "পাসকোডটি প্রবেশ করান",
        "another_meeting_stillon" : "অন্য একটি সভা এখনও চলছে, আপনি এখনই এই সভাটি শুরু করতে পারবেন না",
        "SIP_device" : "SIP যন্ত্র",
        "instavc_whiteBoard" : "ইন্সটাভিসি হোয়াইটবোর্ড",
        "speaker" : "বক্তা",
        "instavc_notepad" : "ইন্সটাভিসি নোটপ্যাড",
        "promote_in" : "প্রচার করুন",
        "guest" : "অতিথি",
        "breakout_rooms" : "ব্রেকআউট রুম",
        "stop_broadcast" : "সম্প্রচার বন্ধ করুন",
        "noise_suppress" : "শব্দ দমন",
        "echo_cancel" : "প্রতিধ্বনি বাতিল:",
        "enter_name_here" : "নাম এখানে লিখুন",
        "Viewer" : "দর্শক",
        "SIP_user" : "SIP ব্যবহারকারী",
        "remove_participants" : "অংশগ্রহণকারীদের সরান",
        "disable_audio_video" : "রিমোট অডিও এবং ভিডিও অক্ষম করুন",
        "disable_audio" : "অডিও অক্ষম করুন",
        "enable_audio" : "অডিও সক্ষম করুন",
        "disable_video" : "ভিডিও অক্ষম করুন",
        "enable_video" : "ভিডিও সক্ষম করুন",
        "audio_video" : "অডিও ভিডিও",
        "audio_only" : "কেবল অডিও",
        "video_only" : "কেবলমাত্র ভিডিও",
        "outlook_addins" : "আউটলুক অ্যাড-ইনগুলি",
        "install_microsoft" : "মাইক্রোসফ্ট আউটলুক এ অ্যাড-ইনগুলি ইনস্টল এবং পরিচালনা করবেন",
        "outlook_step1" : "পদক্ষেপ 1: লিঙ্কটি অনুলিপি করুন এবং আউটলুক খুলুন",
        "first_copy_link" : "প্রথমে লিঙ্কটি অনুলিপি করুন",
        "add_plugin_oulook" : "আপনার দৃষ্টিভঙ্গিতে প্লাগইন যুক্ত করতে এখান থেকে।",
        "outlook_step2" : "পদক্ষেপ 2: অ্যাড-ইনগুলি পান",
        "outlook_step2_para" : "এখন আউটলুক খুলুন এবং হোম ট্যাবের নীচে আপনি অ্যাড-ইনগুলি পেতে একটি বিকল্প খুঁজে পেতে পারেন। অ্যাড-ইনগুলি এবং অন্যান্য কাস্টম বিকল্পগুলি দেখতে এটিতে ক্লিক করুন।",
        "outlook_step3" : "পদক্ষেপ 3: আমার অ্যাড-ইনগুলি",
        "outlook_step3_para" : "আপনি এখন বাম নেভিগেশন সহ অ্যাড-ইন পৃষ্ঠা দেখতে পারেন। আপনার অ্যাড-ইনগুলি পরিচালনা করতে আমার অ্যাড-ইনগুলিতে যান।",
        "outlook_step4" : "পদক্ষেপ 4: কাস্টম অ্যাড-ইনগুলি যুক্ত করুন",
        "outlook_step4_para" : "এখানে আপনি আমার অ্যাড-ইন পৃষ্ঠাতে কাস্টম অ্যাড-ইনগুলির অধীনে কাস্টম অ্যাড-ইন কাস্টম অ্যাড-ইন পেতে পারেন। ড্রপ ডাউন থেকে URL থেকে যুক্ত নির্বাচন করুন",
        "outlook_step5" : "পদক্ষেপ 5: URL থেকে ব্যক্তিগত অ্যাড-ইন যুক্ত করুন",
        "outlook_step5_para" : "আপনি এখন ইউআরএল থেকে ব্যক্তিগত অ্যাড-ইন যোগ করার জন্য একটি পপ আপ দেখতে পাচ্ছেন। এখন আপনার অনুলিপি করা লিঙ্কটি (পদক্ষেপ 1) ইনপুট ক্ষেত্রে আটকে দিন এবং ঠিক আছে ক্লিক করুন, যা অ্যাড-ইনটি আউটলুকে ইনস্টল করে। ",
        "outlook_step6" : "পদক্ষেপ 6:: আমার অ্যাড-ইনগুলিতে ইন্সটাভিসি যুক্ত হয়েছে",
        "outlook_step6_para" : "যোগ করার পরে, আপনি আমার আমার অ্যাড-ইন তালিকায় যুক্ত হওয়া অ্যাডটি চেক করতে পারেন। এখান থেকে আপনি আপনার অ্যাড-ইনগুলি আরও পরিচালনা করতে পারবেন।",
        "outlook_step7" : "পদক্ষেপ 7: আউটলুক বন্ধ করুন এবং আবার খুলুন",
        "outlook_step7_para" : "ইনস্টল করার পরে, নিশ্চিত হয়ে নিন যে আপনি একবারে সম্পূর্ণ দৃষ্টিভঙ্গিটি বন্ধ করে দিয়েছেন এবং অ্যাড-ইনটি দেখতে আবার খুলেছেন।",
        "outlook_step8" : "পদক্ষেপ 8: নতুন আইটেমগুলিতে যান",
        "outlook_step8_para" : "দৃষ্টিভঙ্গি খোলার পরে, আপনি এখন নতুন সভাগুলিতে যেতে পারেন এবং # 62; ইন্সটাভিসি দেখার জন্য বৈঠকটি দৃষ্টিভঙ্গিতে যুক্ত হয়েছে।",
        "outlook_step9" : "পদক্ষেপ 9: ইন্সটাভিসি সভা খুলুন",
        "outlook_step9_para" : "একবার আপনি সভাগুলি খোলার পরে, আপনাকে মিটিং ট্যাবটির নীচে শীর্ষ বারে ইন্সটাভিসি সভা সভার অ্যাড-ইন সক্ষম করে একটি রচনা মেল উইন্ডো দিয়ে খোলা হবে।",
        "outlook_step10" : "পদক্ষেপ 10: তফসিল তৈরি করুন",
        "outlook_step10_para" : "রচনা মেল বিন্যাস থেকে, নতুন শিডিউল তৈরি করতে ইনস্টাভ্যাক সভাগুলিতে ক্লিক করুন। এটি প্রথমবার হলে ডানদিকে ইনস্টা-ভিসির সভা লগইন সহ আপনাকে খোলা হবে। ইতিমধ্যে লগ ইন করা ব্যবহারকারীদের জন্য, তারা কক্ষ তালিকায় পরিচালিত হবে এবং একটি সময়সূচি তৈরি করতে পারে।",
        "outlook_step11" : "পদক্ষেপ 11: ইন্সটাভিসি সভা খুলুন",
        "outlook_step11_para" : "আপনি বাম দিকে একটি তফসিল তৈরি করতে পারেন এবং কোনও নির্দিষ্ট ঘরে সভার সময় নির্ধারণের জন্য ডান পাশের একটি ঘর নির্বাচন করতে পারেন। একবার আপনি একটি তফসিল তৈরি করার পরে, আপনি এখনই মিটিং শুরু করুন বোতামটি দেখতে পাবেন। এখান থেকে আপনি ক্লিক করতে পারেন এবং সভাটি শুরু করতে পারেন।",
        "outlook_step12" : "পদক্ষেপ 12: ক্যালেন্ডারে সময়সূচী দেখুন",
        "outlook_step12_para" : "একবার আপনি সময়সূচী তৈরি করার পরে, পরের বার আপনি ক্যালেন্ডারটি খুললে, আপনি ক্যালেন্ডারে আপনার সময়সূচিগুলিও দেখতে পারেন।",
        "outlook_step13" : "পদক্ষেপ 13: তফসিল তৈরি হয়েছে",
        "outlook_step13_para" : "একবার আপনি একটি তফসিল তৈরি করার পরে, তারপরে আপনি ডান পাশে স্টার্ট মিটিং বোতামের সাথে রচিত মেলটি দেখতে পাবেন।",
        "sel_declaration" : "দয়া করে ঘোষণাটি নির্বাচন করুন",
        "enter_company_code" : "দয়া করে কোম্পানির কোড দিন",
        "invalid_company_code" : "অবৈধ কোম্পানির কোড",
        "affiliate_acc" : "আপনার অনুমোদিত অ্যাকাউন্ট অনুমোদনের জন্য মুলতুবি রয়েছে।",
        "aff_acc_approved" : "আপনার অনুমোদিত অ্যাকাউন্ট অনুমোদিত হয়েছে।",
        "aff_acc_rej" : "আপনার অনুমোদিত অ্যাকাউন্ট বাতিল করা হয়েছে।",
        "aff_TC" : "অনুমোদিত শর্তাদি এবং শর্তাদি",
        "ref_par_agreement" : "রেফারেল পার্টনার চুক্তি",
        "aff_partner_agreement" : 'এই অংশীদার চুক্তি, এই কভার পেজ এবং সংযুক্ত ব্যবসায়ের শর্তাদি (সম্মিলিতভাবে, এই "চুক্তি") দ্বারা গঠিত এবং পিপললিংক ইউনিফাইড যোগাযোগ প্রাইভেট লিমিটেডের (পিপললিঙ্ক হিসাবে পরিচিত) এবং এর মধ্যে অংশীদার বা খ ইউব। "অংশীদার" বা "আপনি" অর্থ সেই ব্যক্তি বা সংস্থাকে (কোম্পানির নাম এবং অন্যান্য তথ্য সহ) জমা দেওয়া ফর্মটিতে বিশদ বিবরণ। চুক্তিটি বাধ্য হয়ে উঠবে একবার আপনি এই চুক্তিটির স্বীকৃতি জানানোর জন্য রেফারেল পার্টনার প্রোগ্রাম ফর্ম ("ফর্ম") জমা দিন এবং জমা দিন। পিপল লিঙ্ক এবং অংশীদারকে কখনও কখনও "পার্টি" হিসাবে এবং "দলগুলি" হিসাবে চিহ্নিত করা হয়।"',
        "background" : "পটভূমি",
        "aff_market_advertise" : 'পিপল লিঙ্ক ইন্সটাভিসি ইউনিফাইড যোগাযোগ পরিষেবা এবং সমাধান সরবরাহ করে। অংশীদার এই চুক্তি অনুসারে, পিপললিঙ্ক পণ্যগুলি এবং সম্ভাব্য পিপললিঙ্ক গ্রাহকদের ("রেফারালস") এর ওয়েবসাইটগুলির (গুলি) এবং অন্যান্য বিপণন চ্যানেলের মাধ্যমে প্রচার করার, বাজারজাতকরণ এবং বিজ্ঞাপনের বিজ্ঞাপন চায়।', 
        "agreement" : "চুক্তি",
        "aff_parties_agree" : "দলগুলি নিম্নরূপে একমত:",
        "heading1" : "প্রোগ্রাম কমিটি",
        "heading2" : "যোগ্য প্রচারের, মন্তব্য।",
        "heading3" : "শব্দ এবং পরিসমাপ্তি.",
        "heading4" : "সাধারণ",
        "the_program" : "কার্যক্রম.",
        "to_participate_program_partner" : 'প্রোগ্রামে অংশ নিতে অংশীদারকে অবশ্যই পিপল লিঙ্ক বা এর সম্পর্কিত ওয়েবসাইটগুলিতে ("সাইট") পাওয়া প্রোগ্রামে অংশ গ্রহণের জন্য অনলাইন অ্যাপ্লিকেশনটি সম্পূর্ণ করতে হবে এবং এই চুক্তিটি লিখতে হবে। পিপল লিঙ্ক কোনও নিজস্ব আবেদন বিবেচনা করে গ্রহণ বা বাতিল করতে পারে',
        "aff_str11" : "আইনী চুক্তি",
        "aff_str12" : "প্রচার, রেফারাল ক্রিয়াকলাপ:",
        "aff_str13" : "নিষিদ্ধ কার্যক্রম।",
        "aff_str14" : "পিপললিঙ্ক চিহ্নগুলির অনুমতিযোগ্য ব্যবহার",
        "aff_str15" : "বাধ্যবাধকতা",
        "aff_str16" : "গ্রাহক সম্পর্ক",
        "aff_str11_para" : "প্রোগ্রামে অংশ নেওয়ার অংশ হিসাবে এবং পিপললিংক এর অংশীদার হিসাবে অভিনয় করার জন্য অংশীদার এর মাধ্যমে এই চুক্তির শর্তাদি এবং প্রোগ্রাম, নির্দেশিকাগুলি এবং সময়ে সময়ে পিপল লিঙ্কের দ্বারা নির্ধারিত অন্য যে কোনও অনুরোধ এবং বিধি সম্মত হয় এবং তাতে সম্মত হয় প্রোগ্রামে অংশীদারের চলমান অংশগ্রহণ এবং পিপল লিঙ্ক পণ্যগুলির প্রচার, সমাধান এবং রেফারেলগুলিতে পরিষেবা প্রচারের ক্ষেত্রে এর যুক্তিসঙ্গত বিচক্ষণতা। এই চুক্তির অধীনে এর সমস্ত ক্রিয়াকলাপে এবং পিপল লিঙ্কের অংশীদার প্রচারের সাথে সম্পর্কিত এই জাতীয় ক্রিয়াকলাপে অংশীদার লোকজনকে লিংককে সহযোগিতা করবে এবং সৎ বিশ্বাসের সাথে কাজ করবে। এই চুক্তিতে প্রবেশ করে অংশীদার পিপললিংক এর পরিষেবার শর্তাদিতে নির্ধারিত শর্তাদি এবং বিধিগুলি স্বীকৃতি দেয় এবং স্বীকার করে",
        "aff_str12_para" : "অংশীদারি লাইসেন্সকৃত মার্কস এবং বিপণন উপকরণগুলি ব্যবহার করে বিভিন্ন বিপণন চ্যানেলগুলিতে পিপললিঙ্ক পণ্যগুলি এবং সমাধানগুলির ক্রমাগত, সক্রিয় প্রচারে জড়িত হতে সম্মত হন এবং এই চুক্তির শর্তাবলী মেনে চলেন",
        "aff_str13_para" : 'অংশীদার বিপণন উপকরণকে এমন কোনও সামগ্রীর সাথে সংযুক্ত না করতে সম্মত হন যা কোনওভাবেই বেআইনী, বা যা অন্যথায় ক্ষতিকারক, হুমকী, মানহানি, অশ্লীল, আপত্তিকর, হয়রানিমূলক, যৌন স্পষ্ট, হিংসাত্মক, বৈষম্যমূলক বা অন্যথায় আপত্তিজনক পিপললিঙ্ক এর বিচক্ষণ বিবেচনা করে। অংশীদাররা পিপললিঙ্ক পরিষেবাদি এবং সমাধানগুলিতে প্রচার করার ক্ষেত্রে একাধিক সম্পর্কহীন প্রাপককে ("স্প্যামিং") বা অবৈধভাবে ইলেক্ট্রনিক বার্তাগুলি না পাঠাতে সম্মত হন বা অন্যথায় এই চুক্তির অধীন বিবেচিত ক্রিয়াকলাপগুলির সাথে আইন দ্বারা নিষিদ্ধ গণ ইলেকট্রনিক যোগাযোগের অন্য কোনও প্রকারে জড়িত না হতে সম্মত হন।',
        "aff_str14_para1" : "অংশীদার লাইসেন্সপ্রাপ্ত চিহ্নগুলি ব্যবহার এবং বিপণন সামগ্রী তৈরিতে এখানে সমস্ত শর্তাবলী স্পষ্টভাবে সম্মতিতে সম্মত হয়।",
        "aff_str14_para2" : "গাইডলাইনগুলির মাধ্যমে এবং অন্যথায়, পিপললিঙ্ক সময়ে সময়ে বিপণন উপকরণ তৈরি করতে এবং পিপললিঙ্ক পরিষেবা প্রচারের জন্য লাইসেন্সকৃত অনুমোদিত মার্কগুলির ব্যবহারযোগ্য অংশীদারদের অনুমতি অনুসারে নির্দিষ্টকরণ এবং অন্যান্য নির্দেশাবলী সরবরাহ করবে। অংশীদার আরও এই জাতীয় স্পেসিফিকেশন এবং নির্দেশাবলী মেনে চলতে সম্মত।",
        "aff_str14_para3" : "অংশীদার নিশ্চিত করবে যে তার লাইসেন্সিং সামগ্রীতে উপস্থিত সমস্ত লাইসেন্সকৃত মার্কস নির্দেশিকাগুলিতে বা অন্যথায় পিপললিঙ্কের অনুমোদিত ফর্মে রয়েছে, কোনও পিপললিঙ্ক মার্কস সংশোধন করবে না অন্যথায় পিপললিঙ্কের সরবরাহিত যুক্তিসঙ্গত নির্দেশনার বিপরীতে অন্য বিপণন উপকরণগুলিকে যথেষ্ট পরিমাণে সংশোধন করবে না এবং আরও মেনে চলবে বিপণন সামগ্রীর ফর্ম, সামগ্রী এবং প্রদর্শন সম্পর্কে পিপল লিঙ্কের যুক্তিসঙ্গত নির্দেশাবলী সহ যে কোনও কারণে এই চুক্তিটি সমাপ্ত হওয়ার পরে, বা পিপল লিঙ্কের লিখিত অনুরোধে, এখানে প্রদত্ত লাইসেন্সটির মেয়াদ শেষ হবে এবং অংশীদার অবিলম্বে এই চুক্তির অধীনে তার সমস্ত কার্যক্রম বন্ধ করে দেবে।",
        "aff_str15_para" : "অংশীদার এই চুক্তির অধীনে আইন পরিচালনার জন্য তার পরিচালনার জন্য সম্পূর্ণ দায়বদ্ধ থাকবে, অংশীদারের ক্রিয়াকলাপ এবং উপকরণগুলির বৈধতা সহ, এই চুক্তির সাথে সম্পর্কিত এবং ব্যবহৃত হয়েছে সহ পিপল লিঙ্ক মার্ক কোনও তৃতীয় পক্ষের ট্রেডমার্ক অধিকার লঙ্ঘন করেছে এমন অভিযোগ ব্যতীত, অংশীদার বিপণন সামগ্রীর বিকাশ, পরিচালনা বা সামগ্রীর জন্য পিপললিঙ্ক দায়বদ্ধ নয় এবং অংশীদার কোনও দাবি, কর্ম, কারণগুলির বিরুদ্ধে পিপল লিঙ্ককে ক্ষতিকারক, ক্ষতিপূরণ প্রদান ও ধরে রাখতে সম্মত হয় পিপললিঙ্ক অংশীদারের বিপণন সামগ্রীর বিকাশ, পরিচালনা, সামগ্রী এবং রক্ষণাবেক্ষণ সম্পর্কিত ক্রিয়া, ক্ষতি বা ব্যয় (অ্যাটর্নি ফি সহ)",
        "aff_str16_para" : "এই মেয়াদ চলাকালীন এবং তার পরে, পিপললিঙ্ক এবং রেফারালদের মধ্যে অংশীদার হয়ে পিপলিংক পরিষেবা সম্পর্কিত যে সমস্ত এবং সমস্ত তথ্য পিপলিংক পরিষেবা ব্যবহারের জন্য পিপলিংকের সাথে চুক্তি করে এমন সমস্ত তথ্য সম্পর্কিত একচেটিয়া মালিক হবে। পিপল লিঙ্ক পরিষেবার জন্য শর্তাদি, গোপনীয়তা নীতি, এবং পিপল লিঙ্কের বিধি ও পদ্ধতিগুলি এই রেফারেলগুলিতে প্রযোজ্য এবং অংশীদারের পূর্ব নোটিশ ছাড়াই পিপলিংক দ্বারা পরিবর্তন করা যেতে পারে এবং অংশীদার শর্তাদির অধীনে পিপল লিঙ্কের সাথে তাদের সম্পর্কের প্রকৃতির রেফারেলগুলি জানাতে সম্মত হয়।",
        "aff_str20_para1" : "অংশীদার দ্বারা পিপললিংকের কাছে উল্লেখ করা হয়েছে এবং যারা নীচে বিভাগ 3 (খ) এ বর্ণিত পদ্ধতি অনুসারে সাইন-আপ পদ্ধতি সম্পূর্ণ করেছেন;",
        "aff_str20_para2" : "পিপল লিঙ্কের সাথে পিপললিংকের কোনও রেকর্ড নেই, বা অংশীদারি দ্বারা পিপল লিঙ্কের সময়ে লিখিত নেই, যারা পিপললিঙ্ক সার্ভিসের সাথে কোনও চুক্তিমূলক সম্পর্ক বা পিপললিঙ্কের সাথে চলমান আলোচনার ক্ষেত্রে;",
        "aff_str20_para3" : "যারা শর্তাদি গ্রহণ করে এবং রেফারেলের নিজস্ব বিবেচনার ভিত্তিতে এবং অংশীদারের কাছ থেকে কোনও আর্থিক বা অন্য কোন উত্সাহ গ্রহণ না করে, পিপললিঙ্ক ওয়েবসাইটগুলিতে তালিকাভুক্ত নিম্নলিখিত পিপললিঙ্ক পরিষেবা পরিকল্পনার বান্ডেলের কমপক্ষে বার্ষিক সাবস্ক্রিপশন বা অন্যথায় (iv) যারা প্রত্যাখ্যানিত নয় পিপললিঙ্ক, এবং পিপল লিঙ্ক পরিষেবা পাওয়ার জন্য কমপক্ষে একটি অর্থ প্রদান (বার্ষিক প্রিপেই) বা তিনটি প্রদান (বার্ষিক মেয়াদ, মাসিক বিলিং) করুন।",
        "aff_str21" : "সুপারিশ পদ্ধতি",
        "aff_str22" : "কমিশন। দায়িত্ব।",
        "aff_str221" : "অর্পন করার মূল্য.",
        "aff_str222" : "একটি সুপারিশ থেকে চলমান বিক্রয়",
        "aff_str223" : "সংযুক্ত চার্জ।",
        "aff_str23" : "বিক্রয় / কমিশন রিপোর্ট।",
        "aff_str21_para" : "অংশীদারকে পিপল লিঙ্ক সরবরাহকারী একটি অনলাইন ইউআরএলের মাধ্যমে প্রতিটি রেফারালকে অংশীদার দ্বারা পিপল লিঙ্কে প্রেরণ করা হবে, বিক্রয় সম্পর্কিত রেফারেল প্রচারের পক্ষে পক্ষের অব্যাহত বিশ্বাস-বিশ্বাসের সাপেক্ষে, পিপললিঙ্ক সকল রেফারেলগুলিতে বিক্রয় প্রক্রিয়াটির জন্য দায়বদ্ধ থাকবে।",
        "aff_str22_para" : "পিপল লিঙ্ক সরাসরি রেফারেল থেকে পিপল লিঙ্ক পরিষেবার জন্য রেফারাল থেকে সমস্ত ফি সংগ্রহ করবে ",
        "aff_str22_para1" : "যোগ্য রেফারেল হয়ে যাওয়ার পরে, পিপললিঙ্ক বি তে অবস্থিত তালিকাভুক্ত ফিসের ভিত্তিতে বকেয়া অংশীদার রেফারেল ফি প্রদান করবে ",
        "aff_str22_para12" : "(কোনও ছাড় বাদে) যোগ্য রেফারেল দ্বারা প্রদেয়। এই জাতীয় রেফারেল ফিগুলি প্রদেয় হয়ে যায় এবং প্রদেয় পরিষেবা শুরুর তারিখের নব্বই (90) দিনের মধ্যে অংশীদারকে প্রদান করা প্রদেয় পেমেন্ট বাধ্যবাধকতা অর্জিত হয়।",
        "aff_str22_para2" : "- অংশীদার রেফারেল প্রারম্ভিকভাবে জমা দেওয়ার তারিখের প্রথম 90 দিনের মধ্যে হওয়া কোনও যোগ্য রেফারেল থেকে অতিরিক্ত বিক্রয়ের জন্য রেফারেল ফি গ্রহণ করবে।",
        "aff_str22_para3" : "বি অংশীদার রেফারেল ফিগুলিতে আরোপিত সমস্ত কর, শুল্ক, সরকারী চার্জ এবং এই জাতীয় চার্জের অর্থ প্রদানের জন্য দায়বদ্ধ এবং অংশীদার পিপললিঙ্কের উদ্ভূত সমস্ত অভিযোগের ক্ষেত্রে উত্থাপিত বা দাবী করা বা দাবী করা বা দায়িত্বে থাকা লোকসমাজকে ক্ষতিপূরণ, সুরক্ষা এবং ধরে রাখবে রেফারেল ফি প্রদান।",
        "aff_str23_para" : "পিপললিঙ্ক অংশীদারকে তাদের অনলাইন ড্যাশবোর্ড প্রতিবেদনে রেফারেলগুলি থেকে প্রাপ্ত যোগ্য রেফারেলগুলির জন্য অংশীদার এবং এর কমিশনের বিক্রয় কার্যক্রমের সংক্ষিপ্ত বিবরণ প্রদান করবে। পিপললিঙ্ক রেফারেল এবং যোগ্য রেফারেল সম্পর্কে নাম বা অন্যান্য ব্যক্তিগত তথ্য প্রকাশ করবে না।",
        "aff_str31" : "প্রাথমিক শর্ত.",
        "aff_str32" : "নবায়ন মেয়াদ",
        "aff_str33" : "প্রারম্ভিক সমাপ্তি। কারণ ছাড়া।",
        "aff_str34" : "কারণ জন্য।",
        "aff_str35" : "সমাপ্তির প্রভাব।",
        "aff_str31_para" : 'এই চুক্তি কার্যকর তারিখ হিসাবে কার্যকর হয়ে যাবে এবং তারপরে বারো (12) মাস অবধি চলবে ("প্রাথমিক মেয়াদ"), যদি না পিপললিঙ্ক অংশীদারদের প্রোগ্রামে অংশ নিতে আবেদন প্রত্যাখ্যান করে',
        "aff_str32_para" : 'প্রাথমিক মেয়াদ শেষ হওয়ার পরে, এই চুক্তিটি বারো (12) মাসের (প্রতিটি "পুনর্নবীকরণের মেয়াদ") অতিরিক্ত টানা শর্তের জন্য স্বয়ংক্রিয়ভাবে পুনর্নবীকরণ করা হবে, যদি না কোনও পক্ষ অন্য পক্ষকে কমপক্ষে তিরিশ (30) সমাপ্তির লিখিত নোটিশ না দেয় ) প্রাথমিক মেয়াদ বা কোনও পুনর্নবীকরণ মেয়াদ শেষ হওয়ার কয়েক দিন আগে।',
        "aff_str33_para" : "পিপললিঙ্কের অংশীদারকে পাঁচ (৫) দিন পূর্বের লিখিত নোটিশ দিয়ে যে কোনও কারণে বা বিনা কারণে যে কোনও সময় এই চুক্তিটি সমাপ্ত করার অধিকার থাকবে।",
        "aff_str34_para" : "যে কোনও পক্ষই এই চুক্তিটি যে কোনও সময়ে বাতিল করতে পারে, তত্ক্ষণাত অন্য পক্ষের যারা এই চুক্তিটি বস্তুগতভাবে লঙ্ঘন করেছে তাদের লিখিত নোটিশের পরে কার্যকরভাবে শর্ত দেওয়া হয়েছে যে এই চুক্তিটি সমাপ্ত করার আগে টার্মিনেটিং পার্টি এই ধরনের উপাদান লঙ্ঘন এবং ত্রিশ (৩০) দিনের লিখিত নোটিশ প্রদান করবে লঙ্ঘনকারী পক্ষের জন্য এ জাতীয় লঙ্ঘন নিরাময়ের সুযোগ।",
        "aff_str35_para" : "এই চুক্তিটি সমাপ্ত হওয়ার তারিখ থেকে এবং তারপরে এই চুক্তির অধীনে অংশীদারের অধিকার সমাপ্ত হবে এবং অংশীদার এই চুক্তির সমাপ্তির পূর্বে অর্জিত কমিশন বা অর্জিত অর্থ ব্যতীত এই চুক্তির অধীনে কোনও রেফারাল ফি বা অন্য কোনও অর্থ প্রদানের অধিকারী হবে না ।",
        "aff_str41" : "অ্যাসাইনমেন্ট।",
        "aff_str42" : "মেধা সম্পত্তি অধিকার.",
        "aff_str43" : "নিস্কৃতি নাই.",
        "aff_str44" : "ওয়ারেন্টি সীমিত.",
        "aff_str45" : "ওয়ারেন্টি অস্বীকৃতি।",
        "aff_str46" : "দায়বদ্ধতা সীমাবদ্ধতা.",
        "aff_str47" : "স্বাধীন ঠিকাদার.",
        "aff_str48" : "অনাক্রম্যতা।",
        "aff_str49" : "মজুরি জোর করুন।",
        "aff_str410" : "সামগ্রিক চুক্তিনামা; গুরুত্ব।",
        "aff_str411" : "প্রতিরূপ; নোটিশ।",
        "aff_str412" : "সরকারি আইন; এখতিয়ার; বিরোধ নিষ্পত্তি.",
        "aff_str41_para" : "পিপল লিঙ্ক যে কোনও সময় এই চুক্তিটি বরাদ্দ করতে পারে। অংশীদাররা পিপললিঙ্কের পূর্ব লিখিত সম্মতি ব্যতিরেকে এই চুক্তিটি অর্পণ বা স্থানান্তর করতে পারে না, যেমন সম্মতিটি অযৌক্তিকভাবে আটকাতে হবে না।",
        "aff_str42_para" : "পিপললিঙ্ক মার্কসের সমস্ত বৌদ্ধিক সম্পত্তি অধিকার (যেমন ট্রেডমার্ক, ব্যবসার নাম, লোগো, পেটেন্টস, কপিরাইটস, ডোমেন নাম এবং ডেরাইভেটিভ রাইটস সীমাবদ্ধ নয়)), পিপললিঙ্ক পরিষেবা এবং বিশ্বজুড়ে সম্পর্কিত সামগ্রী এবং প্রযুক্তি (পিপল লিঙ্ক আইপি রাইটস) এবং পিপললিঙ্ক এবং এর সহায়ক সংস্থাগুলির একচেটিয়া সম্পত্তি থাকবে। অংশীদারের লাইসেন্সকৃত চিহ্নগুলি ব্যবহার করার অধিকারটি পিপল লিঙ্কের বিবেচনার ভিত্তিতে এবং এই চুক্তির শর্তাদি, নির্দেশিকাগুলি এবং সমস্ত প্রযোজ্য আইন ও বিধিবিধানের সাথে অংশীদারের সম্মতিতে সাপেক্ষে। অংশীদার সম্মত হন (ক) এই চুক্তি লঙ্ঘনের মতো কোনওভাবেই পিপললিংকের আইপি অধিকারগুলি ব্যবহার করবেন না; (খ) পিপল লিঙ্কের আইপি অধিকারের প্রতিদ্বন্দ্বিতা বা ক্ষতিগ্রস্থ করার জন্য কিছু করবেন না; (গ) কোনও বৌদ্ধিক সম্পত্তি অধিকার (যেমন ট্রেডমার্ক, ব্যবসার নাম, লোগো, পেটেন্টস, কপিরাইটস, ডোমেন নাম এবং ডেরাইভেটিভ রাইটস এর মধ্যে সীমাবদ্ধ নয়) তৈরি বা অর্জন না করা যা কোনও পিপললিঙ্ক আইপি রাইটস এর সাথে যথেষ্ট মিল; (ঘ) অংশীদারের প্রকৃত জ্ঞান রয়েছে এমন কোনও পিপল লিঙ্ক আইপি অধিকারের অননুমোদিত ব্যবহারের বিষয়ে অবিলম্বে পিপল লিঙ্ককে অবহিত করুন; এবং (ঙ) গাইডলাইনগুলির সাথে সম্মতিতে সর্বদা লাইসেন্সযুক্ত মার্কস এবং অন্য কোনও পিপললিঙ্ক চিহ্ন ব্যবহার করুন। পিপললিঙ্ক অংশীদার দ্বারা উপস্থাপিত যে কোনও বিপণন সামগ্রীর পর্যায় পর্যালোচনা সম্পাদন করতে পারে এবং অংশীদার দ্বারা উপস্থাপিত যে কোনও বিপণন উপকরণগুলি অপসারণ এবং / বা সংশোধন করার আদেশ দেওয়ার একচেটিয়া কর্তৃত্ব এবং বিচক্ষণতা থাকতে পারে।",
        "aff_str43_para" : "অন্যথায় পার্টির এই চুক্তির যে কোনও বিধানের কঠোর কার্যকারিতা কার্যকর করার ক্ষেত্রে পার্টির ব্যর্থতা পরবর্তীকালে এই চুক্তির বিধান বা অন্য কোনও বিধান কার্যকর করার জন্য প্রথম পক্ষের অধিকারকে মওকুফ করবে না।",
        "aff_str44_para" : "উভয় পক্ষই ওয়ারেন্ট দেয় যে এই মেয়াদ চলাকালীন সময়ে সর্বদা তারা প্রযোজ্য সমস্ত আইন, বিধিবিধান, অনুশীলনের কোড এবং সেই সাথে এই চুক্তি, শর্তাদি, গোপনীয়তা নীতি এবং গাইডলাইনগুলি মেনে চলবে। টার্মটি এবং যেকোন কারণে এটির সমাপ্তির পরে, অংশীদার স্পষ্টত এমন কিছু না করার জন্য প্রতিশ্রুতি দেয় যেটি পিপল লিঙ্কের ব্যবসায়, আগ্রহ বা সুনামের ক্ষতি হতে পারে এবং কোনও বিতর্কিত মন্তব্য করতে বা প্রকাশ করতে বা প্রকাশ করতে দেবে না পিপল লিঙ্ক, এর প্রতিনিধি বা পিপললিঙ্ক পরিষেবা সম্পর্কিত।",
        "aff_str45_para" : "পূর্ববর্তী উপধারা (ঙ) এর অধীনে পিপললিংকের এক্সপ্রেস ওয়্যারেন্টি ব্যতীত, পিপললিঙ্ক কোনও প্রকারের অন্য কোনও ওয়্যারেন্টি, এক্সপ্রেস বা ইমপ্লাইড করে না এবং পিপললিঙ্ক স্পষ্টভাবে কোনও ওয়ারেন্টি এবং শর্তাদির অস্বীকৃতি জানায়, তবে কোনও নির্দিষ্ট ব্যবসায়ের জন্য কোনও ফিটনেস নির্ভরযোগ্য ওয়্যারেন্টি সীমাবদ্ধ নয় উদ্দেশ্য, প্রাপ্যতা, সুরক্ষা, শিরোনাম এবং / বা এই চুক্তির বিষয়টির অ লঙ্ঘন।",
        "aff_str46_para" : "পিপললিঙ্ক বা কোনও কর্মকর্তা, কর্মচারী, পরিচালক বা পিপললিঙ্কের কোনও প্রতিনিধি অংশীদার বা তৃতীয় পক্ষের পক্ষে, এই চুক্তি বা এর সমাপ্তির সাথে চুক্তিতে, পূর্ব-চুক্তিতে, নির্যাতনে বা অন্যথায় দায়বদ্ধ থাকবে না (i ) যে কোনও অর্থনৈতিক ক্ষতি (রাজস্ব ক্ষতি, লাভ, চুক্তি, ব্যবসা বা প্রত্যাশিত সঞ্চয় সহ) বা (ii) সদিচ্ছার বা সুনামের কোনও ক্ষতি। এই ধরনের ক্ষতির মধ্যে রয়েছে সীমাবদ্ধতা ছাড়াই, কোনও বিশেষ, অপ্রত্যক্ষ, ঘটনামূলক, বিধিবদ্ধ, দণ্ডিত বা ফলস্বরূপ ক্ষতি বা ক্ষতির পাশাপাশি অপারেশনে বাধাগ্রস্থ হওয়ার কারণে যে কোনও লোকসান বা ক্ষয়ক্ষতি রয়েছে। দলগুলোর মধ্যে যে কোনও সম্পর্ক বা পার্শ্ববর্তী যে কোনও পরিস্থিতি বা বোঝাপড়া সত্ত্বেও, এই চুক্তির অধীনে অংশীদারের জন্য পিপললিংকের সম্পূর্ণ দায় এই চুক্তির অধীনে অংশীদার দ্বারা যে কোনও ধরণের ক্ষতির জন্য এবং সমস্ত দাবির জন্য আইএনআর (কেবল এক হাজার টাকা) ছাড়িয়ে যাবে না এবং এই চুক্তিতে প্রবেশ করে অংশীদার এখানে পিপললিঙ্কের দায়বদ্ধতার সীমাবদ্ধতাগুলি স্বীকৃতি দেয়।",
        "aff_str47_para" : "দলগুলি স্বতন্ত্র ঠিকাদার হিসাবে তাদের পক্ষে কাজ করে। এই চুক্তির কোনও কিছুই এই চুক্তিতে বর্ণিত সম্পর্কের বাইরে পার্টির মধ্যে কোনও যৌথ উদ্যোগ, সংস্থা, ভোটাধিকার, বিক্রয় প্রতিনিধি, কর্মসংস্থান বা অন্য কোনও সম্পর্ক তৈরি করতে পারবে না, এবং অংশীদারকে স্পষ্টতই পিপললিঙ্কের পক্ষে কাজ করা থেকে বিরত রাখা হবে। এই চুক্তির আওতায় অংশীদার লাইসেন্সপ্রাপ্ত চিহ্নগুলির প্রদর্শন, অংশীদার দ্বারা উপস্থাপিত অন্যান্য সামগ্রী, বা অংশীদার এবং তৃতীয় পক্ষের মধ্যে যোগাযোগ এখানে বর্ণিত সম্পর্কের ভুল উপস্থাপনা করবে না।",
        "aff_str48_para" : 'অংশীদার যে কোনও ফলাফল, দায়বদ্ধতা, ক্ষতি এবং ব্যয় (যুক্তিসঙ্গত অ্যাটর্নি ফি সহ অন্তর্ভুক্ত তবে সীমাবদ্ধ নয়) এর ক্ষতি হতে পারে এবং ক্ষতিপূরণ ছাড়াই পিপল লিঙ্ক এবং এর সহযোগী সংস্থাগুলি, অনুমোদিত, কর্মকর্তা ও কর্মচারীদের ("পিপল লিঙ্ক ইন্ডিমনাইফাইড পার্টিস") ক্ষতিপূরণ, সংরক্ষণ এবং ধরে রাখবে নিম্নলিখিত যে কোনওটি থেকে উদ্ভূত পিপল লিঙ্ক অনাদায়ী দলগুলির বিরুদ্ধে যে কোনও তৃতীয় পক্ষের দ্বারা আনা, মামলা, পদক্ষেপ, দাবি বা কার্যধারা: (i) অংশীদার দ্বারা চুক্তি লঙ্ঘন; (ii) অংশীদার বা এর কর্মচারী, এজেন্ট বা ঠিকাদারদের অবহেলা, স্থূল অবহেলা বা ইচ্ছাকৃত দুর্বৃত্তি; বা (iii) অংশীদার বা এর কর্মচারী, এজেন্ট, ঠিকাদার বা এখানে বর্ণিত আইন ও বিধিমালা মেনে চলার জন্য আমন্ত্রিতকারীদের ব্যর্থতা।',
        "aff_str49_para" : 'কোনও পক্ষ বাধ্যতামূলক পরিস্থিতি দ্বারা এটিকে করা থেকে বিরত রাখলে এখানে তার কোনও বাধ্যবাধকতা পালন করতে বাধ্য থাকবে না। "ফোর্স ম্যাজিউর" ইভেন্টগুলিতে পার্টির যুক্তিসঙ্গত নিয়ন্ত্রণের বাইরে অনুষ্ঠানের অন্তর্ভুক্ত থাকবে, ঈশ্বরের কাজ, সরকার, প্রকৃতির কাজ, ধর্মঘট বা দাঙ্গা, পাশাপাশি পিপললিংক সরবরাহকারী বা বস্তু, উপকরণ বা সফ্টওয়্যারগুলির ত্রুটিগুলি তৃতীয় পক্ষগুলি। বল প্রয়োগের পরিস্থিতি যদি ত্রিশ (৩০) দিনের বেশি স্থায়ী হয় তবে অন্য পক্ষকে লিখিত নোটিশ দেওয়ার পরে যে কোনও পক্ষই এই চুক্তিটি বাতিল করতে পারে।',
        "aff_str410_para" : "এই চুক্তিটি এর সাথে সম্পর্কিত পার্টির মধ্যে সম্পূর্ণ চুক্তির প্রতিনিধিত্ব করে এবং এতে পার্টির সংশ্লিষ্ট দায়িত্ব এবং প্রতিশ্রুতি রয়েছে। দলগুলির মধ্যে অন্য কোনও নথি বা মৌখিক বা লিখিত চুক্তিগুলি এই চুক্তিতে বর্ণিত চুক্তির উপর কোনওভাবেই প্রতিফলিত হয় না এবং উভয় পক্ষের দ্বারা সম্পাদিত একটি লিখন ব্যতীত এই চুক্তিটি সংশোধন করা যাবে না। । যখনই সম্ভব, এই চুক্তির প্রতিটি বিধানটি কার্যকরভাবে প্রয়োগযোগ্য আইনের অধীনে কার্যকর এবং বৈধ হতে এমনভাবে ব্যাখ্যা করা হবে, তবে এই চুক্তির কোনও বিধান যদি প্রযোজ্য আইনের অধীনে নিষিদ্ধ বা অবৈধ হয়ে থাকে তবে এই বিধানটি কেবলমাত্র অকার্যকর হবে এই ধরনের নিষেধাজ্ঞার বা অবৈধতার পরিমাণ, এই বিধানের বাকী বা এই চুক্তির বাকী বিধানগুলিকে অবৈধ না করে।",
        "aff_str411_para" : "এই চুক্তিটি প্রতিপক্ষগুলিতে স্বাক্ষরিত হতে পারে এবং এ জাতীয় অংশগুলি বৈধ এবং বাধ্যতামূলক হবে পার্টির পক্ষে একই প্রভাবের সাথে যেমন আসল স্বাক্ষরগুলি বিনিময় করা হয়েছে।",
        "aff_str412_para" : "এই চুক্তি আইন বিরোধের কোনও নীতি কার্যকর না করেই ভারতের হায়দরাবাদ, তেলেঙ্গানার এখতিয়ার আইন দ্বারা পরিচালিত হবে। এখতিয়ারটি ভারতের তেলঙ্গানার হায়দরাবাদ জেলা আদালতে একচেটিয়াভাবে থাকবে। এই চুক্তির ফলে উত্থাপিত যে কোনও মামলা মোকদ্দমার জন্য একমাত্র এবং একচেটিয়া এখতিয়ার এবং স্থান হ'ল হায়দ্রাবাদ, তেলেঙ্গানার, এবং পার্টির একটি উপযুক্ত জেলা বা রাজ্য আদালত হতে হবে এবং উত্থাপনের ভিত্তিতে কোনও আপত্তি বা প্রতিরক্ষা ছাড় না দেওয়ার পক্ষে পক্ষগুলি সম্মত হয় বা ফোরাম অ সুবিধা। এই চুক্তির অধীনে বা সম্পর্কিত যে কোনও আইনী পদক্ষেপ গ্রহণের আগে একটি পক্ষ অন্য পক্ষকে বিরোধের লিখিত নোটিশ সরবরাহ করবে এবং পক্ষগুলি ত্রিশ (৩০) এর মধ্যে এ জাতীয় বিরোধের দ্রুত সমাধানের লক্ষ্যে সক্রিয়ভাবে এবং সৎ বিশ্বাসের সাথে আলোচনা করবে এই জাতীয় নোটিশ প্রাপ্তির ব্যবসায়ের দিনগুলি।",
        "aff_str40" : "চুক্তির পরিবর্তন।",
        "aff_str40_para" : "পিপললিঙ্ক এই চুক্তিটি সময়ে সময়ে তার যুক্তিসঙ্গত বিবেচনার ভিত্তিতে সাইটে পরিবর্তন পোস্ট করতে পারে (atB www.peoplelinkvc.com/affiliatestermsofservice) বা ইমেলের মাধ্যমে অংশীদারকে অবহিত করে। যদি অংশীদার এই জাতীয় কোনও পরিবর্তনে আপত্তি জানায়, অংশীদার কারণ হিসাবে এই চুক্তিটি বাতিল করতে পারে। এই চুক্তিতে পরিবর্তন সম্পর্কে নোটিশ প্রাপ্তির পরে প্রোগ্রামে অংশীদারের অব্যাহত অংশগ্রহণ সংশোধিত হিসাবে এই চুক্তির বাধ্যতামূলক গ্রহণযোগ্যতা গঠন করবে।",
        "qualified_ref" : "যোগ্য প্রচার",
        "mean_referrals" : "রেফারেলগুলি বোঝায়",
        "apply" :"প্রয়োগ করা",
        "company_code_validate" : "যাচাই করার জন্য দয়া করে সংস্থার কোডটি প্রবেশ করুন",
        "golive_company_code" : "গো-লাইভ কোম্পানির কোড",
        "accept_TC" : "আমি উপরের শর্তাবলী স্বীকার করি",
        "by_sub_referral" : "সুপারিশ অংশীদার অ্যাপ্লিকেশন জমা দেওয়ার মাধ্যমে, অংশীদার এটি প্রতিনিধিত্ব করে এবং ওয়ারেন্ট দেয় যে এটি এই চুক্তিটি পড়েছে, বোঝে এবং গ্রহণ করে।",
        "term" : "শর্তাবলী",
        "found_at" : "পাওয়া গেছে",
        "our_privacy_policy" : "এবং আমাদের গোপনীয়তা নীতি",
        "privacy_policy" : "গোপনীয়তা নীতি",
        "as_applicable" : "প্রযোজ্য.",
        "screen-sharing" : "স্ক্রিন ভাগ করে নেওয়া",
        "whiteboard_access" : "হোয়াইটবোর্ড অ্যাক্সেস",
        "Document_access" : "দস্তাবেজ অ্যাক্সেস",
        "share_the_screen" : "পর্দা ভাগ!",
        "to_collaborate" : "সহযোগীতা করতে!",
        "share_document" : "দলিল ভাগ!",

        "exit_or_end" : "Exit or End Meeting?",
        "exit_from_meeting" : "Exit from Meeting?",
        "are_sure_exit_meeting_everyone" : "Are you sure you want to exit from the meeting? You can either end the meeting for everyone or you can exit from the meeting.",
        "are_sure_exit_meeting" : "Are you sure you want to exit from the meeting?",
        "exit_meeting" : "Exit Meeting",
        "end_for_all" : "End Meeting for all",
        "end_meeting" : "End Meeting",
        "will_let_alone_exit" : "will let you alone exit or leave from the meeting.",
        "will_end_for_everyone" : "will end the meeting for everyone in the conference (All participants & attendees).",
        "user_already_exists" : "Users Already Exists",
        "already_user_avail" : "There are already some users available in the conference. ",
        "if_like_continue" : "If you would like to continue click on ",
        "force_start_meetinh" : "Force Start Another Meeting ",
        "otherwise_click" : "otherwise click on ",
        "to_go_back" : "to go back. ",

        //New by Keerthi - 17th Sep 2020
        "lang_settings" : "Language Settings",
        "lang_info" : "Choose your preferred language to use the application.",
        "select_language" : "Select Language",
        "settings_languages" : "Languages",

        "rec_plugin" : "Recording Plugin",
        "rec_heading1" : "How to install and manage InstaVC Screen-Video Recorder with the plugin",
        "rec_step1" : "Step 1: Copy & open Link in Chrome",
        "rec_step1_para" : "First copy the link ",
        "rec_step1_para_br" : "from here and open it in chrome to add the plugin to your browser. Click on ",
        "rec_step1_para_bold" : "Add to Chrome",
        "rec_step1_para_ct" : "to add this extension.",

        "rec_step2" : "Step 2: Pop Up for Permission",
        "rec_step2_para_br" : "When you click on Add to chrome, here appears a popup asking for permission to display notification access your content. Click on ",
        "rec_step2_para_bold" : "Add Extension",
        "rec_step2_para_ct" : "to proceed.",

        "rec_step3" : "Step 3: Extension Added to Chrome",
        "rec_step3_para" : "When the extension is added to chrome, it shows a window giving you an information with a plugin icon and how to manage this plugin from here.",

        "rec_step4" : "Step 4: Pin the plugin on the toolbar",
        "rec_step4_para_br" : "To pin the plugin to your toolbar, you need to click on manage extensions, go to ",
        "rec_step4_para_bold" : "InstaVC Screen-Recording",
        "rec_step4_para_ct" : "and click on the pin icon to add.",

        "rec_step5" : "Step 5: Extension/Plugin Pinned to Toolbar",
        "rec_step5_para" : "Once the extension is pinned, you can now see an instavc recording icon in your browser toolbar and start using it for easy access." ,

        "rec_step6" : "Step 6: InstVC Recorder Setup",
        "rec_step6_para_br" : "Once you have installed the plugin and the next time when you open it, you can now see the ",
        "rec_step6_para_bold" : "InstaVC Recorder Setup",
        "rec_step6_para_ct" : "page to enable or disable the recording tools. By default both the options will be enabled. Click on ",
        "rec_step6_para_bold1" : "Next",
        "rec_step6_para_ct1" : "to continue.",

        "rec_step7" : "Step 7: Additional Permissions",
        "rec_step7_para_br" : "Once the Next button is clicked, system will then show you a popup asking for additional permissions to read and change your data. Click ",
        "rec_step7_para_bold" : "Allow",
        "rec_step7_para_ct" : "to continue.",

        "rec_step8" : "Step 8: Permissions Allowed",
        "rec_step8_para" : "After allowing the permission, this page now gets frozen or in a disabled mode from where you can now start exploring recording options now.",

        "rec_heading2" : "Desktop Screen-Recording Plugin",

        "rec_step9" : "Step 9: Desktop Screen-Recording",
        "rec_step9_para_br" : "After allowing all permissions, you can now access recording menus from the plugin extension in your toolbar. Click on it to see further options. Here we have selected ",
        "rec_step9_para_bold" : "Desktop Screen Recording",
        "rec_step9_para_ct" : "and click on the",
        "rec_step9_para_bold1" : "Record",
        "rec_step9_para_ct1" : "button to start.",

        "rec_step9a" : "Step 9(a): Share your Screen Popup",
        "rec_step9a_para_br" : "Now the system shows up this popup asking to select the contents of your screen, whether its an Entire Screen or only application window. Click on the tab which you want to share and click on ",
        "rec_step9a_para_bold" : "Share",
        "rec_step9a_para_ct" : "button and go to that screen which you want to start recording.",

        "rec_step9b" : "Step 9(b): Desktop Screen Recording Started",
        "rec_step9b_para_br" : "The Desktop Screen recording is now started and you can see a blink in the toolbar while its in recording mode. Also, you can see a tab at the bottom showing buttons for ",
        "rec_step9b_para_bold" : "Stop Sharing",
        "rec_step9b_para_ct" : "or",
        "rec_step9b_para_bold1" : "Hide",
        "rec_step9b_para_ct1" : ". You can see the bottom message on any screen you are opening until you are in the desktop screen recording mode.",

        "rec_step9c" : "Step 9(c): Restart / Pause or Stop Desktop Screen Recording",
        "rec_step9c_para_br" : "Once you want to stop Recording. Click on the plugin in the toolbar and here you can see the options to ",
        "rec_step9c_para_bold" : "Restart, Pause",
        "rec_step9c_para_ct" : "and",
        "rec_step9c_para_bold1" : "Stop",
        "rec_step9c_para_ct1" : "buttons. You can click any of those accordingly.",

        "rec_step9d" : "Step 9(d):Recent Recording View",
        "rec_step9d_para_br" : "Once you stop the recording from the toolbar, the recent recording will now automatically open the recording in a new tab along with Title and ",
        "rec_step9d_para_bold" : "Download",
        "rec_step9d_para_ct" : "option in the top and the recording details in the right column.",
        
        "rec_heading3" : "Browser Tab Screen-Recording Plugin",

        "rec_step10" : "Step 10: Browser Tab Screen-Recording",
        "rec_step10_para_br" : "When we want to select ",
        "rec_step10_para_bold" : "Browser Tab",
        "rec_step10_para_ct" : "option for recording your browser screen. First open your screen(url) in chrome whichever you want to record and then open the plugin and click on Browser Tab, adjust microphone options and then click",
        "rec_step10_para_bold1" : "Record",
        "rec_step10_para_ct1" : "button to start recording.",

        "rec_step10a" : "Step 10(a): Browser Tab is being Recorded",
        "rec_step10a_para" : "Once the Browser tab is started recording, you can see a red dot blinking in your toolbar which indicates the tab is being recorded and also a blue box blinking in your browser title bar",
        
        "rec_step10b" : "Step 10(b): Record another tab",
        "rec_step10b_para_br" : "At the time of current screen recording, if you open another url and open the plugin, it will show you the recording status along with an option",
        "rec_step10b_para_bold" : "Record This Tab",
        "rec_step10b_para_ct" : "if you want to change the recording scree to the new url. Meanwhile the blue box blinking in the title bar of the browser indicates the tab that is being recorded at the moment.",

        "rec_step10c" : "Step 10(C): Stop and View recording",
        "rec_step10c_para_br" : "Later, when you stop the recording, the browser itself opens the recording in a new tab along with Title and",
        "rec_step10c_para_bold" : "Download",
        "rec_step10c_para_ct" : "Option at the top and the recording details in the right column.",

        "rec_heading4" : "Webcam Recording",

        "rec_step11" : "Step 11: Start Webcam Screen Recording",
        "rec_step11_para_br" : "When you start with Webcam screen recording, make sure to select the microphone & camera settings among the devices detected by the plugin. and then click on the",
        "rec_step11_para_bold" : "Record",
        "rec_step11_para_ct" : "button to start with.",

        "rec_step11a" : "Step 11(a): Webcam opens Self Video and starts Recording",
        "rec_step11a_para_br" : "The recording opens a web page with yourself video with",
        "rec_step11a_para_bold" : "Pause",
        "rec_step11a_para_ct" : "and",
        "rec_step11a_para_bold1" : "Stop",
        "rec_step11a_para_ct1" : "recording options at the bottom.",

        "rec_step11b" : "Step 11(b): View Webcam Recorded Video",
        "rec_step11b_para" : "When you stop the recording in the previous screen, the browser then opens the recording in a new tab to view and download along with the recording details.",
        
        "rec_heading5" : "Top Menus in Recording Plugin",

        "rec_step12" : "Step 12: Navigation Menus",
        "rec_step12_para_br" : "The plugin has few navigation menus to fetch your data as well as manage different actions related to the plugin. One of them is a",
        "rec_step12_para_bold" : "Hamburger Menu",
        "rec_step12_para_ct" : "Click on it to open.",

        "rec_step12a" : "Step 12(a): Open Hamburger Menu",
        "rec_step12a_para_br" : "On click of",
        "rec_step12a_para_bold" : "Hamburger Menu",
        "rec_step12a_para_ct" : ", you can find 2 tabs named",
        "rec_step12a_para_bold1" : "My Recordings",
        "rec_step12a_para_ct1" : "and",
        "rec_step12a_para_bold2" : "Options",
        "rec_step12a_para_ct2" : "which manages all the data you have been recording and options you have enabled or disabled for that plugin. Click on",
        "rec_step12a_para_bold3" : "My Recordings",
        "rec_step12a_para_ct3" : "to see the videos you have recorded till date.",

        "rec_step12b" : "Step 12(b): Access My Recordings",
        "rec_step12b_para_br" : "There is another way of accessing",
        "rec_step12b_para_bold" : "My Recordings",
        "rec_step12b_para_ct" : ", page from the top menu in the plugin which can be considered as a shortcut to navigate.",
        
        "rec_step12c" : "Step 12(c): My Recordings",
        "rec_step12c_para" : "Here will be the detailed list of videos(recordings) you have recorded till date. Each video contains the date, duration, size of the video along with delete icon in the thumbnail view. When you click on any video it opens the details in the view recording page. Note that all the videos will be stored locally here.",

        "rec_step12d" : "Step 12(d): Delete All recordings",
        "rec_step12d_para_br" : "Looking at My recordings Page, there is a more icon in the top right corner which opens the",
        "rec_step12d_para_bold" : "Delete All",
        "rec_step12d_para_ct" : "option to easily delete all recordings with a single click.",
        
        "rec_step12e" : "Step 12(e): Side Navigation",
        "rec_step12e_para_br" : "Instead of opening the plugin again and change, You can directly navigate to another tab from here using the Hamburger Menu in the top left corner of the page that opens the navigation to navigate to the",
        "rec_step12e_para_bold" : "Options",
        "rec_step12e_para_ct" : "page",

        "rec_heading6" : "Plugin Options",

        "rec_step13" : "Step 13: Plugin Options",
        "rec_step13_para_br" : "On click on Hamburger Menu, you can find another tab named Options which manages all the options you have enabled or disabled for that plugin. Click on",
        "rec_step13_para_bold" : "Options",
        "rec_step13_para_ct" : "to see the options that are enabled for you.",

        "rec_step13a" : "Step 13(a): Recorder Options",
        "rec_step13a_para" : "Recorder Options ask you for various options like video storage, Notifications, Keyboard Shortcuts",

        "rec_step13b" : "Step 13(b): Recorder Options",
        "rec_step13b_para" : "Recorder Options contain various other options like Recording Settings and advanced.",

        "rec_heading7" : "Plugin Notifications",

        "rec_step14" : "Step 14: Plugin Notifications",
        "rec_step14_para" : "On the top navigation part, you can find a bell icon for notifications if any related to instavc screen recording plugin.",

        "rec_step14a" : "Step 14(a): Open Notifications",
        "rec_step14a_para" : "On click on the notification icon, you can find the list of notifications if any or it shows an empty slide in.",

        "rec_heading8" : "Recording Settings",

        "rec_step15" : "Step 15: Settings",
        "rec_step15_para_br" : "Then comes the last navigation menu on the top right corner named",
        "rec_step15_para_bold" : "Settings",
        "rec_step15_para_ct" : "where you can open and manage the recording settings accordingly.",

        "rec_step15a" : "Step 15(a): Advanced Settings Options",
        "rec_step15a_para" : "Here you can adjust the settings based on the Resize tab, Limit resolution and maximum frame rate which are given by plugin.",

        "crteContent_upload_medialist" : "Uploaded Media List",
        "content_upld_desc_txt" : "The files you upload here will be available to users who view content.",
        "content_browse_txt" : "Browse Files to Upload",
        "content_upld_types" : "Files with only .jpg, .jpeg, .png, and .pdf are allowed limiting the max size upto 15MB",
        
        "video_qlty": "ভিডিও এর ধরন",
        "audio_qlty": "অডিও মানের",
        "cntnt_shrng": "সামগ্রী ভাগ করে নেওয়া",
        "fdb_poor": "দরিদ্র",
        "fdb_good": "ভাল",
        "fdb_avg": "গড়",
        "fdb_excellent": "দুর্দান্ত",
        "share_feedback": "আপনার ফিডব্যাকটি ভাগ করুন",
        "ovrl_rating": "সামগ্রিক রেটিং",
        "fdb_cmnts": "আপনার মন্তব্য অত্যন্ত প্রশংসা করা হয়",
        "no_thnks": "না ধন্যবাদ",
        "upload_size_max_15mb": "আপনি সর্বোচ্চ আকারের সীমা 15MB আপলোড করতে পারেন",

        "pastMeeting_feedback" : "মতামত",
        "pastMeeting_comments" : "মন্তব্য",
        
        "microsoft_webplugin" : "মাইক্রোসফ্ট আউটলুক ওয়েব প্লাগইন",
        "microsoft_installable" : "মাইক্রোসফ্ট আউটলুক ইনস্টলযোগ্য প্লাগইন",
        "outlook_installable": "আউটলুক ইনস্টলযোগ্য",
        "customization_installer": "কীভাবে কাস্টমাইজেশন ইনস্টলার অ্যাক্সেস করবেন",
        "plugin_step1" : "পদক্ষেপ 1: ফাইল ডাউনলোড করতে লিঙ্কটি ক্লিক করুন",
        "click_link_download": "ডাউনলোড ফাইল থেকে লিঙ্ক ক্লিক করুন",
        "first_click_link": "প্রথমে নীচের লিঙ্কে ক্লিক করুন",
        "to_download_file": "আপনার সিস্টেমে ফাইলটি ডাউনলোড করতে। তারপরে ইনস্টলেশন শুরু করার জন্য ডাউনলোড করা ফাইলটি খুলুন এবং ক্লিক করুন",
        "install_txt": "ইনস্টল করুন",
        "plugin_step2" : "পদক্ষেপ 2: কাস্টমাইজেশন ইনস্টল করা",
        "plugin_step2_para":"Once you start installing, wait untill the file gets installed and you get a popup showing successfully Installed and then close.",
        "plugin_step3" : "পদক্ষেপ 3: আউটলুক খুলুন এবং মিটিংগুলিতে যান",
        "plugin_step3_para" : "ইনস্টলেশন শেষে, মাইক্রোসফ্ট আউটলুক খুলুন এবং সভাগুলিতে যান।",
        "plugin_step3_para1" : "নতুন ইমেল> সভাগুলিতে যান",
        "plugin_step4" : "পদক্ষেপ 4: খোলা সভা",
        "plugin_step4_para" : "একবার মিটিং উইন্ডো উপরের ট্যাবগুলির তালিকায় খোলার পরে এবং তারপরে আপনি ট্যাবে ক্লিক করতে পারেন",
        "plugin_step4_para1": "পিপলিংক",
        "plugin_step5": "পদক্ষেপ 5: তফসিল সম্মেলন",
        "plugin_step5_para": "পিপলিংকের অধীনে আপনার একটি সাব ট্যাব রয়েছে",
        "plugin_step5_para1": "তফসিল সম্মেলন।",
        "plugin_step5_para2": "এটিতে ক্লিক করুন এবং আপনি উইন্ডোটির ডানদিকে সময়সূচী বিকল্পগুলি দেখতে পাবেন। এখানে আপনি ইনভিসি সূচিগুলি পরিচালনা করতে পারেন।",
        "plugin_step6": "পদক্ষেপ:: পরিচালনা করুন বা কাস্টমাইজ করুন সূচী",
        "plugin_step6_para": "এখানে আপনি ঘরগুলি, সময়গুলির তালিকা অনুসারে সময়সূচিগুলি পরিচালনা বা কাস্টমাইজ করতে পারেন এবং এখান থেকে একটি নতুন সময়সূচি তৈরি করতে পারেন যা আপনাকে ব্রাউজারে এবং পুনরায় দৃষ্টিভঙ্গিতে পুনর্নির্দেশ করে।",
        "plugin_step6_para1": "তফসিলটি ঠিক হয়ে গেলে আপনি ক্লিক করতে পারেন",
        "plugin_step6_para2": "লিংক পেতে",
        "plugin_step7": "লিঙ্ক উত্পন্ন হয়েছে",
        "plugin_step7_para": "তারপরে এখানে মেলটিতে উত্পন্ন এবং রচিত লিঙ্কটি পাওয়া যায় যা আপনি এটি অনলাইনে ভাগ করে নেওয়ার জন্য ব্যবহার করতে বা আরও এগিয়ে যেতে পারেন।"
    }
}